import * as h from "react";
import n, { createContext as er, useRef as ee, useState as x, useLayoutEffect as At, useContext as tr, useEffect as A, useCallback as L, useMemo as Fe, useReducer as Go, useSyncExternalStore as ie, useImperativeHandle as nr } from "react";
import { createStreamSourceGraphNode as or, createAnalyzerGraphNode as ar, createAudioGraph as rr } from "@pexip/media-processor";
import { assert as Xt, lastOr as Jo, isDefined as ir, prig as sr, pipe as cr, getTimeLeft as lr, noop as st } from "@pexip/utils";
import { useTranslation as y, Trans as Z } from "react-i18next";
import { DeniedDevices as W, UserMediaStatus as j, isFallback as dr, isFallbackVideo as mr, isFallbackAudio as ur, isRequestPermissionNeeded as pr, isInitial as hr, isInitialPermissionsNotGranted as Uo, createPreviewStreamController as gr, isRejected as fr, isGrantedOnlyAudio as Er, isGrantedOnlyVideo as qo, isDeviceInUse as vr, areBothGranted as Cr } from "@pexip/media";
import { useAnimationFrame as br, autoHideUIInterfacesStateSignal as yr, isFullscreen as Br, useToggleFullscreen as Xo, usePrevious as kr, useSizeObserver as wr, useWideContainerObserver as xr, useMatchMedia as to, useIsInWindowBottomHalf as Mr, useIsInWindowRightHalf as Ir, useCountDown as Sr } from "@pexip/hooks";
import { notificationToastSignal as ut, ConfirmationModal as Qe, ThemeProvider as Pe, Icon as F, IconTypes as k, Text as N, FontVariant as S, TextLink as pt, useTouchDevice as nn, VideoWrapper as Ko, FullSizeWindow as Wn, CenterLayout as Ln, Audio as Pr, Video as _o, Spinner as $o, Button as D, FullscreenLayout as Nr, Draggable as ea, PopOutWindow as Tr, ProgressBar as ta, ProgressBarColor as na, List as ye, Modal as at, Row as ae, Grid as be, Cell as K, Bar as Xe, Color as Me, TextHeading as Ie, Pill as oa, Avatar as on, AvatarType as Vt, AspectRatio as Fn, Group as Ne, ModalCloseButton as Qn, NotificationTooltip as ot, Tooltip as me, PexipLogo as An, SvgImage as Vn, useMobileDevice as aa, AriaMenu as an, Box as Re, onEnter as Rr, Select as ra, InteractiveElement as rn, CircleCountDown as zr, Accordion as ia, useModalHandle as sa, useMdDown as On, sizeToPadding as jt, useBelow360 as Wr, BadgeCounter as Ot, Form as Lr, TextArea as Fr, useXs as Qr, useFocusFromOpened as Dn, useModal as jn, withColorScheme as Ar, ThemeConsumer as sn, URLToLink as Yn, CoreHeader as Vr, Divider as cn, KebabMenuButton as Or, Menu as Dr, Scrim as jr, Panel as Dt, variables as Yr, User as Hr, Input as ca, ModalType as Zr, announce as Gr, LoadingBox as Jr, Toast as Ur, useLgUp as la, useMd as da, useBreakpointChange as qr, isImageSrcEmpty as Xr, Logo as Kr, LockStyle as _r, useSmUp as ln, InputLabel as no, NumberStepInput as Mn, RadioButton as oo, Checkbox as $r, CondensedTabs as ei } from "@pexip/components";
import { assertRoomID as dn, assertParticipantID as ti, ClientCallType as gn, MAIN_ROOM_ID as ni } from "@pexip/infinity";
import oi from "i18next";
import { UAParser as ai } from "ua-parser-js";
import { Quality as Le, getQuality as ri, STATS_SIZE as ii } from "@pexip/peer-connection-stats";
import b from "classnames";
import { reverseDeviceId as si, compareDevices as ci, isDeviceGranted as li, getDeviceId as In } from "@pexip/media-control";
var u = /* @__PURE__ */ ((e) => (e.ActionEnterDTMF = "action-enter-dtmf", e.ActionFecc = "action-fecc", e.ActionLowerHand = "action-lower-hand", e.ActionMakeGuest = "action-make-guest", e.ActionMakeHost = "action-make-host", e.ActionMuteMicrophone = "action-mute-microphone", e.ActionRemoveSpotlight = "action-remove-spotlight", e.ActionSpotlight = "action-spotlight", e.ActionTransfer = "action-transfer", e.ActionUnmuteMicrophone = "action-unmute-microphone", e.AudioMeterSettings = "audio-meter-settings", e.BadgeCounterBreakoutRoomsPanelButton = "badge-counter-breakout-rooms-panel-button", e.BadgeCounterParticipantPanelButton = "badge-counter-participant-panel-button", e.BreakoutAssignAutoBtn = "breakout-assign-auto-btn", e.BreakoutAssignManuallyBtn = "breakout-assign-manually-btn", e.BreakoutAssignRoomMenu = "breakout-assign-room-menu", e.BreakoutAssignRoomMenuButton = "breakout-assign-room-menu-button", e.BreakoutNumberOfRoomsInput = "roomsInput-number-step-input", e.BreakoutRoom = "breakout-room", e.BreakoutRoomsPanelWrapper = "breakout-rooms-panel-wrapper", e.BreakoutSetupPanelBackBtn = "breakout-setup-panel-back-btn", e.ButtonAdmitParticipant = "button-admit-participant", e.ButtonAudioMeter = "button-audio-meter", e.ButtonAudioMeterMuted = "button-audio-meter-muted", e.ButtonBackgroundEffectsOff = "button-background-effects-off", e.ButtonBackgroundEffectsOn = "button-background-effects-on", e.ButtonBreakoutJoinAskingForHelp = "button-breakout-join-asking-for-help", e.ButtonBreakoutRoomAddRoom = "button-breakout-rooms-add-room", e.ButtonBreakoutRoomEdit = "button-breakout-rooms-edit", e.ButtonBreakoutRoomHeader = "button-breakout-rooms-edit-header", e.ButtonBreakoutRoomSettings = "breakout-rooms-settings", e.ButtonBreakoutRoomShuffle = "button-breakout-rooms-shuffle", e.ButtonBreakoutRooms = "button-breakout-rooms", e.ButtonBreakoutRoomsCancelGoBackToModeAssignment = "button-breakout-rooms-cancel-go-back-to-mode-assignment", e.ButtonBreakoutRoomsCancelGoBackToOpenedRooms = "button-breakout-rooms-cancel-go-back-to-opened-rooms", e.ButtonBreakoutRoomsConfiguration = "button-breakout-rooms-configuration", e.ButtonBreakoutRoomsConfirmGoBackToModeAssignment = "button-breakout-rooms-confirm-go-back-to-mode-assignment", e.ButtonBreakoutRoomsConfirmGoBackToOpenedRooms = "button-breakout-rooms-confirm-go-back-to-opened-rooms", e.ButtonBreakoutRoomsNumberOfRoomDecrement = "roomsInput-number-step-decrement", e.ButtonBreakoutRoomsNumberOfRoomIncrement = "roomsInput-number-step-increment", e.ButtonCallControlsTouchMoreMenuBack = "button-call-controls-touch-more-menu-back", e.ButtonChat = "button-chat", e.ButtonChatDirectMessagePreview = "button-chat-direct-message-preview", e.ButtonChatDirectTab = "button-chat-direct-tab", e.ButtonChatEveryoneTab = "button-chat-everyone-tab", e.ButtonChatNewDirectMessage = "button-chat-new-direct-message", e.ButtonChatSend = "button-chat-send", e.ButtonCloseInvitationModal = "button-invitation-modal", e.ButtonCollapseSelfview = "button-collapse-selfview", e.ButtonCopyMeetingLink = "button-copy-meeting-link", e.ButtonDenyParticipant = "button-deny-participant", e.ButtonDeviceSettings = "button-device-settings", e.ButtonDismiss = "button-dismiss", e.ButtonDragFoldedSelfview = "button-drag-folded-selfview", e.ButtonDuplicateRoomName = "button-duplicate-room-name", e.ButtonExpandSelfview = "button-hide-selfview", e.ButtonFlipCamera = "button-flip-camera", e.ButtonInviteMemberSearchRow = "button-invite-member-search-row", e.ButtonJoinAudioOnly = "button-join-audio-only", e.ButtonJoinMeeting = "button-join-meeting", e.ButtonJoinMeetingWithOptions = "button-join-meeting-with-options", e.ButtonJoinWithVideo = "button-join-with-video", e.ButtonKickOffParticipant = "button-kick-off-participant", e.ButtonLeave = "button-leave", e.ButtonLowerHand = "button-lower-hand", e.ButtonLowerHandParticipantRow = "button-lower-hand-participant-row", e.ButtonMeetingAudioInput = "button-meeting-audioinput", e.ButtonMeetingAudioInputMuted = "button-meeting-audioinput-muted", e.ButtonMeetingBackgroundEffectsOff = "button-meeting-background-effects-off", e.ButtonMeetingBackgroundEffectsOn = "button-meeting-background-effects-on", e.ButtonMeetingVideoInput = "button-meeting-videoinput", e.ButtonMeetingVideoInputMuted = "button-meeting-videoinput-muted", e.ButtonMoveToBreakoutNow = "button-move-to-breakout-room-now", e.ButtonMuteParticipant = "button-mute-participant", e.ButtonParticipants = "button-participants", e.ButtonPeerMuted = "button-peer-muted", e.ButtonPeerMutedCamera = "button-peer-muted-camera", e.ButtonPeerPresenting = "button-peer-presenting", e.ButtonPeerUnmuteCamera = "button-peer-unmute-camera", e.ButtonQuality = "button-quality", e.ButtonRaiseHand = "button-raise-hand", e.ButtonRemoveUserCancel = "button-remove-user-cancel", e.ButtonRemoveUserConfirm = "button-remove-user-confirm", e.ButtonRequestPermissions = "button-request-permissions", e.ButtonRoomSettingsHoursInputDecrement = "hoursInput-number-step-decrement", e.ButtonRoomSettingsHoursInputIncrement = "hoursInput-number-step-increment", e.ButtonRoomSettingsMinutesInputDecrement = "minutesInput-number-step-decrement", e.ButtonRoomSettingsMinutesInputIncrement = "minutesInput-number-step-increment", e.ButtonSaveBreakoutRoomsEdit = "button-save-breakout-rooms-edit", e.ButtonSelfviewQuality = "button-selfview-quality", e.ButtonSettingsBack = "button-settings-back", e.ButtonSettingsResetToMeetingLayout = "button-settings-reset-to-meeting-layout", e.ButtonSettingsSaveAll = "button-settings-save-all", e.ButtonSettingsSaveMyself = "button-settings-save-myself", e.ButtonStartPresentation = "button-start-presentation", e.ButtonStealPresentationCancel = "button-steal-presentation-cancel", e.ButtonStealPresentationConfirm = "button-steal-presentation-confirm", e.ButtonStopPresentation = "button-stop-presentation", e.ButtonTestAudioInputAgain = "button-test-audio-input-again", e.ButtonTestAudioInputStart = "button-test-audio-input-start", e.ButtonTestAudioInputTryAgain = "button-test-audio-input-try-again", e.ButtonToggleAudioInFoldedSelfview = "button-toggle-audio-in-folded-selfview", e.ButtonToggleAudioInSelfview = "button-toggle-audio-in-selfview", e.ButtonToggleVideoInFoldedSelfview = "button-toggle-video-in-folded-selfview", e.ButtonToolbarMoreItems = "button-toolbar-more-items", e.ButtonTryAgain = "button-try-again", e.ButtonVideoInput = "button-videoinput", e.ButtonVideoinputMuted = "button-videoinput-muted", e.CancelBreakoutSettings = "cancel-breakout-settings", e.ChatActivityMessage = "chat-activity-message", e.ChatActivityMessageDisplayName = "chat-activity-message-display-name", e.ChatActivityMessageText = "chat-activity-message-text", e.ChatEmptyActivityMessage = "chat-empty-activity-message", e.ChatForm = "chat-form", e.ChatInput = "chat-input", e.ChatMessage = "chat-message", e.ChatMessageLink = "chat-message-link", e.ChatMessageName = "chat-message-name", e.ChatMessageText = "chat-message-text", e.ChatMessages = "chat-messages", e.ChatPanel = "chat-panel", e.ChatRemoveActivityMessage = "chat-remove-activity-message", e.ChatUnreadEveryoneMessagesIndicator = "chat-unread-everyone-messages-indicator", e.ChatUnreadMessageIndicator = "chat-unread-message-indicator", e.ChatUnseenDirectMessagesIndicator = "chat-unseen-direct-messages-indicator", e.CheckEverythingWorksText = "check-that-everything-works", e.CloseBreakoutRoom = "close-breakout-room", e.CloseBreakoutRooms = "close-breakout-rooms", e.CloseBreakoutRoomsModalCancel = "close-breakout-rooms-modal-cancel", e.CloseBreakoutRoomsModalConfirm = "close-breakout-rooms-modal-confirm", e.ConfirmationModalCancelButton = "confirmation-modal-cancel-button", e.ConfirmationModalConfirmButton = "confirmation-modal-confirm-button", e.DevicesSelection = "devices-selection", e.DevicesSelectionBlocked = "devices-selection-blocked", e.FoldedSelfview = "folded-selfview", e.GoToBreakoutSetupPanel = "go-to-breakout-setup-panel", e.HeaderLogo = "header-logo", e.HeaderSubTitle = "header-subtitle", e.HeaderTitle = "header-title", e.IconCameraMuted = "icon-camera-muted", e.IconMuted = "icon-muted", e.IconMutedByAHost = "icon-muted-by-a-host", e.IconPresenting = "icon-presenting", e.IconSpotlight = "icon-spotlight", e.InvitationSearchInput = "invitation-search-input", e.JoinBreakoutRoom = "join-breakout-room", e.JoinCallDetailsWrapper = "join-call-details-wrapper", e.Layout = "layout", e.LayoutLabel = "layout-label", e.LinkMuteAllGuests = "link-mute-all-guests", e.LinkOpenMeetingSettings = "link-open-meeting-settings", e.LinkTestAudioInput = "link-test-audio-input", e.LinkTestAudioOutput = "link-test-audio-output", e.LinkUnmuteAllGuests = "link-unmute-all-guests", e.MeetingLinkText = "meeting-link-text", e.MeetingLinkWrapper = "meeting-link-wrapper", e.MeetingVideoFull = "meeting-video-large", e.MeetingVideoPip = "meeting-video-pip", e.MeetingWrapper = "meeting-wrapper", e.MetricAudio = "metric-audio", e.MetricAudioIn = "metric-audio-in", e.MetricAudioOut = "metric-audio-out", e.MetricPreso = "metric-preso", e.MetricPresoIn = "metric-preso-in", e.MetricPresoOut = "metric-preso-out", e.MetricVideo = "metric-video", e.MetricVideoIn = "metric-video-in", e.MetricVideoOut = "metric-video-out", e.MissingAudioDeviceAlert = "missing-audio-device-alert", e.MissingVideoDeviceAlert = "missing-video-device-alert", e.ModalBreakoutRoomsGoBackToModeAssignment = "modal-breakout-rooms-go-back-to-mode-assignment", e.ModalBreakoutRoomsGoBackToOpenedRooms = "modal-breakout-rooms-go-back-to-opened-rooms", e.ModalInvitation = "modal-invitation", e.ModalLayoutChangeConfirmation = "modal-layout-change-confirmation", e.ModalMoveToRoom = "modal-move-to-breakout-room", e.ModalOpenRoomsError = "modal-open-rooms-error", e.ModalRemoveUser = "modal-remove-user", e.ModalRoomSettings = "modal-room-settings", e.ModalStealPresentation = "modal-steal-presentation", e.NetworkConnectedState = "network-connected-state", e.NetworkReconnectedState = "network-reconnected-state", e.NetworkReconnectingState = "network-reconnecting-state", e.NotificationToolTipAudioCloseButton = "notification-tooltip-audio-close-button", e.NotificationToolTipAudioProblem = "notification-tooltip-audio-problem", e.NotificationToolTipDeviceError = "notification-tooltip-device-error", e.NotificationToolTipVideoCloseButton = "notification-tooltip-video-close-button", e.NotificationToolTipVideoProblem = "notification-tooltip-video-problem", e.NotificationTooltipPreviouslyBlocked = "notification-tooltip-previously-blocked", e.NotificationTooltipSelfviewHidden = "notification-tooltip-selfview-hidden", e.OpenBreakoutRooms = "open-breakout-rooms", e.PanelHeaderCloseButton = "panel-header-close-button", e.PanelHeaderTitle = "panel-header-title", e.ParticipantMenuButton = "participant-menu-button", e.ParticipantPanel = "participant-panel", e.ParticipantRow = "participant-row", e.PermissionsRequestMessageWrapper = "permissions-request-message-wrapper", e.PillNewChatMessage = "new-chat-message-pill", e.PresentationFull = "presentation-large", e.PresentationPip = "presentation-pip", e.RemoveBreakoutRoom = "remove-breakout-room", e.RoomSettingsHoursInput = "hoursInput-number-step-input", e.RoomSettingsMinutesInput = "minutesInput-number-step-input", e.SaveBreakoutSettings = "save-breakout-settings", e.SearchRow = "search-row", e.SelectAudioInput = "select-audio-input", e.SelectAudioInputErrorText = "select-audio-input-error-text", e.SelectAudioOutput = "select-audio-output", e.SelectTestAudioInput = "select-test-audio-input", e.SelectTestAudioInputPlayback = "select-test-audio-input-playback", e.SelectTestAudioInputSpeakerPlayback = "select-test-audio-input-speaker-playback", e.SelectVideoInput = "select-video-input", e.SelectVideoInputErrorText = "select-video-input-error-text", e.SendInviteLink = "send-invite-link", e.SettingButtonRequestPreview = "setting-button-request-preview", e.SettingButtonTryAgain = "setting-button-try-again", e.SettingIconCameraOff = "setting-icon-camera-off", e.SettingIconWarning = "setting-icon-warning", e.SettingsVideoSelfview = "settings-video-selfview", e.SettingsVideoSelfviewPreviewLabel = "settings-video-selfview-preview-label", e.SettingsVideoSelfviewWrapper = "settings-video-selfview-wrapper", e.SpeakingIndicator = "speaking-indicator", e.StatsModal = "stats-modal", e.TestAudioInputIndicator = "test-audio-input-indicator", e.TextLinkLearnDismissRequestPermissions = "text-link-dismiss-learn-request-permissions", e.TextLinkLearnRequestPermissions = "text-link-learn-request-permissions", e.TextLinkTryAgainRequestPermissions = "text-link-try-again-request-permissions", e.TextLinkUnblockPermissionsVideo = "text-link-unblock-permissions-video", e.TextNoStatsAvailable = "text-no-stats-available", e.ToastYouAreTemporarilyUnmuted = "toast-you-are-temporarily-unmuted", e.ToggleFecc = "toggle-fecc", e.ToggleNoiseSuppression = "toggle-noise-suppression", e.TogglePreferPresInMix = "toggle-prefer-in-mix", e.TogglePrioritizeSharingMotion = "toggle-prioritize-sharing-motion", e.TooltipDeniedDevice = "tooltip-denied-device", e.TooltipMuteDisabled = "tooltip-mute-disabled", e.UserMenuAddParticipant = "user-menu-add-participant", e.VideoMeeting = "video-meeting", e.VideoPresentation = "video-presentation", e.VideoSelfview = "video-selfview", e.VideoSelfviewWrapper = "video-selfview-wrapper", e.VideoSplashText = "video-splash-text", e.VideoStatus = "video-status", e.VideoStatusBody = "video-status-body", e.VideoStatusTitle = "video-status-title", e))(u || {}), Ue = /* @__PURE__ */ ((e) => (e.BlockedDeviceSelection = "blocked-device-selection", e.DeviceSelection = "device-selection", e.Spinner = "spinner", e))(Ue || {}), Ut = /* @__PURE__ */ ((e) => (e.Void = "void", e.CompleteReload = "complete-reload", e.Complete = "complete", e))(Ut || {}), ma = /* @__PURE__ */ ((e) => (e.unreadChatMessages = "unreadChatMessages", e.focusedButton = "focusedButton", e.inviteModal = "openedInviteModal", e.openedPanel = "openedPanel", e.settingModal = "openedSettingModal", e.userMenu = "openedUserMenu", e.userMenuModal = "openedMenuModal", e.statsModal = "openedStatsModal", e.moreControls = "openedMoreControls", e.openedPlugins = "openedPlugins", e.openedTranscripts = "openedTranscripts", e))(ma || {}), di = /* @__PURE__ */ ((e) => (e.Images = "images", e.Video = "video", e))(di || {}), De = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e))(De || {}), Sn = /* @__PURE__ */ ((e) => (e.Large = "large", e.Full = "full", e))(Sn || {}), de = /* @__PURE__ */ ((e) => (e.Start = "start", e.Reset = "reset", e.Receive = "receive", e.SetLocalMediaStream = "setLocalMediaStream", e.SetRemoteMediaStream = "setRemoteMediaStream", e.SetEmphasis = "setEmphasis", e.SetExpandPrimary = "setExpandPrimary", e.SetShowSteal = "setShowSteal", e.SetSize = "setSize", e.SetPresenterName = "setPresenterName", e.ActivityChange = "ActivityChange", e))(de || {}), X = /* @__PURE__ */ ((e) => (e.BrowserPip = "BrowserPip", e.Emphasized = "Emphasized", e.External = "External", e.Deemphasized = "Deemphasized", e.Expanded = "Expanded", e.Pip = "Pip", e.None = "None", e))(X || {}), Hn = /* @__PURE__ */ ((e) => (e.Disabled = "Disabled", e.Muted = "Muted", e.Unmuted = "Unmuted", e))(Hn || {}), Pn = /* @__PURE__ */ ((e) => (e.Direct = "Direct", e.Everyone = "Everyone", e))(Pn || {}), we = /* @__PURE__ */ ((e) => (e.Low = "low", e.Medium = "medium", e.High = "high", e.VeryHigh = "very-high", e.Auto = "auto", e))(we || {}), $ = /* @__PURE__ */ ((e) => (e.AdaptiveComposition = "ac", e.Speaker7 = "1:7", e.Speaker21 = "1:21", e.Speaker221 = "2:21", e.Speaker33 = "1:33", e.Highlight = "1:0", e.Equal22 = "2x2", e.Equal33 = "3x3", e.Equal44 = "4x4", e.Equal55 = "5x5", e))($ || {}), ue = /* @__PURE__ */ ((e) => (e.Connected = "connected", e.Reconnecting = "reconnecting", e.Reconnected = "reconnected", e))(ue || {});
const nE = [
  "camera-step",
  "in-meeting",
  "ready-to-join-express",
  "ready-to-join-step",
  "force-landscape"
];
var We = /* @__PURE__ */ ((e) => (e.Automatically = "Automatically", e.Manually = "Manually", e))(We || {}), mi = /* @__PURE__ */ ((e) => (e[e.ModeAssignment = 0] = "ModeAssignment", e[e.InitialConfiguration = 1] = "InitialConfiguration", e[e.RoomsOpened = 2] = "RoomsOpened", e[e.EditConfiguration = 3] = "EditConfiguration", e))(mi || {}), fe = /* @__PURE__ */ ((e) => (e.Setup = "setup", e.Preview = "preview", e.Edit = "edit", e))(fe || {});
const ui = 1e4, ua = 767, pi = 498, Te = 16, hi = Te + 344 + Te, ct = 72, Ze = hi + ct, ao = we.High, pe = "main", ht = {
  enter: "Enter",
  escape: "Escape"
}, gi = 145, fi = 80, Ei = er(
  void 0
), vi = (e, t) => {
  Xt(e, "Audio Track must be provided");
  const a = or(new MediaStream([e])), o = ar({
    fftSize: t
  });
  return [rr([[a, o]]), o];
}, Ci = (e, t) => {
  const a = ee(void 0), [o, r] = x();
  return At(() => {
    let i = !1;
    e && ((l) => {
      const [d, m] = vi(l, t);
      a.current = d, i || r(m);
    })(e);
    const c = () => {
      a.current?.release?.(), r(void 0);
    };
    return () => {
      c(), i = !0;
    };
  }, [t, e]), o;
}, bi = (e) => {
  const t = tr(e);
  if (typeof t > "u")
    throw new Error("UndefinedContextValue", { cause: e });
  return t;
}, yi = 3e3, oE = (e, t, a) => {
  const { t: o } = y(), [r, i] = x();
  return A(() => {
    let s = 0;
    const c = e((l) => {
      l ? i({
        title: o(
          "device-status.no-audio-detected.title",
          "No audio detected from microphone"
        ),
        message: o(
          "device-status.no-audio-detected.message",
          "We are not able to detect any sound from your microphone. Please check your settings"
        ),
        warning: W.Microphone
      }) : (i({
        title: o(
          "device-status.audio-detected.title",
          "Audio detected from microphone"
        ),
        message: o(
          "device-status.audio-detected.message",
          "Great, now we have sound from you!"
        ),
        warning: W.Microphone
      }), s = window.setTimeout(() => {
        i(void 0);
      }, yi), t());
    });
    return () => {
      c(), s && (window.clearTimeout(s), s = 0), i(void 0);
    };
  }, [t, e, o, a]), r;
}, Bi = 255, ki = (e) => Math.trunc(e / Bi * 100), wi = (e, t) => {
  if (!e?.node || !t)
    return 0;
  e.node.getByteFrequencyData(t);
  let a = 0;
  for (const o of t)
    if (o > a && (a = o, a === 255))
      break;
  return a;
}, xi = (e) => {
  const [t, a] = x(0), o = ee(void 0);
  A(() => {
    e?.node && (o.current = new Uint8Array(e.node.fftSize / 2));
  }, [e?.node]);
  const r = L(() => {
    e && a(
      ki(wi(e, o.current))
    );
  }, [e]);
  return br(r), t;
}, aE = () => {
  const [e, t] = x(), [a, o] = x(!1);
  return A(() => {
    if ("getBattery" in navigator) {
      const r = navigator.getBattery();
      return r.then(({ level: i, charging: s, addEventListener: c }) => {
        const l = i * 100;
        t(l), o(s), c(
          "chargingchange",
          () => o(s)
        ), c(
          "levelchange",
          () => t(l)
        );
      }).catch((i) => {
        console.error(i);
      }), () => {
        r.then(({ removeEventListener: i }) => {
          i("chargingchange", null), i("levelchange", null);
        });
      };
    }
  }, []), {
    batteryLevel: e,
    isCharging: a
  };
}, pa = (e, t) => t.includes(e) || e === pe, Zn = (e) => Array.from(e.keys()).filter((t) => t !== pe), ha = ({
  setParticipants: e,
  existingBreakoutNames: t = []
}) => {
  const { t: a } = y();
  return L(() => {
    e((o) => {
      const r = new Map(o.entries()), i = a("breakouts.room", "Room"), s = a("breakouts.duplicate", "duplicate");
      let c = `${i} ${[...o.keys()].length}`;
      return pa(c, [
        ...Zn(o),
        ...t
      ]) && (c = `${c} (${s})`), dn(c), r.set(c, []);
    }), ut.emit([
      {
        message: a(
          "breakouts.add-room-done-notification",
          "A new room has been added"
        )
      }
    ]);
  }, [t, e, a]);
}, Mi = (e, t) => e.groupedParticipants?.length ? [
  ...e.groupedParticipants,
  {
    userId: t.userId,
    isMe: t.isMe,
    displayName: t.displayName,
    timestamp: t.timestamp
  }
] : [
  {
    userId: e.userId,
    displayName: e.displayName,
    isMe: e.isMe,
    timestamp: e.timestamp
  },
  {
    userId: t.userId,
    displayName: t.displayName,
    isMe: t.isMe,
    timestamp: t.timestamp
  }
], Ii = (e, t) => ({
  ...t,
  userId: void 0,
  displayName: "",
  groupedParticipants: Mi(e, t)
});
var Nn = /* @__PURE__ */ ((e) => (e.ScrollToLastMessage = "scroll-to-last-message", e.DisplayNewMessageToast = "display-new-message-toast", e))(Nn || {});
const Si = (e, t) => !t && !e ? "display-new-message-toast" : "scroll-to-last-message", Pi = (e, t) => {
  const a = Jo(e, {});
  return !a.userId || !t ? !1 : a.userId === t;
}, ga = (e, t = !0) => {
  const a = e.current?.getScrollElement();
  if (!a)
    return;
  const o = () => {
    const r = e.current?.getScrollElement();
    r?.scrollTo({
      top: r?.scrollHeight,
      behavior: t ? "smooth" : "auto"
    });
  };
  a.scrollHeight !== 0 ? o() : setTimeout(o, 0);
}, Ni = (e = 0) => (t) => {
  const a = t?.getScrollElement();
  if (a) {
    const o = a.scrollHeight, r = a.scrollTop, i = a.clientHeight;
    return o - r <= i + e;
  }
  return !1;
}, Ti = (e, t) => {
  const a = e.findIndex(
    (o) => o.id === t
  );
  return a === -1 ? 0 : e.length - (a + 1);
}, rE = (e, t) => e && e.length < t;
var Ri = /* @__PURE__ */ ((e) => (e.TextPlain = "text/plain", e.TextHTML = "text/html", e))(Ri || {});
const zi = (e, t) => new window.ClipboardItem({
  [e]: t
}), iE = (e, t, {
  clipboardWrite: a = navigator.clipboard.write.bind(
    window.navigator.clipboard
  ),
  createItem: o = zi
} = {}) => a([o(e, t)]), Wi = (e, t = window.navigator.clipboard.writeText.bind(
  window.navigator.clipboard
)) => t(e), sE = (e = window.navigator.clipboard.readText.bind(
  window.navigator.clipboard
)) => e(), cE = async (e, t) => {
  await Wi(e), t(!0);
}, ro = "audio/ogg; codecs=opus", Li = "audio/webm; codecs=opus", Fi = "audio/mp4", lE = () => (
  // MP4 has higher priority over webm as it has better support from Safari
  [ro, Fi, Li].find(
    (e) => MediaRecorder.isTypeSupported(e)
  ) ?? ro
), dE = (e, t, a) => {
  const o = ["audio", "video"].flatMap((s) => t.includes("video") ? [s] : t.includes(s) ? [s] : []);
  if (!e.some((s) => o.includes(s.kind)))
    throw new Error("No valid track");
  const r = {}, i = new MediaRecorder(
    new MediaStream(
      e.flatMap((s) => {
        if (o.includes(s.kind)) {
          const c = s.clone();
          return c.enabled = !0, c;
        }
        return [];
      })
    ),
    { mimeType: t }
  );
  return i.ondataavailable = (s) => {
    r.onDataAvailable?.(s.data), a?.add(s.data);
  }, i.onstop = () => {
    r.onStop?.();
  }, i.onstart = () => {
    r.onStart?.();
  }, i.onresume = () => {
    r.onResume?.();
  }, i.onpause = () => {
    r.onPause?.();
  }, i.onerror = () => {
    r.onError?.();
  }, {
    get stream() {
      return i.stream;
    },
    get mimeType() {
      return i.mimeType;
    },
    get state() {
      return i.state;
    },
    get audioBitsPerSecond() {
      return i.audioBitsPerSecond;
    },
    get videoBitsPerSecond() {
      return i.videoBitsPerSecond;
    },
    set onDataAvailable(s) {
      r.onDataAvailable = s;
    },
    set onStart(s) {
      r.onStart = s;
    },
    set onStop(s) {
      r.onStop = s;
    },
    set onPause(s) {
      r.onPause = s;
    },
    set onResume(s) {
      r.onResume = s;
    },
    set onError(s) {
      r.onError = s;
    },
    start(s) {
      i.start(s);
    },
    stop() {
      i.stop();
    },
    pause() {
      i.pause();
    },
    resume() {
      i.resume();
    },
    requestData() {
      i.requestData();
    },
    clean() {
      for (const s of i.stream.getTracks())
        s.stop();
    }
  };
}, mE = () => {
  let e = [];
  return {
    add: (t) => {
      e.push(t);
    },
    clear: () => {
      e = [];
    },
    get: () => e
  };
}, Yt = (e, t, a) => {
  const o = e.match(t);
  return o && o.length >= a && Number.parseInt(o[a] ?? "0", 10) || 0;
}, Qi = (e = window) => !(!e?.navigator || !("RTCPeerConnection" in e) || !("RTCRtpTransceiver" in e)), Ai = (e = window) => "mozGetUserMedia" in e || "peerIdentity" in e.RTCPeerConnection.prototype, Vi = (e = window) => "webkitGetUserMedia" in navigator || !e.isSecureContext && "webkitRTCPeerConnection" in e && !("RTCIceGatherer" in e), Oi = (e = window) => !!(e.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)), Di = (e = window) => !!(e.RTCRtpTransceiver && "currentDirection" in e.RTCRtpTransceiver.prototype);
function fa({
  hasWebRTC: e = Qi,
  isFirefox: t = Ai,
  isChromium: a = Vi,
  isSafari: o = Oi,
  hasUnifiedPlan: r = Di
} = {}) {
  const i = {
    browser: "",
    version: 0,
    supportsUnifiedPlan: !1
  };
  if (!e())
    return i.browser = "Not a browser.", i;
  if (t())
    i.browser = "firefox", i.version = Yt(
      navigator.userAgent,
      /Firefox\/(\d+)\./,
      1
    ), i.supportsUnifiedPlan = r();
  else if (a())
    i.browser = "chrome", i.version = Yt(
      navigator.userAgent,
      /Chrom(e|ium)\/(\d+)\./,
      2
    ), i.supportsUnifiedPlan = r();
  else if (o()) {
    const s = /Version\/(\d+)\.(\d+)\.(\d+)/;
    i.browser = "safari", i.version = +`${Yt(
      navigator.userAgent,
      s,
      1
    )}.${Yt(navigator.userAgent, s, 2)}`, i.supportsUnifiedPlan = r();
  } else
    return i.browser = "Not a supported browser.", i;
  return i;
}
const Ea = (e) => {
  if (e.includes("Edg/"))
    return "Edge Chromium";
  if (e.includes("Firefox/"))
    return "Firefox";
  if (e.includes("Chrome/") || e.includes("CriOS/"))
    return "Chrome";
  if (e.includes("Android"))
    return "Android";
  if (e.includes("Safari/") && !e.includes("Mobile/"))
    return "Safari Mac";
  if (e.includes("Safari/") && e.includes("iPad"))
    return "Safari iPad";
  if (e.includes("Safari/") && e.includes("iPhone"))
    return "Safari iPhone";
}, va = fa(), ji = (e = fa) => !e().browser.includes("Not a"), uE = ji(), pE = navigator?.mediaDevices && "getDisplayMedia" in navigator.mediaDevices, hE = va.browser === "firefox", gE = va.version, fE = Ea(navigator?.userAgent), Kt = (e = !0) => (t) => {
  e && t.stopPropagation();
}, EE = (e, t) => Math.floor(Math.random() * (t - e + 1)) + e, vE = (e = 1) => (t) => Math.round(t / e) / 100, Yi = 5 * 6e4, Hi = (e, t) => e?.activityType === t.activityType, Zi = (e, t) => {
  if (e?.at && t.at) {
    const a = t.at;
    if (new Date(
      e.at.getTime() + Yi
    ) >= a)
      return !0;
  }
  return !1;
}, Gi = (e, t) => e?.type === "activity" && Hi(e, t) && Zi(e, t), Ji = (e, t) => {
  const a = e.at(-1);
  return a && Gi(a, t) ? (e.splice(
    e.length - 1,
    1,
    Ii(a, t)
  ), Array.from(e)) : [...e, t];
};
function Ui() {
  return Object.freeze({
    fatal: (e, t) => console.error(t, e),
    error: (e, t) => console.error(t, e),
    warn: (e, t) => console.warn(t, e),
    info: (e, t) => console.info(t, e),
    debug: (e, t) => console.debug(t, e),
    trace() {
    },
    silent() {
    },
    redact(e) {
      return e;
    },
    addRedactPattern() {
    }
  });
}
let ve = Ui();
function CE(e) {
  ve = e;
}
const bE = () => {
  if (!("connection" in navigator) || !(navigator.connection && "effectiveType" in navigator.connection))
    return ao;
  switch (ve.info(navigator.connection, "User connection"), navigator.connection.effectiveType) {
    case "slow-2g":
    case "2g":
      return we.Low;
    case "3g":
      return we.Medium;
    default:
      return ao;
  }
}, yE = (e) => e !== Hn.Unmuted, BE = (e) => e === Hn.Disabled;
var qi = /* @__PURE__ */ ((e) => (e[e.IOS = 0] = "IOS", e[e.Android = 1] = "Android", e[e.WebOS = 2] = "WebOS", e[e.BlackBerry = 3] = "BlackBerry", e[e.WindowsPhone = 4] = "WindowsPhone", e[e.Mac = 5] = "Mac", e[e.Windows = 6] = "Windows", e[e.Linux = 7] = "Linux", e[e.Unknown = 8] = "Unknown", e))(qi || {});
const Ca = [/iPhone/i, /iPad/i, /iPod/i], Xi = [
  /Android/i,
  /webOS/i,
  /BlackBerry/i,
  /Windows Phone/i,
  ...Ca
], ke = (e, t) => !!new RegExp(t).exec(e), Gn = () => "matchMedia" in window && matchMedia("(any-pointer: fine)").matches ? !1 : "maxTouchPoints" in navigator && navigator.maxTouchPoints > 0 || "orientation" in window, ba = (e, t) => e < t, ya = (e, t, a = ua) => ba(e, t) ? e < a : t < a, _t = (e = navigator.userAgent) => {
  const t = ke(e, /Macintosh/i) && Gn();
  return Ca.some((a) => ke(e, a)) || t ? 0 : ke(e, /Windows Phone/i) ? 4 : ke(e, /Android/i) ? 1 : ke(e, /webOS/i) ? 2 : ke(e, /BlackBerry/i) ? 3 : ke(e, /Macintosh/i) ? 5 : ke(e, /Windows/i) ? 6 : ke(e, /Linux/i) ? 7 : 8;
}, Jn = () => _t() === 6 && Gn(), kE = Jn(), gt = (e = navigator.userAgent) => Jn() ? !1 : Gn() ? !0 : Xi.some((t) => ke(e, t)), Ki = gt() && ya(window.screen.width, window.screen.height), wE = gt() && !ya(window.screen.width, window.screen.height) && !Jn(), xE = _t() !== 0 || _t() === 0 && ke(Ea(navigator.userAgent) || "", /Safari/i), ME = _t(), Ba = (e, t) => (a) => {
  e({ title: "" }), t?.(a);
}, IE = async () => {
  document.pictureInPictureElement && document.exitPictureInPicture && await document.exitPictureInPicture();
}, SE = (e) => {
  switch (e) {
    case we.Low:
      return fn(960, 540);
    case we.VeryHigh:
      return fn(1920, 1080);
    default:
      return fn(1280, 720);
  }
}, fn = (e, t) => ({
  width: { ideal: e, max: 1920 },
  height: { ideal: t, max: 1080 }
}), PE = (e, t) => t || !e ? "collapsed" : "expanded", _i = gt, NE = (e = ua, t = pi) => _i() ? !1 : window.innerWidth < e || window.innerHeight < t, Un = ({
  allParticipants: e,
  identity: t,
  shuffleAssigned: a = !1,
  shuffleId: o = Date.now() % 6e4
}) => {
  const r = [], i = [], s = [];
  for (const [m, p] of e.entries()) {
    const g = m === pe;
    g || r.push(m), !a && g ? i.push(...p) : s.push(...p);
  }
  const c = s.findIndex(
    (m) => m.uuid === t
  );
  if (c > -1) {
    const m = s[c];
    m && i.unshift(m), s.splice(c, 1);
  }
  const l = ["main", i], d = Array.from(
    { length: r.length },
    (m, p) => [ir(r[p]), []]
  );
  for (let m = 0; m < s.length; m++) {
    const p = m % d.length, [, g] = d[p] ?? [];
    if (!g)
      break;
    const f = s[sr(m, o, s.length)];
    if (!f)
      break;
    g.push(f);
  }
  return d.unshift(l), new Map(d);
};
let { format: ka } = new Intl.DateTimeFormat(void 0, {
  hour: "2-digit",
  hour12: !1,
  minute: "2-digit"
});
oi.on("languageChanged", (e) => {
  ({ format: ka } = new Intl.DateTimeFormat(e, {
    hour: "2-digit",
    hour12: !1,
    minute: "2-digit"
  }));
});
const TE = ka, bt = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, Ht = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, io = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded"
}, $i = "iPad", wa = (e) => {
  const t = new ai();
  t.setUA(e);
  const { name: a, version: o } = t.getBrowser(), { name: r, version: i } = t.getOS(), {
    type: s,
    vendor: c,
    model: l
  } = t.getDevice(), d = () => a === bt.Firefox, m = () => a === bt.Chrome, p = () => a === bt.Safari, g = () => a === bt.MobileSafari, f = () => a === bt.Edge, v = () => r === Ht.Android, E = () => r === Ht.MAC_OS, C = () => r === Ht.IOS, B = () => r === Ht.Windows, w = () => s === io.Mobile, M = () => s === io.Tablet, P = () => l === $i || (E() || C()) && (M() || so()), T = () => s === void 0;
  return {
    // Metadata
    browserName: a,
    browserVersion: o,
    systemName: r,
    systemVersion: i,
    deviceType: s,
    deviceVendor: c,
    deviceModel: l,
    get isTouch() {
      return so();
    },
    // Browser check
    get isFirefox() {
      return d();
    },
    get isChrome() {
      return m();
    },
    get isEdge() {
      return f();
    },
    get isSafari() {
      return p();
    },
    get isSafariMobile() {
      return g();
    },
    // System check
    get isAndroid() {
      return v();
    },
    get isMacOS() {
      return E();
    },
    get isIOS() {
      return C();
    },
    get isWindows() {
      return B();
    },
    // Device check
    get isMobile() {
      return w();
    },
    get isTablet() {
      return M();
    },
    get isIPad() {
      return P();
    },
    get isDesktop() {
      return T();
    }
  };
}, so = () => {
  let e = !1;
  return window.PointerEvent && "maxTouchPoints" in navigator ? navigator.maxTouchPoints > 0 && (e = !0) : (window.matchMedia?.("(any-pointer:coarse)").matches || window.TouchEvent || "ontouchstart" in window) && (e = !0), e;
}, es = (e) => (t) => {
  const a = [
    e.onMediaChanged.add(t),
    e.onDevicesChanged.add(t)
  ];
  return () => {
    for (const o of a)
      o();
    a.length = 0;
  };
}, En = (e, t) => (a) => {
  const o = (i) => {
    i.kind === t && a();
  }, r = [
    e.onMediaChanged.add(a),
    e.onAddTrack.add(o),
    e.onRemoveTrack.add(o)
  ];
  return () => {
    for (const i of r)
      i();
    r.length = 0;
  };
}, RE = (e) => (t) => {
  const a = [
    e.onMediaChanged.add(t),
    e.onAddTrack.add(t),
    e.onRemoveTrack.add(t),
    e.onMediaTrackStopped.add(t)
  ];
  return () => {
    for (const o of a)
      o();
    a.length = 0;
  };
}, ts = (e, t) => ns(e, t) ?? os(e) ?? as(e), ns = (e, t) => !t || !("kind" in t) ? void 0 : e.get(t)[0], os = (e) => e.get({ kind: "audiooutput", deviceId: "default" })[0], as = (e) => e.first("audiooutput");
var $t = /* @__PURE__ */ ((e) => (e.NONE = "none", e.BREAKOUT_ROOMS_IN = "breakout-rooms-in", e.BREAKOUT_ROOMS_OUT = "breakout-rooms-out", e.CHAT_IN = "chat-in", e.CHAT_OUT = "chat-out", e.PARTICIPANTS_IN = "participants-in", e.PARTICIPANTS_OUT = "participants-out", e.PLUGINS_IN = "plugins-in", e.PLUGINS_OUT = "plugins-out", e.TRANSCRIPTS_IN = "transcripts-in", e.TRANSCRIPTS_OUT = "transcripts-out", e))($t || {});
const rs = (e) => {
  const {
    currentBreakoutRooms: t,
    currentChat: a,
    currentParticipants: o,
    currentPlugins: r,
    currentTranscripts: i,
    nextBreakoutRooms: s,
    nextChat: c,
    nextParticipants: l,
    nextPlugins: d,
    nextTranscripts: m
  } = e, p = !a && !o && !t && !r && !i, g = c || l || s || d || m, f = () => p && s, v = () => p && c, E = () => p && l, C = () => p && d, B = () => p && m, w = () => t && !g, M = () => a && !g, P = () => o && !g, T = () => r && !g, R = () => i && !g;
  return v() ? "chat-in" : E() ? "participants-in" : f() ? "breakout-rooms-in" : C() ? "plugins-in" : M() ? "chat-out" : P() ? "participants-out" : w() ? "breakout-rooms-out" : T() ? "plugins-out" : B() ? "transcripts-in" : R() ? "transcripts-out" : "none";
}, is = (e, {
  openChatPanel: t,
  openParticipantPanel: a,
  openBreakoutRoomsPanel: o,
  openPluginsPanel: r,
  openTranscriptsPanel: i
}) => e === "chat" ? !t : e === "participants" ? !a : e === "plugins" ? !r : e === "transcripts" ? !i : !o, zE = (e) => (t) => {
  const a = is(e, {
    openChatPanel: t.openChatPanel,
    openParticipantPanel: t.openParticipantPanel,
    openBreakoutRoomsPanel: t.openBreakoutRoomsPanel,
    openPluginsPanel: t.openPluginsPanel,
    openTranscriptsPanel: t.openTranscriptsPanel
  }), o = e === "chat" && a, r = e === "participants" && a, i = e === "breakoutRooms" && a, s = e === "plugins" && a, c = e === "transcripts" && a, l = rs({
    currentBreakoutRooms: t.openBreakoutRoomsPanel,
    currentChat: t.openChatPanel,
    currentParticipants: t.openParticipantPanel,
    currentPlugins: t.openPluginsPanel,
    currentTranscripts: t.openTranscriptsPanel,
    nextBreakoutRooms: i,
    nextChat: o,
    nextParticipants: r,
    nextPlugins: s,
    nextTranscripts: c
  });
  return [a, l];
}, ss = () => {
  let e = "visible", t = {
    unreadChatMessages: !1,
    focusedButton: !1,
    openedMenuModal: !1,
    openedSettingModal: !1,
    openedInviteModal: !1,
    openedPanel: !1,
    openedUserMenu: !1,
    openedMoreControls: !1,
    openedPlugins: !1,
    openedTranscripts: !1
  };
  return {
    setMeetingUIState: (a) => {
      t = a;
    },
    get currentState() {
      return t;
    },
    get uiVisibilityState() {
      return e;
    },
    setUIVisibilityState: (a) => {
      e = a;
    },
    shouldEnableAutoHide: () => !Object.values(t).some((a) => a)
  };
}, cs = ({
  assignmentMode: e,
  myIdentity: t,
  numberOfRooms: a,
  setParticipants: o,
  shuffle: r = Un
}) => {
  const { t: i } = y();
  A(() => {
    switch (e) {
      case We.Manually:
        o((s) => {
          const c = [
            ...s.get(pe) ?? []
          ], l = [
            pe,
            c
          ], d = Array.from(
            { length: a },
            (m, p) => [
              `${i("breakouts.room", "Room")} ${p + 1}`,
              []
            ]
          );
          return d.unshift(l), new Map(d);
        });
        break;
      case We.Automatically:
        o((s) => {
          const c = [
            ...s.get(pe) ?? []
          ], l = new Map(
            Array.from(
              { length: a },
              (d, m) => [
                `${i("breakouts.room", "Room")} ${m + 1}`,
                []
              ]
            )
          );
          return l.set(pe, c), r({
            allParticipants: l,
            identity: t,
            shuffleAssigned: !0
          });
        });
        break;
    }
  }, [
    e,
    t,
    a,
    o,
    r,
    i
  ]);
}, xa = ({
  participants: e,
  setParticipants: t
}) => L(
  (a, o) => {
    e.forEach((r, i) => {
      r.forEach((s, c) => {
        s.uuid === a && t((l) => {
          const d = new Map(
            l.entries()
          ), m = [...r];
          if (m?.splice(c, 1), d.set(i, m), o) {
            const p = [
              ...d.get(o) ?? []
            ];
            p.push(s), d.set(
              o,
              p
            );
          }
          return d;
        });
      });
    });
  },
  [e, t]
), ls = ({
  onCloseRooms: e
}) => {
  const { t } = y(), [a, o] = x(!1), r = L(
    () => o(!0),
    []
  );
  return {
    breakoutCloseAllRoomsConfirmationModal: /* @__PURE__ */ n.createElement(
      Qe,
      {
        cancelButtonText: t("common.cancel", "Cancel"),
        cancelButtonTestid: u.CloseBreakoutRoomsModalCancel,
        confirmButtonText: t("common.yes", "Yes"),
        confirmButtonTestid: u.CloseBreakoutRoomsModalConfirm,
        title: t(
          "breakouts.close-all-rooms-modal.title",
          "Close all rooms?"
        ),
        uniqueTitle: t(
          "breakouts.close-all-rooms-modal.title",
          "Close all rooms?"
        ),
        description: t(
          "breakouts.close-all-rooms-modal.description",
          "All participants will be moved to the main room."
        ),
        isOpen: a,
        onConfirm: () => {
          o(!1), e();
        },
        onCancel: () => o(!1)
      }
    ),
    openBreakoutCloseAllRoomsConfirmationModal: r
  };
}, Ma = ({
  participants: e,
  changeParticipantRoom: t,
  setIsDragging: a
}) => {
  const o = ee({}), [r, i] = x(), s = (m) => (p) => {
    p && (o.current[m] = p);
  }, c = L(
    (m) => {
      const p = m.getBoundingClientRect();
      for (const g in o.current) {
        const f = o.current[g];
        if (!f)
          return;
        const v = f.getBoundingClientRect(), E = p.left >= v.left && p.left <= v.right, C = p.top > v.top && p.bottom < v.bottom;
        if (E && C)
          return dn(g), // if participant was dropped in the same room, don't do anything
          e.get(g)?.find(
            (B) => B.uuid === m.id
          ) ? void 0 : g;
      }
    },
    [e]
  ), l = L(
    (m) => {
      a(!0), i(c(m));
    },
    [c, a]
  ), d = L(
    (m) => {
      i(void 0), a(!1);
      const p = c(m);
      p && (ti(m.id), t(m.id, p));
    },
    [a, c, t]
  );
  return {
    targetRoomId: r,
    onParticipantDragging: l,
    onParticipantDrag: d,
    getBreakoutRoomRefCallback: s
  };
}, Ia = ({
  setParticipants: e
}) => L(
  (t) => {
    e((a) => {
      const o = new Map(a.entries()), r = [
        ...o.get(pe) ?? [],
        ...o.get(t) ?? []
      ];
      return o.set(pe, r), o.delete(t), o;
    });
  },
  [e]
), ds = ({ isOpen: e, onConfirm: t }) => {
  const { t: a } = y();
  return /* @__PURE__ */ n.createElement(
    Qe,
    {
      isOpen: e,
      title: a(
        "breakouts.duplicate-room-name-title",
        "Duplicated room names"
      ),
      uniqueTitle: a(
        "breakouts.duplicate-room-name-title",
        "Duplicated room names"
      ),
      description: a(
        "breakouts.duplicate-room-name-description",
        "Two rooms can not have the same name"
      ),
      confirmButtonText: a("common.ok", "Ok"),
      confirmButtonTestid: u.ButtonDuplicateRoomName,
      onConfirm: t
    }
  );
}, Sa = ({
  participants: e,
  setParticipants: t,
  breakoutRoomsNames: a,
  setBreakoutRoomsNames: o
}) => {
  const [r, i] = x(!1), s = L(
    (l, d) => pa(d, [
      ...Zn(e),
      ...a ? Object.values(a) : []
    ]) ? (i(!0), !1) : (a && o && a.has(l) ? o({
      ...a,
      [l]: d
    }) : t((m) => {
      const p = m.get(l);
      return p ? (dn(d), m.set(d, p), m.delete(l), new Map(m)) : m;
    }), !0),
    [
      e,
      t,
      a,
      o
    ]
  ), c = Fe(
    () => /* @__PURE__ */ n.createElement(
      ds,
      {
        isOpen: r,
        onConfirm: () => i(!1)
      }
    ),
    [r]
  );
  return { handleBreakoutRoomNameChange: s, duplicateRoomNameModal: c };
}, Pa = ({
  setParticipants: e,
  myIdentity: t,
  shuffle: a = Un
}) => {
  const o = ee(0), [r, i] = x(!1), { t: s } = y(), c = L(() => {
    i(!0), e(
      (l) => a({ allParticipants: l, identity: t })
    ), o.current = window.setTimeout(() => {
      i(!1), ut.emit([
        {
          message: s(
            "breakouts.shuffle-done-notification",
            "Participants have been shuffled"
          )
        }
      ]);
    }, 500);
  }, [t, e, a, s]);
  return A(() => () => {
    clearTimeout(o.current);
  }, []), { isShuffling: r, doShuffle: c };
}, ms = ({
  localParticipants: e,
  liveParticipants: t,
  localBreakoutNames: a,
  liveBreakoutNames: o
}) => L(() => {
  const r = {
    move: /* @__PURE__ */ new Map(),
    addRoom: /* @__PURE__ */ new Map(),
    renameRoom: /* @__PURE__ */ new Map(),
    removeRoom: []
  };
  for (const i of o.keys()) {
    if (!e.has(i)) {
      r.removeRoom.push(i);
      continue;
    }
    const s = a.get(i);
    s && s !== o.get(i) && r.renameRoom.set(i, s);
  }
  for (const i of e.keys())
    i !== pe && (o.has(i) || r.addRoom.set(i, /* @__PURE__ */ new Map()));
  for (const [i, s] of e.entries())
    for (const c of s)
      for (const [
        l,
        d
      ] of t.entries())
        for (const m of d)
          if (c === m && i !== l) {
            if (r.addRoom.has(i)) {
              const f = r.addRoom.get(i);
              if (f) {
                const v = f.get(l);
                v ? v.push(c) : f.set(
                  l,
                  [c]
                );
              }
              continue;
            }
            const p = r.move.get(l) ?? /* @__PURE__ */ new Map(), g = p?.get(i);
            g ? g.push(c) : p.set(i, [c]), r.move.set(l, p);
          }
  return r;
}, [
  o,
  a,
  t,
  e
]), us = ({
  currentParticipants: e,
  breakoutRoomsNames: t,
  myIdentity: a,
  onSave: o
}) => {
  const [r, i] = x(e), [s, c] = x(
    t
  ), [l, d] = x(!1), m = xa({
    participants: r,
    setParticipants: i
  }), {
    targetRoomId: p,
    onParticipantDragging: g,
    onParticipantDrag: f,
    getBreakoutRoomRefCallback: v
  } = Ma({
    participants: r,
    changeParticipantRoom: m,
    setIsDragging: d
  }), E = Ia({ setParticipants: i }), { handleBreakoutRoomNameChange: C } = Sa({
    setParticipants: i,
    participants: r,
    breakoutRoomsNames: s,
    setBreakoutRoomsNames: c
  }), B = ha({
    setParticipants: i,
    existingBreakoutNames: Object.values(s)
  }), { doShuffle: w, isShuffling: M } = Pa({
    setParticipants: i,
    myIdentity: a
  }), P = (O) => Array.from(O).reduce((G, [Y, J]) => (G.set(
    Y,
    J.map((_) => _.uuid)
  ), G), /* @__PURE__ */ new Map()), T = ms({
    liveBreakoutNames: t,
    localBreakoutNames: s,
    liveParticipants: P(e),
    localParticipants: P(r)
  }), R = L(() => {
    const O = T();
    o(O);
  }, [T, o]);
  return {
    participants: r,
    breakoutRoomsNames: s,
    isDragging: l,
    currentDragTarget: p,
    onParticipantDragging: g,
    onParticipantDrag: f,
    getBreakoutRoomRefCallback: v,
    onRemoveRoom: E,
    handleBreakoutRoomNameChange: C,
    onAddRoom: B,
    doShuffle: w,
    isShuffling: M,
    doSave: R,
    changeParticipantRoom: m
  };
}, ps = ({
  currentParticipants: e,
  participants: t,
  setParticipants: a,
  changeParticipantRoom: o
}) => A(() => {
  const r = Array.from(
    e.values()
  ).flat(), i = Array.from(t.values()).flat();
  if (r.length > i.length) {
    const s = r.filter(
      (c) => !i.find(
        (l) => l.uuid === c.uuid
      )
    );
    s.length !== 0 && a((c) => {
      const l = new Map(c.entries());
      return l.get(pe)?.push(...s), l;
    });
  } else if (r.length < i.length) {
    const s = i.filter(
      (c) => !r.find((l) => l.uuid === c.uuid)
    );
    for (const c of s)
      o(c.uuid);
  }
}, [
  e,
  t,
  a,
  o
]), WE = () => {
  const { t: e } = y(), t = L(
    (o, r) => {
      switch (o.length) {
        case 0:
        case 1:
          return;
        case 2:
          switch (r) {
            case "joined":
              return e("meeting.two-participants-joined-group", {
                defaultValue: "{{second}} and {{first}} joined",
                first: o.at(0)?.displayName,
                second: o.at(1)?.displayName
              });
            case "left":
              return e("meeting.two-participants-left-group", {
                defaultValue: "{{second}} and {{first}} left",
                first: o.at(0)?.displayName,
                second: o.at(1)?.displayName
              });
            default:
              throw new Error(
                `Unhandled activity type: ${r}`
              );
          }
        case 3:
          switch (r) {
            case "joined":
              return e(
                "meeting.three-participants-joined-group",
                {
                  defaultValue: "{{third}}, {{second}} and {{first}} joined",
                  first: o.at(0)?.displayName,
                  second: o.at(1)?.displayName,
                  third: o.at(2)?.displayName
                }
              );
            case "left":
              return e("meeting.three-participants-left-group", {
                defaultValue: "{{third}}, {{second}} and {{first}} left",
                first: o.at(0)?.displayName,
                second: o.at(1)?.displayName,
                third: o.at(2)?.displayName
              });
            default:
              throw new Error(
                `Unhandled activity type: ${r}`
              );
          }
        case 4:
          switch (r) {
            case "joined":
              return e("meeting.four-participants-joined-group", {
                defaultValue: "{{third}}, {{second}}, {{first}} and 1 other joined",
                first: o.at(1)?.displayName,
                second: o.at(2)?.displayName,
                third: o.at(3)?.displayName
              });
            case "left":
              return e("meeting.four-participants-left-group", {
                defaultValue: "{{third}}, {{second}}, {{first}} and 1 other left",
                first: o.at(1)?.displayName,
                second: o.at(2)?.displayName,
                third: o.at(3)?.displayName
              });
            default:
              throw new Error(
                `Unhandled activity type: ${r}`
              );
          }
        default:
          switch (r) {
            case "joined":
              return e(
                "meeting.more-than-four-participants-joined-group",
                {
                  defaultValue: "{{third}}, {{second}}, {{first}} and {{remaining}} others joined",
                  first: o.at(-3)?.displayName,
                  second: o.at(-2)?.displayName,
                  third: o.at(-1)?.displayName,
                  remaining: o.length - 3
                }
              );
            case "left":
              return e(
                "meeting.more-than-four-participants-left-group",
                {
                  defaultValue: "{{third}}, {{second}}, {{first}} and {{remaining}} others left",
                  first: o.at(-3)?.displayName,
                  second: o.at(-2)?.displayName,
                  third: o.at(-1)?.displayName,
                  remaining: o.length - 3
                }
              );
            default:
              throw new Error(
                `Unhandled activity type: ${r}`
              );
          }
      }
    },
    [e]
  );
  return L(
    (o, r) => {
      if (r) {
        const i = Ji(
          o,
          r
        ), s = i.at(-1);
        if (s?.groupedParticipants?.length && s.activityType) {
          const c = t(
            s.groupedParticipants,
            s.activityType
          );
          c && (s.message = c);
        }
        return i;
      }
      return o;
    },
    [t]
  );
}, LE = ({
  getStreamQuality: e,
  callQualitySignal: t,
  networkState: a = ue.Connected
}) => {
  const [o, r] = x(Le.GOOD);
  return A(() => {
    if (a !== ue.Reconnecting)
      return t.add(
        ([i, s]) => {
          const c = e();
          ve.debug(
            {
              networkState: a,
              incomingQuality: i,
              outgoingQuality: s,
              streamQuality: c,
              stats: window.pexDebug?.stats
            },
            "Call quality changed"
          ), r(
            hs(i, s)
          );
        }
      );
  }, [a, e, t]), o;
}, hs = (e = 0, t = 0) => Math.max(e, t), gs = "_wrapper_1lqo5_4", fs = {
  wrapper: gs
}, Es = ({ onClick: e }) => {
  const { t } = y();
  return /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, /* @__PURE__ */ n.createElement("div", { className: b("d-flex align-items-center", fs.wrapper) }, /* @__PURE__ */ n.createElement(
    F,
    {
      source: k.IconWarningRound,
      className: "mr-1 flex-shrink-0"
    }
  ), " ", /* @__PURE__ */ n.createElement(N, { fontVariant: S.Body, className: "text-center" }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "quality.poor-connection-detected" }, "Poor connection detected"), " ", e && /* @__PURE__ */ n.createElement(
    pt,
    {
      fontVariant: S.Body,
      onClick: e
    },
    /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "quality.change-quality" }, "Change quality")
  ))));
}, vs = 3e3, Cs = () => {
  ut.emit([
    {
      message: /* @__PURE__ */ n.createElement(Es, null),
      isDanger: !0,
      isInterrupt: !0,
      colorScheme: "light",
      timeout: 0
    }
  ]);
}, co = () => {
  ut.emit({ close: !0 });
}, FE = ({
  callQuality: e,
  networkState: t = ue.Connected
}) => {
  const a = ee(0), o = L(() => {
    a.current && (clearTimeout(a.current), a.current = 0);
  }, []);
  A(() => t === ue.Reconnecting ? co() : (e === Le.BAD || e === Le.TERRIBLE ? (o(), Cs()) : a.current = window.setTimeout(
    co,
    vs
  ), o), [e, o, t]);
}, bs = (e, t, a) => {
  const {
    isMessageByCurrentUser: o,
    isLastMessageVisible: r,
    messageCount: i,
    scrollbarRef: s
  } = e;
  A(() => {
    switch (Si(
      o,
      r
    )) {
      case Nn.ScrollToLastMessage:
        ga(s);
        break;
      case Nn.DisplayNewMessageToast:
        a(t(!0));
        break;
    }
  }, [i]);
}, ys = (e, t, a) => {
  const [o, r] = x(""), { isMessageByCurrentUser: i, isLastMessageVisible: s, messages: c } = e;
  A(() => {
    const { id: l } = Jo(c, {
      id: ""
    });
    s && l ? r(l) : i || a(
      t(
        Ti(
          c,
          o
        )
      )
    );
  }, [
    c,
    s,
    o,
    i,
    t,
    a
  ]);
}, QE = ({
  currentUserId: e,
  messages: t,
  sendMessage: a,
  selectedChatType: o,
  participantInDirectChatWith: r
}) => {
  const i = ee(null), s = (v, E) => {
    const C = v.trim();
    C && a(C, E);
  }, [
    { isLastMessageVisible: c, displayNewMessageToast: l, newMessagesCount: d },
    m
  ] = ws(), p = Pi(
    t,
    e
  ), g = (v) => {
    v.stopPropagation(), m(lo(!1));
  }, f = () => {
    Bs(i?.current) ? m(mo(!0, !1, 0)) : m(Ms(!1));
  };
  return bs(
    {
      isLastMessageVisible: c,
      isMessageByCurrentUser: p,
      messageCount: t.length,
      scrollbarRef: i
    },
    lo,
    m
  ), ys(
    { isLastMessageVisible: c, isMessageByCurrentUser: p, messages: t },
    Is,
    m
  ), A(() => {
    m(mo(!0, !1, 0));
  }, [o, r, m]), {
    closeNewChatMessage: g,
    displayNewMessageToast: l,
    isLastMessageVisible: c,
    newMessagesCount: d,
    onScroll: f,
    scrollbarRef: i,
    handleSubmit: s
  };
}, Bs = Ni(
  fi
), ks = {
  isLastMessageVisible: !0,
  displayNewMessageToast: !1,
  newMessagesCount: 0
}, ws = () => Go(xs, ks), xs = (e, t) => t.type === "set-last-message-visible" ? {
  ...e,
  isLastMessageVisible: t.isLastMessageVisible
} : t.type === "set-display-new-message-toast" ? {
  ...e,
  displayNewMessageToast: t.displayNewMessageToast
} : t.type === "update-new-message-count" ? {
  ...e,
  newMessagesCount: t.newMessagesCount
} : t.type === "update-last-message-visible" ? {
  ...e,
  isLastMessageVisible: t.isLastMessageVisible,
  displayNewMessageToast: t.displayNewMessageToast,
  newMessagesCount: t.newMessagesCount
} : e, Ms = (e) => ({
  type: "set-last-message-visible",
  isLastMessageVisible: e
}), lo = (e) => ({
  type: "set-display-new-message-toast",
  displayNewMessageToast: e
}), Is = (e) => ({
  type: "update-new-message-count",
  newMessagesCount: e
}), mo = (e, t, a) => ({
  type: "update-last-message-visible",
  isLastMessageVisible: e,
  displayNewMessageToast: t,
  newMessagesCount: a
}), Ke = (e) => "dir" in e ? e.dir(e.language) : "ltr", Ss = 55, Ps = Ss + Te, Ns = 82, Ts = Te + Ns + Te, Rs = Te, zs = (e) => e.desktopToolbar || e.header || e.footer, Ws = (e) => {
  const [t, a] = x({
    desktopToolbar: !1,
    header: !1,
    footer: !1
  }), o = nn(), r = Fe(
    () => o ? Ts : Rs,
    [o]
  ), { i18n: i } = y(), s = Ke(i), c = L(
    (l) => {
      if (!e.current) {
        a({
          desktopToolbar: !1,
          header: !1,
          footer: !1
        });
        return;
      }
      if (l) {
        a(l);
        return;
      }
      const d = e.current, m = d.getBoundingClientRect();
      let p = !gt() && d.offsetLeft <= ct + Te;
      s === "rtl" && (p = !gt() && m.right >= window.innerWidth - ct - Te);
      const g = d.offsetTop <= Ps, f = m.bottom >= window.innerHeight - r;
      a({
        desktopToolbar: p,
        header: g,
        footer: f
      });
    },
    [r, e, s]
  );
  return A(() => {
    c();
  }, [c]), { controlsOverlap: t, update: c };
}, qn = (e, { audio: t, video: a }) => {
  const { t: o } = y(), r = Fe(() => {
    const i = t && a ? o(
      "device-status.initial-permissions-not-granted.title",
      "We need your permission to use your camera and microphone"
    ) : t ? o(
      "device-status.initial-permissions-not-granted.title-audioonly",
      "We need your permission to use your microphone"
    ) : a ? o(
      "device-status.initial-permissions-not-granted.title-videoonly",
      "We need your permission to use your camera"
    ) : "";
    return {
      [j.Initial]: {
        title: "",
        message: ""
      },
      [j.InitialPermissionsGranted]: {
        title: o(
          "device-status.initial-permissions-granted.title",
          "Permissions granted"
        ),
        message: o(
          "device-status.initial-permissions-granted.message",
          "You have granted permissions to use your camera and microphone"
        ),
        controls: "media"
      },
      [j.InitialPermissionsVideoInputDenied]: {
        title: o(
          "device-status.initial-permissions-video-input-denied.title",
          "You have not allowed access to your microphone"
        ),
        message: o(
          "device-status.initial-permissions-video-input-denied.message",
          "You have denied permission to use your camera"
        ),
        controls: "media"
      },
      [j.InitialPermissionsAudioInputDenied]: {
        title: o(
          "device-status.videoinput-granted-audioinput-denied.title",
          "You have not allowed access to your microphone"
        ),
        message: o(
          "device-status.videoinput-granted-audioinput-denied.message",
          "Access to your microphone is required if you want others to hear you in the call"
        ),
        controls: "media"
      },
      [j.InitialPermissionsVideoInputGranted]: {
        title: o(
          "device-status.initial-permissions-video-input-granted.title",
          "Permissions partially granted"
        ),
        message: o(
          "device-status.initial-permissions-video-input-granted.message",
          "You have not granted permissions to use your microphone"
        ),
        controls: "media"
      },
      [j.InitialPermissionsAudioInputGranted]: {
        title: o(
          "device-status.initial-permissions-audio-input-granted.title",
          "Permissions partially granted"
        ),
        message: o(
          "device-status.initial-permissions-audio-input-granted.message",
          "You have not granted permissions to use your camera"
        ),
        controls: "media"
      },
      [j.InitialPermissionsGrantedAudioInputDenied]: {
        title: o(
          "device-status.videoinput-granted-audioinput-denied.title",
          "You have not allowed access to your microphone"
        ),
        message: o(
          "device-status.videoinput-granted-audioinput-denied.message",
          "Access to your microphone is required if you want others to hear you in the call"
        ),
        controls: "media"
      },
      [j.InitialPermissionsGrantedVideoInputDenied]: {
        title: o(
          "device-status.audioinput-granted-videoinput-denied.title",
          "You have not allowed access to your camera"
        ),
        message: o(
          "device-status.audioinput-granted-videoinput-denied.message",
          "Access to your camera is required if you want others to see you in the call"
        ),
        controls: "media"
      },
      [j.NoDevicesFound]: {
        title: o(
          "device-status.no-devices-found.title",
          "There’s no connected camera and microphone"
        ),
        message: o(
          "device-status.no-devices-found.message",
          "Your camera and microphone seem to be unavailable. Please check if they are plugged in and set up correctly"
        ),
        controls: "media",
        error: W.Both,
        distinctiveTitles: {
          videoError: {
            title: o(
              "device-status.no-video-devices-found.title",
              "There’s no connected camera"
            ),
            description: o(
              "device-status.no-video-devices-found.message",
              "Your camera seems to be unavailable. Please check if it is plugged in and set up correctly"
            )
          },
          audioError: {
            title: o(
              "device-status.no-audio-devices-found.title",
              "There’s no connected microphone"
            ),
            description: o(
              "device-status.no-audio-devices-found.message",
              "Your microphone seems to be unavailable. Please check if it is plugged in and set up correctly"
            )
          }
        }
      },
      [j.NoVideoDevicesFound]: {
        title: o(
          "device-status.no-video-devices-found.title",
          "There’s no connected camera"
        ),
        message: o(
          "device-status.no-video-devices-found.message",
          "Your camera seems to be unavailable. Please check if it is plugged in and set up correctly"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.NoAudioDevicesFound]: {
        title: o(
          "device-status.no-audio-devices-found.title",
          "There’s no connected microphone"
        ),
        message: o(
          "device-status.no-audio-devices-found.message",
          "Your microphone seems to be unavailable. Please check if it is plugged in and set up correctly"
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.AudioVideoDevicesNotFound]: {
        title: o(
          "device-status.audio-video-devices-not-found.title",
          "We can’t find your camera and microphone"
        ),
        message: o(
          "device-status.audio-video-devices-not-found.message",
          "Your preferred camera and microphone are unavailable"
        ),
        controls: "media",
        error: W.Both,
        distinctiveTitles: {
          videoError: {
            title: o(
              "device-status.video-device-not-found.title",
              "We can’t find your camera"
            ),
            description: o(
              "device-status.video-device-not-found.message",
              "Your preferred camera is unavailable"
            )
          },
          audioError: {
            title: o(
              "device-status.audio-device-not-found.title",
              "We can’t find your microphone"
            ),
            description: o(
              "device-status.audio-device-not-found.message",
              "Your preferred microphone is unavailable"
            )
          }
        }
      },
      [j.VideoDeviceNotFound]: {
        title: o(
          "device-status.video-device-not-found.title",
          "We can’t find your camera"
        ),
        message: o(
          "device-status.video-device-not-found.message",
          "Your preferred camera is unavailable"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.AudioDeviceNotFound]: {
        title: o(
          "device-status.audio-device-not-found.title",
          "We can’t find your microphone"
        ),
        message: o(
          "device-status.audio-device-not-found.message",
          "Your preferred microphone is unavailable"
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.InitialPermissionsNotGranted]: {
        title: i,
        message: /* @__PURE__ */ n.createElement(
          Z,
          {
            i18nKey: "device-status.initial-permissions-not-granted.message",
            t: o
          },
          "Please select ",
          /* @__PURE__ */ n.createElement("strong", null, "Allow"),
          " in the next step when prompted by your browser. We will only have access for the duration of the meeting."
        ),
        controls: "permissions-dismiss"
      },
      [j.PermissionsGranted]: {
        title: "",
        message: "",
        controls: "media"
      },
      [j.PermissionsGrantedFallback]: {
        title: o(
          "device-status.permissions-granted-fallback-devices.title",
          "Unable to use your preferred camera and microphone"
        ),
        message: o(
          "device-status.permissions-granted-fallback-devices.message",
          "We are unable to use your preferred camera and microphone"
        ),
        controls: "media"
      },
      [j.PermissionsGrantedFallbackAudioinput]: {
        title: o(
          "device-status.permissions-granted-fallback-audioinput.title",
          "Unable to use your preferred microphone"
        ),
        message: o(
          "device-status.permissions-granted-fallback-audioinput.message",
          "We are unable to use your preferred microphone"
        ),
        controls: "media"
      },
      [j.PermissionsGrantedFallbackVideoinput]: {
        title: o(
          "device-status.permissions-granted-fallback-videoinput.title",
          "Unable to use your preferred camera"
        ),
        message: o(
          "device-status.permissions-granted-fallback-videoinput.message",
          "We are unable to use your preferred camera"
        ),
        controls: "media"
      },
      [j.PermissionsRejected]: {
        title: o(
          "device-status.permissions-rejected.title",
          "Did you mean to block access to your camera or microphone?"
        ),
        message: o(
          "device-status.permissions-rejected.message",
          "You blocked access to your camera or microphone. To grant access follow the steps in this short video"
        ),
        controls: "permissions",
        error: W.Both,
        distinctiveTitles: {
          videoError: {
            title: o(
              "device-status.permissions-rejected-videoinput.title",
              "Camera permission not granted"
            ),
            description: o(
              "device-status.permissions-rejected-videoinput.message",
              "You have previously denied permission to use your camera. To grant access follow the steps in this short video"
            )
          },
          audioError: {
            title: o(
              "device-status.permissions-rejected-audioinput.title",
              "Microphone permission not granted"
            ),
            description: o(
              "device-status.permissions-rejected-audioinput.message",
              "You have previously denied permission to use your microphone. To grant access follow the steps in this short video"
            )
          }
        }
      },
      [j.PermissionsRejectedVideoInput]: {
        title: o(
          "device-status.permissions-rejected-videoinput.title",
          "Camera permission not granted"
        ),
        message: o(
          "device-status.permissions-rejected-videoinput.message",
          "You have denied permission to use your camera. It will not be available for this meeting"
        ),
        controls: "permissions",
        error: W.Camera
      },
      [j.PermissionsRejectedAudioInput]: {
        title: o(
          "device-status.permissions-rejected-audioinput.title",
          "Microphone permission not granted"
        ),
        message: o(
          "device-status.permissions-rejected-audioinput.message",
          "You have denied permission to use your microphone. It will not be available for this meeting"
        ),
        controls: "permissions",
        error: W.Microphone
      },
      [j.PermissionsOnlyAudioinput]: {
        title: o(
          "device-status.permissions-only-audioinput.title",
          "Camera inactive"
        ),
        message: o(
          "device-status.permissions-only-audioinput.message",
          "You have previously denied permission to use your camera. To grant access follow the steps in this short video"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.PermissionsOnlyAudioinputNoVideoDevices]: {
        title: o(
          "device-status.permissions-only-audioinput-no-video-devices.title",
          "Your camera seems to be unavailable"
        ),
        message: o(
          "device-status.permissions-only-audioinput-no-video-devices.message",
          "Please check if it is plugged in and set up correctly"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.PermissionsOnlyAudioinputFallback]: {
        title: o(
          "device-status.permissions-only-fallback-audioinput.title",
          "Camera and preferred microphone are unavailable"
        ),
        message: o(
          "device-status.permissions-only-fallback-audioinput.message",
          "We can't use any camera, and your preferred microphone is unavailable"
        ),
        controls: "media"
      },
      [j.PermissionsOnlyAudioinputFallbackNoVideoDevices]: {
        title: o(
          "device-status.permissions-only-fallback-audioinput-no-video-devices.title",
          "No camera available and preferred microphone is unavailable"
        ),
        message: o(
          "device-status.permissions-only-fallback-audioinput-no-video-devices.message",
          "We can't find any camera, and your preferred microphone is unavailable"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.PermissionsOnlyVideoinput]: {
        title: o(
          "device-status.permissions-only-videoinput.title",
          "Microphone inactive"
        ),
        message: o(
          "device-status.permissions-only-videoinput.message",
          "You have previously denied permission to use your microphone. To grant access follow the steps in this short video"
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.PermissionsOnlyVideoinputNoAudioDevices]: {
        title: o(
          "device-status.permissions-only-videoinput-no-audio-devices.title",
          "Your microphone seems to be unavailable"
        ),
        message: o(
          "device-status.permissions-only-videoinput-no-audio-devices.message",
          "Please check if it is plugged in and set up correctly"
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.PermissionsOnlyVideoinputFallback]: {
        title: o(
          "device-status.permissions-only-fallback-videoinput.title",
          "Microphone and preferred camera are unavailable"
        ),
        message: o(
          "device-status.permissions-only-fallback-videoinput.message",
          "We can't use any microphone, and your preferred camera is unavailable"
        ),
        controls: "media"
      },
      [j.PermissionsOnlyVideoinputFallbackNoAudioDevices]: {
        title: o(
          "device-status.permissions-only-fallback-videoinput-no-audio-devices.title",
          "No microphone and preferred camera is unavailable"
        ),
        message: o(
          "device-status.permissions-only-fallback-videoinput-no-audio-devices.message",
          "We can't find any microphone, and your preferred camera is unavailable"
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.DevicesInUse]: {
        title: o(
          "device-status.devices-in-use.title",
          "Camera and microphone unavailable"
        ),
        message: o(
          "device-status.devices-in-use.message",
          "Another application (e.g. Teams or Slack) is using your camera. To use it on Pexip, please find that application and turn it off"
        ),
        retriable: !0,
        controls: "media",
        error: W.Both,
        distinctiveTitles: {
          videoError: {
            title: o(
              "device-status.video-device-in-use.title",
              "Camera unavailable"
            ),
            description: o(
              "device-status.video-device-in-use.message",
              "Another application (e.g. Teams or Slack) is using your camera. To use it on Pexip, please find that application and turn it off"
            )
          },
          audioError: {
            title: o(
              "device-status.audio-device-in-use.title",
              "Microphone unavailable"
            ),
            description: o(
              "device-status.audio-device-in-use.message",
              "Another application (e.g. Teams or Slack) is using your microphone. To use it here, please find that application and turn it off"
            )
          }
        }
      },
      [j.VideoDeviceInUse]: {
        title: o(
          "device-status.video-device-in-use.title",
          "Camera unavailable"
        ),
        retriable: !0,
        message: o(
          "device-status.video-device-in-use.message",
          "Another application (e.g. Teams or Slack) is using your camera. To use it on Pexip, please find that application and turn it off"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.AudioDeviceInUse]: {
        title: o(
          "device-status.audio-device-in-use.title",
          "Microphone unavailable"
        ),
        retriable: !0,
        message: o(
          "device-status.audio-device-in-use.message",
          "Another application (e.g. Teams or Slack) is using your microphone. To use it here, please find that application and turn it off"
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.InvalidConstraints]: {
        title: o(
          "device-status.invalid-constraints.title",
          "Camera and microphone are not configured properly"
        ),
        message: o(
          "device-status.invalid-constraints.message",
          "Try clearing your browser cache"
        ),
        controls: "media",
        error: W.Both,
        distinctiveTitles: {
          videoError: {
            title: o(
              "device-status.invalid-video-constraints.title",
              "Camera is not configured properly"
            ),
            description: o(
              "device-status.invalid-video-constraints.message",
              "Try clearing your browser cache"
            )
          },
          audioError: {
            title: o(
              "device-status.invalid-audio-constraints.title",
              "Microphone is not configured properly"
            ),
            description: o(
              "device-status.invalid-audio-constraints.message",
              "Try clearing your browser cache"
            )
          }
        }
      },
      [j.InvalidVideoConstraints]: {
        title: o(
          "device-status.invalid-video-constraints.title",
          "Camera is not configured properly"
        ),
        message: o(
          "device-status.invalid-video-constraints.message",
          "Try clearing your browser cache"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.InvalidAudioConstraints]: {
        title: o(
          "device-status.invalid-audio-constraints.title",
          "Microphone is not configured properly"
        ),
        message: o(
          "device-status.invalid-audio-constraints.message",
          "Try clearing your browser cache"
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.Overconstrained]: {
        title: o(
          "device-status.overconstrained.title",
          "Camera and microphone are overly constrained"
        ),
        message: o(
          "device-status.overconstrained.message",
          "Try lowering your quality settings"
        ),
        controls: "media",
        error: W.Both,
        distinctiveTitles: {
          videoError: {
            title: o(
              "device-status.video-overconstrained.title",
              "Camera is overly constrained"
            ),
            description: o(
              "device-status.video-overconstrained.message",
              "Try lowering your quality settings"
            )
          },
          audioError: {
            title: o(
              "device-status.audio-overconstrained.title",
              "Microphone is overly constrained"
            ),
            description: o(
              "device-status.audio-overconstrained.message",
              "Try lowering your quality settings"
            )
          }
        }
      },
      [j.VideoOverconstrained]: {
        title: o(
          "device-status.video-overconstrained.title",
          "Camera is overly constrained"
        ),
        message: o(
          "device-status.video-overconstrained.message",
          "Try lowering your quality settings"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.AudioOverconstrained]: {
        title: o(
          "device-status.audio-overconstrained.title",
          "Microphone is overly constrained"
        ),
        message: o(
          "device-status.audio-overconstrained.message",
          "Try lowering your quality settings"
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.NotSupportedError]: {
        title: o(
          "device-status.not-supported-error.title",
          "Browser does not support"
        ),
        message: o(
          "device-status.not-supported-error.message",
          "We can't get media from your browser. Try to use another modern browser."
        ),
        controls: "media",
        error: W.Both,
        distinctiveTitles: {
          videoError: {
            title: o(
              "device-status.not-supported-error-only-audio.title",
              "Browser does not support"
            ),
            description: o(
              "device-status.not-supported-error-only-audio.message",
              "We can't get media from your browser. Try to use another modern browser."
            )
          },
          audioError: {
            title: o(
              "device-status.not-supported-error-only-video.title",
              "Browser does not support"
            ),
            description: o(
              "device-status.not-supported-error-only-video.message",
              "We can't get media from your browser. Try to use another modern browser."
            )
          }
        }
      },
      [j.NotSupportedErrorOnlyAudioInput]: {
        title: o(
          "device-status.not-supported-error-only-audio.title",
          "Browser does not support"
        ),
        message: o(
          "device-status.not-supported-error-only-audio.message",
          "We can't get media from your browser. Try to use another modern browser."
        ),
        controls: "media",
        error: W.Microphone
      },
      [j.NotSupportedErrorOnlyVideoInput]: {
        title: o(
          "device-status.not-supported-error-only-video.title",
          "Browser does not support"
        ),
        message: o(
          "device-status.not-supported-error-only-video.message",
          "We can't get media from your browser. Try to use another modern browser."
        ),
        controls: "media",
        error: W.Camera
      },
      [j.UnknownError]: {
        title: o(
          "device-status.unknown-error.title",
          "Camera and microphone unavailable"
        ),
        message: o(
          "device-status.unknown-error.message",
          "We are not able to get media from your devices. Try to reconnect your devices or use different ones"
        ),
        controls: "media",
        error: W.Both,
        distinctiveTitles: {
          videoError: {
            title: o(
              "device-status.unknown-error-only-audioinput.title",
              "Camera unavailable"
            ),
            description: o(
              "device-status.unknown-error-only-audioinput.message",
              "We are not able to use your camera. Try to reconnect your device or use a different one"
            )
          },
          audioError: {
            title: o(
              "device-status.unknown-error-only-videoinput.title",
              "Microphone unavailable"
            ),
            description: o(
              "device-status.unknown-error-only-videoinput.message",
              "We are not able to use your microphone. Try to reconnect your device or use a different one"
            )
          }
        }
      },
      [j.UnknownErrorOnlyAudioinput]: {
        title: o(
          "device-status.unknown-error-only-audioinput.title",
          "Camera unavailable"
        ),
        message: o(
          "device-status.unknown-error-only-audioinput.message",
          "We are not able to use your camera. Try to reconnect your device or use a different one"
        ),
        controls: "media",
        error: W.Camera
      },
      [j.UnknownErrorOnlyVideoinput]: {
        title: o(
          "device-status.unknown-error-only-videoinput.title",
          "Microphone unavailable"
        ),
        message: o(
          "device-status.unknown-error-only-videoinput.message",
          "We are not able to use your microphone. Try to reconnect your device or use a different one"
        ),
        controls: "media",
        error: W.Microphone
      }
    };
  }, [o, t, a]);
  return e ? r[e] : {
    title: "",
    message: ""
  };
}, Ls = () => {
  const [e, t] = x({
    title: ""
  }), [a, o] = x({
    title: ""
  });
  return {
    videoInputError: e,
    setVideoInputError: t,
    audioInputError: a,
    setAudioInputError: o
  };
}, Fs = (e, t, a) => {
  const { t: o } = y(), r = o(
    "media.error.unable-to-use.audio",
    "Cannot use audio input device. Please select another one."
  ), i = o(
    "media.error.unable-to-use.video",
    "Cannot use video input device. Please select another one."
  );
  A(() => a?.onAudioInputError(() => {
    e({
      title: r
    });
  }), [a, e, r]), A(() => a?.onVideoInputError(() => {
    t({
      title: i
    });
  }), [a, t, i]);
}, Qs = (e, t = {
  videoError: {
    title: "",
    description: ""
  },
  audioError: {
    title: "",
    description: ""
  }
}) => {
  const { videoError: a, audioError: o } = t;
  return e.distinctiveTitles ? (a.title = e.distinctiveTitles.videoError.title, a.description = e.distinctiveTitles.videoError.description, o.title = e.distinctiveTitles.audioError.title, o.description = e.distinctiveTitles.audioError.description) : e.error === W.Camera ? (a.title = e.title, a.description = e.message) : e.error === W.Microphone && (o.title = e.title, o.description = e.message), { videoError: a, audioError: o };
}, As = /* @__PURE__ */ new Map([
  [j.PermissionsRejected, W.Both],
  [j.PermissionsRejectedAudioInput, W.Microphone],
  [j.PermissionsRejectedVideoInput, W.Camera],
  [j.PermissionsOnlyAudioinput, W.Camera],
  [j.PermissionsOnlyAudioinputFallback, W.Camera],
  [j.PermissionsOnlyVideoinput, W.Microphone],
  [
    j.PermissionsOnlyVideoinputFallback,
    W.Microphone
  ]
]), Vs = (e) => (t) => {
  const { videoError: a, audioError: o } = t;
  switch (As.get(e)) {
    case W.Microphone:
      o.deniedDevice = W.Microphone;
      break;
    case W.Camera:
      a.deniedDevice = W.Camera;
      break;
    case W.Both:
      o.deniedDevice = W.Both, a.deniedDevice = W.Both;
      break;
  }
  return { videoError: a, audioError: o };
}, Os = (e, t, a) => (o) => {
  const { videoError: r, audioError: i } = o, s = () => a(r), c = () => t(i), l = {
    [W.Microphone]: c,
    [W.Camera]: s,
    [W.Both]: () => {
      c(), s();
    }
  };
  if (e.error)
    return l[e.error];
}, Ds = ({
  setAudioInputError: e,
  setVideoInputError: t,
  streamStatus: a,
  requested: o
}) => {
  const r = qn(a, {
    audio: o.audio,
    video: o.video
  });
  A(() => {
    const i = cr(
      Qs,
      Vs(a)
    ), { videoError: s, audioError: c } = i(r);
    return Os(
      r,
      e,
      t
    )({ videoError: s, audioError: c })?.(), () => {
      e({
        title: ""
      }), t({
        title: ""
      });
    };
  }, [
    r,
    e,
    t,
    a
  ]);
}, AE = (e, t) => {
  const { t: a } = y();
  At(
    () => e((o) => {
      if (o?.status && dr(o.status)) {
        const r = a("media.input.connector", " and "), i = [
          {
            originalDeviceName: o.expectedVideoInput?.label,
            fallbackDeviceName: o.videoInput?.label,
            deviceType: a("media.input.video", "camera"),
            fallback: mr(o.status) && o.expectedVideoInput?.label !== o.videoInput?.label
          },
          {
            originalDeviceName: o.expectedAudioInput?.label,
            fallbackDeviceName: o.audioInput?.label,
            deviceType: a("media.input.audio", "microphone"),
            fallback: ur(o.status) && o.expectedAudioInput?.label !== o.audioInput?.label
          }
        ].reduce(
          (c, l) => {
            if (l.fallback)
              for (const d of Object.keys(c)) {
                const m = d, p = l[m];
                p && (c[m] = [
                  c[m],
                  m !== "deviceType" ? `'${p}'` : p
                ].filter(Boolean).join(r));
              }
            return c;
          },
          {
            originalDeviceName: "",
            fallbackDeviceName: "",
            deviceType: ""
          }
        );
        if (!i.fallbackDeviceName || !i.originalDeviceName || !i.deviceType)
          return;
        const s = a("media.input.fallback-video", {
          defaultValue: "We couldn't use {{originalDeviceName}} so we switched your {{deviceType}} to {{fallbackDeviceName}}",
          ...i
        });
        t(s);
      }
    }),
    [e, t, a]
  );
}, Ft = ss(), js = (e) => L(
  (t, a) => {
    Ft.setMeetingUIState({
      ...Ft.currentState,
      [a]: t
    }), e(Ft.shouldEnableAutoHide());
  },
  [e]
), Ys = (e, t, a) => {
  A(() => {
    e(t, ma.openedPanel);
  }, [t, e]), A(
    () => a.add((o) => {
      e(o.isOpen, o.type);
    }),
    [a, e]
  );
}, Hs = (e, t) => {
  const a = (o) => e(o, "focusedButton");
  return ee({
    onMouseEnter: t ? void 0 : () => a(!0),
    onFocus: () => t ? void 0 : a(!0),
    onMouseLeave: t ? void 0 : () => a(!1),
    onBlur: () => t ? void 0 : a(!1)
  }).current;
}, Zs = (e, t, a) => {
  const o = js(t), [r, i] = x(
    Ft.uiVisibilityState === "visible"
  ), s = nn(), c = Hs(
    o,
    s
  );
  return Ys(
    o,
    e,
    a
  ), A(
    () => yr.add((l) => {
      i(l === "visible"), Ft.setUIVisibilityState(l);
    }),
    []
  ), { autoHideProps: c, isAutoHideUIVisible: r };
}, VE = (e) => ({
  isStreamReady: t,
  isAutoHideUiControlsDisabledByConfig: a,
  toggleConfirm: o
}) => {
  const {
    enableInMeetingUIAutoHide: r,
    useAutoHideUIInterfaces: i,
    useFullscreenApi: s,
    togglePanel: c
  } = e, [l, d] = x({
    openBreakoutRoomsPanel: !1,
    openChatPanel: !1,
    openParticipantPanel: !1,
    openAddParticipant: !1,
    openPluginsPanel: !1,
    openTranscriptsPanel: !1,
    openMeetingManagerRaisedHand: !0,
    openMeetingManagerWaitingInLobby: !0,
    openMeetingManagerPlugins: !1,
    openMeetingManagerBreakoutRooms: !0,
    openMeetingManagerBreakoutRoomsAskingForHelp: !0,
    animationType: $t.NONE
  }), m = L(
    (w) => {
      d((M) => ({
        ...M,
        [w]: !M[w]
      }));
    },
    []
  ), p = L(
    (w) => {
      switch (w) {
        case "add":
          m(
            "openAddParticipant"
          );
          return;
        case "meetingManagerRaisedHand":
          m(
            "openMeetingManagerRaisedHand"
          );
          return;
        case "meetingManagerWaitingInLobby":
          m(
            "openMeetingManagerWaitingInLobby"
          );
          return;
        case "meetingManagerPlugins":
          m(
            "openMeetingManagerPlugins"
          );
          return;
        case "meetingManagerBreakoutRooms":
          m(
            "openMeetingManagerBreakoutRooms"
          );
          return;
        case "meetingManagerBreakoutRoomsAskingForHelp":
          m(
            "openMeetingManagerBreakoutRoomsAskingForHelp"
          );
          return;
      }
      d((M) => {
        const [P, T] = c(w)(M);
        return {
          ...{
            openAddParticipant: M.openAddParticipant,
            openMeetingManagerRaisedHand: M.openMeetingManagerRaisedHand,
            openMeetingManagerWaitingInLobby: M.openMeetingManagerWaitingInLobby,
            openMeetingManagerPlugins: M.openMeetingManagerPlugins,
            openMeetingManagerBreakoutRooms: M.openMeetingManagerBreakoutRooms,
            openMeetingManagerBreakoutRoomsAskingForHelp: M.openMeetingManagerBreakoutRoomsAskingForHelp,
            openBreakoutRoomsPanel: w === "breakoutRooms" && P,
            openChatPanel: w === "chat" && P,
            openParticipantPanel: w === "participants" && P,
            openPluginsPanel: w === "plugins" && P,
            openTranscriptsPanel: w === "transcripts" && P
          },
          animationType: T
        };
      });
    },
    [c, m]
  ), g = L(
    (w) => {
      let M;
      if (l.openBreakoutRoomsPanel ? M = "breakoutRooms" : l.openChatPanel ? M = "chat" : l.openAddParticipant ? M = "participants" : l.openPluginsPanel ? M = "plugins" : l.openTranscriptsPanel && (M = "transcripts"), M && o?.[M]) {
        o[M](
          () => p(w)
        );
        return;
      }
      p(w);
    },
    [
      l.openAddParticipant,
      l.openBreakoutRoomsPanel,
      l.openChatPanel,
      l.openPluginsPanel,
      l.openTranscriptsPanel,
      o,
      p
    ]
  ), { enableAutoHide: f } = i(
    t,
    a
  ), v = l.openParticipantPanel || l.openChatPanel || l.openBreakoutRoomsPanel || l.openPluginsPanel || l.openTranscriptsPanel, { autoHideProps: E, isAutoHideUIVisible: C } = Zs(
    v,
    f,
    r
  ), B = s();
  return A(
    () => () => {
      Br(B.fullscreenElement) && B.exitFullscreen?.();
    },
    [B]
  ), {
    autoHideProps: E,
    panelsState: l,
    showSidePanel: v,
    togglePanels: g,
    isAutoHideUIVisible: C
  };
}, Gs = ({
  isAudioInputMuted: e,
  isVideoInputMuted: t,
  inputStatusInfo: a,
  iconSize: o
}) => {
  const { t: r } = y(), i = a.warning, s = W.Microphone === a.error, c = W.Camera === a.error, l = W.Both === a.error, d = l || s || e, m = l || c || t, p = d ? r("media.unmute-microphone", "Unmute microphone") : r("media.mute-microphone", "Mute microphone"), g = m ? r("media.turn-camera-on", "Turn camera on") : r("media.turn-camera-off", "Turn camera off");
  return {
    audioProps: {
      hasError: s,
      hasAudioVideoError: l,
      isActive: e,
      "aria-label": p,
      icon: d ? /* @__PURE__ */ n.createElement(F, { source: k.IconMicrophoneOff, size: o }) : /* @__PURE__ */ n.createElement(F, { source: k.IconMicrophoneOn, size: o })
    },
    videoProps: {
      hasError: c,
      hasAudioVideoError: l,
      isActive: t,
      "aria-label": g,
      icon: m ? /* @__PURE__ */ n.createElement(F, { source: k.IconVideoOff, size: o }) : /* @__PURE__ */ n.createElement(F, { source: k.IconVideoOn, size: o })
    },
    warning: i,
    isAudioIconMuted: d,
    isVideoIconMuted: m
  };
}, OE = (e, t) => {
  A(() => {
    e.tryAndGetUserMedia({ audio: !0, video: !0 });
    const a = t((o) => {
      const r = o.size("audioinput") > 0, i = o.size("videoinput") > 0;
      // Avoid double GUM requests
      !(e.updatingAudio || e.updatingVideo) && e.media?.status && !pr(e.media?.status) && (r || i) && e.getUserMedia({
        audio: r,
        video: i
      });
    });
    return () => {
      ve.debug("Media cleanup"), a(), e.media?.release().catch((o) => {
        ve.error({ error: o }, "GUM cleanup failed");
      });
    };
  }, [t, e]);
}, DE = (e) => {
  const t = ie(
    (o) => (e?.stream.addEventListener("addtrack", o), e?.stream.addEventListener("removetrack", o), () => {
      e?.stream.removeEventListener("addtrack", o), e?.stream.removeEventListener("removetrack", o);
    }),
    () => e?.audioInput
  );
  return { selectedVideoInput: ie(
    (o) => (e?.stream.addEventListener("addtrack", o), e?.stream.addEventListener("removetrack", o), () => {
      e?.stream.removeEventListener("addtrack", o), e?.stream.removeEventListener("removetrack", o);
    }),
    () => e?.videoInput
  ), selectedAudioInput: t };
}, Js = (e) => ie(
  e.subscribe,
  e.initial
), jE = (e) => Object.keys(e).reduce(
  (t, a) => {
    const o = a, r = e[o];
    return r && (t[o] = () => Js(r)), t;
  },
  {}
), YE = ({
  expandPrimaryVideo: e,
  isPresenting: t,
  isPresentationPoppedOut: a,
  presentationEmphasis: o,
  setEmphasis: r
}) => {
  const i = Xo(), [s, c] = x(!1), [l, d] = x(!1), [m, p] = x(X.None), [g, f] = x(
    X.None
  ), v = ee(null), E = ee(null);
  A(() => {
    t ? a ? (p(X.Expanded), f(X.External)) : s ? (p(X.BrowserPip), f(X.Expanded)) : l ? (p(X.Expanded), f(X.BrowserPip)) : e && o === De.Primary ? (p(X.Pip), f(X.Expanded)) : e && o === De.Secondary ? (p(X.Expanded), f(X.Pip)) : !e && o === De.Secondary ? (p(X.Emphasized), f(X.Deemphasized)) : (p(X.Deemphasized), f(X.Emphasized)) : p(X.Expanded);
  }, [
    s,
    l,
    t,
    a,
    e,
    o
  ]);
  const C = L(async () => {
    await uo(m, () => {
      r(De.Secondary);
    });
  }, [m, r]), B = L(async () => {
    await uo(g, () => {
      r(De.Primary);
    });
  }, [g, r]);
  return {
    meetingStreamStatus: m,
    presoStreamStatus: g,
    setIsMeetingVideoBrowserPip: c,
    setIsPresentationBrowserPip: d,
    handleMeetingVideoClick: C,
    handlePresentationVideoClick: B,
    mainOnKeyDown: (P) => {
      P.key === ht.enter && (m === X.Emphasized || m === X.Expanded ? i() : C().then(() => {
        E.current?.focus();
      }));
    },
    presentationOnKeyDown: (P) => {
      P.key === ht.enter && (g === X.Emphasized || g === X.Expanded ? i() : B().then(
        () => v.current?.focus()
      ));
    },
    mainVideoComponentRef: v,
    presentationVideoComponentRef: E
  };
}, uo = async (e, t) => {
  if (e === X.Deemphasized || e === X.Pip)
    return t(), Promise.resolve();
}, Us = 2e3, HE = (e, t) => {
  const [a, o] = x(ue.Connected);
  return A(() => {
    let r;
    const i = [
      e.add(() => {
        clearTimeout(r), o(ue.Reconnecting);
      }),
      t.add(() => {
        o(ue.Reconnected), r = setTimeout(() => {
          o(ue.Connected);
        }, Us);
      })
    ];
    return () => {
      for (const s of i)
        s();
      clearTimeout(r);
    };
  }, [e, t]), a;
}, ZE = (e) => {
  const [t, a] = x(
    Ue.Spinner
  );
  return A(() => {
    e && (hr(e) || Uo(e)) ? a(
      Ue.BlockedDeviceSelection
    ) : a(
      Ue.DeviceSelection
    );
  }, [e]), [t, a];
}, qs = () => {
  const e = ee(null), [t, a] = x(!1);
  return {
    isPresentationPoppedOut: t,
    remotePopOutRef: e,
    setIsPresentationPoppedOut: a,
    toggleIsPresentationPoppedOut: () => {
      let r;
      t || (r = window.open("", "", "width=848,height=480"), r && (e.current = r)), a((i) => !i);
    }
  };
}, Xs = (e, t) => {
  switch (t.type) {
    case de.SetLocalMediaStream:
      return {
        ...e,
        localMediaStream: t.mediaStream
      };
    case de.SetRemoteMediaStream:
      return {
        ...e,
        remoteMediaStream: t.mediaStream
      };
    case de.SetEmphasis:
      return {
        ...e,
        emphasis: t.emphasis
      };
    case de.SetExpandPrimary:
      return {
        ...e,
        expandPrimary: t.expandPrimary
      };
    case de.SetShowSteal:
      return {
        ...e,
        showSteal: t.showSteal
      };
    case de.SetSize:
      return {
        ...e,
        size: t.size
      };
    case de.SetPresenterName:
      return {
        ...e,
        presenterName: t.presenterName
      };
    case de.ActivityChange: {
      const a = e.activity?.send, o = t.activity.send, r = e.activity?.recv, i = t.activity.recv;
      if (o) {
        let s = e.remoteMediaStream;
        return !i && r && (s = void 0), {
          ...e,
          emphasis: De.Secondary,
          size: Sn.Large,
          remoteMediaStream: s,
          activity: t.activity
        };
      }
      if (i) {
        let s = e.localMediaStream;
        return !o && a && (s = void 0), {
          ...e,
          emphasis: De.Primary,
          size: Sn.Large,
          localMediaStream: s,
          activity: t.activity
        };
      }
      return {
        emphasis: void 0,
        expandPrimary: void 0,
        showSteal: void 0,
        size: void 0,
        localMediaStream: void 0,
        remoteMediaStream: void 0,
        activity: void 0,
        presenterName: void 0
      };
    }
    default:
      throw new Error(
        `${t} not implemented in Presentation.reducer`
      );
  }
}, po = (e) => e === "connecting" || e === "connected", GE = ({
  getPresentationCapability: e,
  handlaGetDisplayMediaError: t,
  handleGetDisplayMedia: a,
  isCallRestarting: o,
  present: r,
  presentationConnectionStateChangeSignal: i,
  presentationPresenterNameSignal: s,
  presentationReceiveStreamSignal: c,
  stopPresentation: l
}) => {
  const [
    {
      activity: d,
      emphasis: m,
      expandPrimary: p,
      showSteal: g,
      size: f,
      localMediaStream: v,
      remoteMediaStream: E,
      presenterName: C
    },
    B
  ] = Go(Xs, {}), { send: w, recv: M } = e(), P = M && !!d?.recv, T = w && !!d?.send, R = P || T, O = p ?? !1, G = g ?? !1, Y = L(
    (I) => {
      if (I) {
        ve.debug({ mediaStream: I }, "Presentation stream acquired");
        for (const z of I.getVideoTracks())
          z.addEventListener("ended", () => {
            ve.debug("Track ended. Stop presentation."), l();
          });
        r(I), B({
          type: de.SetLocalMediaStream,
          mediaStream: I
        });
      }
    },
    [r, l]
  ), J = L(
    (I) => B({ type: de.SetEmphasis, emphasis: I }),
    []
  ), _ = L(
    (I) => B({ type: de.SetSize, size: I }),
    []
  ), U = L((I) => {
    B({
      type: de.SetExpandPrimary,
      expandPrimary: I
    });
  }, []), H = L((I) => {
    B({ type: de.SetShowSteal, showSteal: I });
  }, []), q = L(
    async (I) => {
      if (I)
        Y(I);
      else
        try {
          const z = await a();
          z && Y(z);
        } catch (z) {
          t && z instanceof Error ? t(z) : ve.error({ error: z }, "Can't start presentation");
        }
    },
    [
      a,
      Y,
      t
    ]
  ), te = L(() => {
    P ? H(!0) : q();
  }, [P, H, q]);
  A(
    () => c.add((I) => {
      B({
        type: de.SetRemoteMediaStream,
        mediaStream: I
      });
    }),
    [c]
  ), A(
    () => s?.add((I) => {
      B({
        type: de.SetPresenterName,
        presenterName: I
      });
    }),
    [s]
  ), A(
    () => i.add(({ send: I, recv: z }) => {
      if (o?.())
        return;
      const Q = po(I), ne = po(z);
      B({
        type: de.ActivityChange,
        activity: {
          send: Q,
          recv: ne
        }
      });
    }),
    [o, i]
  );
  const V = qs();
  return {
    emphasis: m,
    isPrimaryExpanded: O,
    isShowSteal: G,
    isPresenting: R,
    size: f,
    localIsPresenting: T,
    localMediaStream: v,
    remoteIsPresenting: P,
    remoteMediaStream: E,
    activity: d,
    presenterName: C,
    handlePresentationRequest: te,
    setEmphasis: J,
    setExpandPrimary: U,
    setShowSteal: H,
    setSize: _,
    startPresentation: q,
    stopPresentation: l,
    poppedOut: V
  };
}, JE = ({ get: e, set: t }) => () => {
  const [a, o] = x(e), r = L(() => e() !== a ? t(a) : !1, [a, e, t]), i = L(() => e() !== a, [a, e]);
  return { preview: a, setPreview: o, applyChanges: r, hasChanges: i };
}, UE = (e) => {
  const t = ie(
    (a) => e.onUpdatingPreviewAudio(() => a()),
    () => e.media?.getAudioTracks()[0]?.source.track
  );
  return Ci(t);
}, Na = (e, t) => {
  const [a, o] = x(t);
  return A(() => e(o), [e]), [a, o];
}, qE = ({
  get: e,
  getExpected: t,
  set: a
}) => ({
  error: o,
  controller: r,
  setError: i
}) => {
  const [s] = Na(
    r.onAudioInputChanged,
    t()
  ), c = L(() => {
    if (r.audioInput?.deviceId !== e()?.deviceId) {
      const { audioInput: d } = r;
      ve.debug({ audioInput: d }, "Save AudioInput"), a(d);
    }
    return !1;
  }, [r, a, e]), l = Ba(
    i,
    r?.updateAudioInput
  );
  return {
    error: o,
    preview: s,
    applyChanges: c,
    setPreview: l
  };
}, XE = (e) => (t, a) => {
  const [o, r] = x(
    ts(t, a)
  ), i = L(() => (o && o.deviceId !== a?.deviceId && (ve.debug({ audioOutput: o }, "Save AudioOutput"), e(o)), !1), [a?.deviceId, o, e]), s = L(
    () => !!(o && o.deviceId !== a?.deviceId),
    [a?.deviceId, o]
  );
  return {
    preview: o,
    applyChanges: i,
    hasChanges: s,
    setPreview: r
  };
}, KE = (e) => (t) => {
  const [a, o] = x();
  return A(() => {
    if (!t) {
      o((i) => {
        i?.cleanup(), i?.revertChanges();
      });
      return;
    }
    const r = gr(
      e()
    );
    return o(r), () => {
      o(void 0), r.cleanup(), r.revertChanges();
    };
  }, [t, e]), a;
}, Ks = (e) => {
  const [t, a] = x(e.media);
  return At(
    () => e.onMediaChanged((o) => {
      a(o);
    }),
    [e]
  ), t;
}, ho = (e) => !e || e.length === 0 ? !0 : e.some((t) => t.stopped || t.muted) ?? !0, go = (e) => !e || e.length === 0 ? !0 : e.some((t) => t.suspended) ?? !1, _s = (e) => {
  const [t, a] = x(
    e.media?.status ?? j.Initial
  ), [o, r] = x(
    () => ho(e.media?.getVideoTracks())
  ), [i, s] = x(
    () => ho(e.media?.getAudioTracks())
  ), [c, l] = x(
    () => go(e.media?.getAudioTracks())
  ), [d, m] = x(
    () => go(e.media?.getVideoTracks())
  ), [p, g] = x(!1), [f, v] = x(!1), [E, C] = x(
    e.videoInputChanged
  );
  return A(() => {
    const B = [
      e.onUpdatingPreviewVideo((w) => {
        w || (Xt(e.media), a(e.media.status), C(e.videoInputChanged)), v(w);
      }),
      e.onUpdatingPreviewAudio((w) => {
        w || (Xt(e.media), a(e.media.status)), g(w);
      }),
      e.onVideoMuted((w) => {
        r(w ?? !0);
      }),
      e.onAudioMuted((w) => {
        s(w ?? !0);
      }),
      e.onAudioSuspended((w) => {
        l(w ?? !1);
      }),
      e.onVideoSuspended((w) => {
        m(w ?? !1);
      }),
      e.onUpdatingMain(() => {
        C(e.videoInputChanged);
      })
    ];
    return () => {
      for (const w of B)
        w();
      B.length = 0;
    };
  }, [e]), {
    audioMuted: i,
    audioSuspended: c,
    status: t,
    updatingPreviewAudio: p,
    updatingPreviewVideo: f,
    videoInputChanged: E,
    videoMuted: o,
    videoSuspended: d
  };
}, _E = ({
  applyChanges: e,
  close: t,
  controller: a,
  onHandleSave: o
}) => {
  const [r, i] = x(!1), s = Ks(a), {
    audioMuted: c,
    audioSuspended: l,
    status: d,
    updatingPreviewAudio: m,
    updatingPreviewVideo: p,
    videoInputChanged: g,
    videoMuted: f,
    videoSuspended: v
  } = _s(a), E = L(
    async (C) => {
      ve.debug("Handle saving settings modal"), o && o(), i(!0);
      const B = e();
      await a?.applyChanges(B), i(!1), t?.(C);
    },
    [e, t, a, o]
  );
  return {
    audioMuted: c,
    audioSuspended: l,
    handleSave: E,
    isSaving: r,
    previewMedia: s,
    status: d,
    updatingPreviewAudio: m,
    updatingPreviewVideo: p,
    videoInputChanged: g,
    videoMuted: f,
    videoSuspended: v
  };
}, $E = (e, t, a) => {
  const {
    videoInputError: o,
    setVideoInputError: r,
    audioInputError: i,
    setAudioInputError: s
  } = Ls();
  return Fs(
    s,
    r,
    e
  ), Ds({
    setAudioInputError: s,
    setVideoInputError: r,
    streamStatus: t,
    requested: a
  }), {
    videoInputError: o,
    setVideoInputError: r,
    audioInputError: i,
    setAudioInputError: s
  };
}, ev = ({
  get: e,
  getExpected: t,
  set: a
}) => ({
  error: o,
  controller: r,
  setError: i
}) => {
  const [s] = Na(
    r.onVideoInputChanged,
    t()
  ), c = L(() => {
    if (r.videoInput?.deviceId !== e()?.deviceId) {
      const { videoInput: d } = r;
      ve.debug({ videoInput: d }, "Save VideoInput"), a(d);
    }
    return !1;
  }, [r, e, a]), l = Ba(
    i,
    r?.updateVideoInput
  );
  return {
    error: o,
    preview: s,
    applyChanges: c,
    setPreview: l
  };
}, $s = 500, en = (e) => e === "Space" && !["INPUT", "TEXTAREA"].includes(document.activeElement?.tagName || ""), fo = (e) => {
  en(e.code) && e.preventDefault();
}, ec = () => (document.addEventListener("keyup", fo), () => document.removeEventListener("keyup", fo)), tc = (e, t, a) => a && (e(a) || t(a)), nc = (e, t = {
  isMuted: void 0,
  isPressed: !1
}) => {
  ec();
  const a = () => {
    document.removeEventListener("keydown", c), clearTimeout(t.easeMuteTimerId);
  }, o = (l = $s) => {
    t.easeMuteTimerId = window.setTimeout(() => {
      t.isPressed = !1, clearTimeout(t.easeMuteTimerId);
    }, l);
  }, r = () => {
    e.emit(!1), window.removeEventListener("blur", r), document.removeEventListener("keyup", s), o();
  }, i = () => {
    !t.isPressed && t.isMuted?.current === !0 && (t.isPressed = !0, document.addEventListener("keyup", s, {
      once: !0
    }), e.emit(!0), window.addEventListener("blur", r, { once: !0 }));
  }, s = (l) => {
    en(l.code) && r();
  }, c = (l) => {
    en(l.code) && i();
  };
  return document.addEventListener("keydown", c), a;
}, tv = (e, t, a) => ({
  isAudioInputMuted: o,
  setAudioInputMuted: r,
  streamStatus: i,
  onDisabledInteraction: s,
  isPushToTalkDisabled: c
}) => {
  const l = ee(o);
  l.current = o;
  const d = Fe(
    () => tc(
      e,
      t,
      i
    ),
    [i, t, e]
  );
  A(() => {
    if (c)
      return;
    const m = (g) => {
      d && r(!g);
    }, p = a.add(m);
    return () => p();
  }, [
    r,
    a,
    d,
    c
  ]), A(() => {
    const m = (p) => {
      en(p.code) && !p.repeat && s?.();
    };
    return c && s && document.addEventListener("keydown", m), () => {
      document.removeEventListener("keydown", m);
    };
  }, [c, s]), A(() => {
    if (d && !c)
      return nc(a, {
        isMuted: l
      });
  }, [d, a, c]);
}, oc = ({ text: e, source: t = k.IconMicrophoneOn }) => /* @__PURE__ */ n.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ n.createElement(F, { source: t, size: "compact", className: "mr-1" }), " ", /* @__PURE__ */ n.createElement(N, { colorScheme: "light" }, e)), nv = (e) => () => {
  const { t } = y();
  A(
    () => e.add((a) => {
      const o = {
        message: /* @__PURE__ */ n.createElement(
          oc,
          {
            text: t(
              "media.audio.you-are-temporarily-unmuted",
              "You’re temporarily unmuted"
            )
          }
        ),
        testid: u.ToastYouAreTemporarilyUnmuted,
        position: "bottomCenter",
        timeout: 0,
        isInterrupt: !0
      };
      a ? ut.emit([o]) : ut.emit({
        close: !0
      });
    }),
    [t, e]
  );
}, Eo = {
  isOpen: !1,
  userName: "this user",
  description: "",
  onConfirm: void 0
}, ov = (e) => {
  const [{ isOpen: t, userName: a, description: o, onConfirm: r }, i] = x(Eo);
  return A(() => e.add(i), [e]), {
    onConfirm: () => {
      r?.(), i({
        isOpen: !1,
        userName: a,
        onConfirm: r
      });
    },
    onCancel: () => {
      i(Eo);
    },
    description: o,
    userName: a,
    isOpen: t
  };
}, ac = 3e3, av = (e, t) => {
  A(() => {
    const a = setTimeout(() => {
      e(!1);
    }, ac);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]);
}, Ta = (e, t) => t === "ltr" ? Math.floor(e.left) <= Ze : Math.ceil(e.right) >= window.innerWidth - Ze, rc = (e, t, a = !0) => {
  const o = kr(e), r = ee(void 0), i = L((l) => {
    r.current = l;
  }, []), { i18n: s } = y(), c = Ke(s);
  return A(() => {
    if (e !== o && a && t.current) {
      const l = t.current;
      if (e) {
        const d = l.getBoundingClientRect();
        Ta(d, c) && (r.current = d.left, c === "ltr" ? l.style.transform = `translate(${Ze - l.offsetLeft}px)` : l.style.transform = `translate(${window.innerWidth - Ze - d.right}px)`);
      } else
        r.current && (l.style.transform = `translate(${r.current - l.offsetLeft}px)`, r.current = void 0);
    }
  }, [a, t, e, o, c]), i;
}, rv = (e, t) => (a) => {
  const [o, r] = x(!1);
  return A(() => t(() => r(!0)), [t]), A(() => (e(a), () => e(!1)), [a, e]), [o, r];
}, Ra = (e, t) => ba(e, t) ? "portrait" : "landscape", ic = Ra(
  window.innerWidth,
  window.innerHeight
), sc = () => {
  const [e, t] = x(
    ic
  ), a = wr(document.body), o = L(() => {
    t(
      Ra(window.innerWidth, window.innerHeight)
    );
  }, []);
  return A(() => (window.addEventListener("orientationchange", o), () => {
    window.removeEventListener("orientationchange", o);
  }), [o]), A(() => {
    o();
  }, [a, o]), {
    isPortrait: e === "portrait",
    isLandscape: e === "landscape"
  };
}, re = () => bi(Ei), iv = ({
  devices: e,
  currentInput: t,
  requestMedia: a
}) => L(
  (o) => {
    if (!o)
      return a(void 0);
    const r = si(o), [i] = e.get(r);
    t && i && ci(t)(i) || a(i);
  },
  [t, e, a]
), sv = ({
  signals: e,
  muteAudio: t,
  muteVideo: a
}) => {
  const o = es(e), r = En(
    e,
    "audio"
  ), i = En(
    e,
    "video"
  ), s = (V, ...I) => (z) => {
    const Q = (se) => {
      se.kind === V && z();
    }, ne = [
      ...I.map(
        (se) => se.add(Q)
      ),
      En(
        e,
        V === "audioinput" ? "audio" : "video"
      )(z)
    ];
    return () => {
      for (const se of ne)
        se();
      ne.length = 0;
    };
  }, c = s(
    "audioinput",
    e.onMediaTrackMuted,
    e.onMediaTrackStopped
  ), l = s(
    "audioinput",
    e.onMediaTrackSuspended,
    e.onMediaTrackResumed
  ), d = s(
    "videoinput",
    e.onMediaTrackMuted,
    e.onMediaTrackStopped
  ), m = s(
    "videoinput",
    e.onMediaTrackSuspended,
    e.onMediaTrackResumed
  ), p = (V = r) => {
    const I = re();
    return ie(
      V,
      () => I.media?.audioInput
    );
  }, g = (V = i) => {
    const I = re();
    return ie(
      V,
      () => I.media?.videoInput
    );
  }, f = (V = e.onDevicesChanged.add) => {
    const I = re();
    return ie(V, () => I.devices);
  }, v = (V = e.onMediaChanged.add) => {
    const I = re();
    return ie(V, () => I.media?.stream);
  }, E = (V = e.onStatusChanged.add) => {
    const I = re();
    return ie(
      V,
      () => I.media?.status ?? j.Initial
    );
  }, C = (V = c) => {
    const I = re();
    return ie(V, () => {
      const z = I.media?.getAudioTracks();
      return !z || z.length === 0 ? !0 : z.some((Q) => Q.stopped || Q.muted);
    });
  }, B = (V = l) => {
    const I = re();
    return ie(V, () => {
      const z = I.media?.getAudioTracks();
      return !z || z.length === 0 ? !1 : z.some((Q) => Q.suspended);
    });
  }, w = (V = d) => {
    const I = re();
    return ie(V, () => {
      const z = I.media?.getVideoTracks();
      return !z || z.length === 0 ? !0 : z.some((Q) => Q.stopped || Q.muted);
    });
  }, M = (V = m) => {
    const I = re();
    return ie(V, () => {
      const z = I.media?.getVideoTracks();
      return !z || z.length === 0 ? !1 : z.some((Q) => Q.suspended);
    });
  }, P = (V = t) => {
    const I = re();
    return L(
      (z, Q) => {
        I.media?.audioMuted !== void 0 && (I.media.muteAudio(z), V(I.media.audioMuted, Q));
      },
      [I, V]
    );
  }, T = (V = a) => {
    const I = re();
    return L(
      (z, Q) => {
        I.media?.videoMuted !== void 0 && (I.media.muteVideo(z), V(I.media.videoMuted, Q));
      },
      [I, V]
    );
  }, R = (V = t) => {
    const I = re(), z = P(V);
    return L(
      (Q) => {
        I.media?.audioMuted !== void 0 && z(!I.media.audioMuted, Q);
      },
      [I, z]
    );
  }, O = (V = a) => {
    const I = re(), z = T(V);
    return L(
      (Q) => {
        I.media?.videoMuted !== void 0 && z(!I.media.videoMuted, Q);
      },
      [I, z]
    );
  }, G = (V = r) => {
    const I = re();
    return ie(
      V,
      () => I.media?.requestedAudio() ?? !1
    );
  }, Y = (V = i) => {
    const I = re();
    return ie(
      V,
      () => I.media?.requestedVideo() ?? !1
    );
  }, J = (V = r) => {
    const I = re();
    return ie(V, () => I.media?.getAudioTracks().at(0)?.source.track);
  }, _ = (V = i) => {
    const I = re();
    return ie(V, () => I.media?.getVideoTracks().at(0)?.source.track);
  }, U = (V = o) => {
    const I = re();
    return ie(V, () => I.media?.isAudioInputUnavailable() ?? !1);
  }, H = (V = o) => {
    const I = re();
    return ie(V, () => I.media?.isVideoInputUnavailable() ?? !1);
  }, q = () => ({
    audio: G(),
    video: Y()
  });
  return {
    useAudioInput: p,
    useAudioInputUnavailable: U,
    useAudioMuteState: C,
    useAudioSuspended: B,
    useDevices: f,
    useHaveRequestedAudio: G,
    useHaveRequestedMedia: q,
    useHaveRequestedVideo: Y,
    useInputDeviceStatusInfo: () => {
      const V = E(), I = q();
      return qn(V, I);
    },
    useMediaStatus: E,
    useMediaStream: v,
    useMuteAudio: P,
    useMuteVideo: T,
    useSourceAudioTrack: J,
    useSourceVideoTrack: _,
    useToggleAudioMuted: R,
    useToggleVideoMuted: O,
    useVideoInput: g,
    useVideoInputUnavailable: H,
    useVideoMuteState: w,
    useVideoSuspended: M
  };
}, cc = (e, t) => {
  const { t: a } = y();
  return {
    audio: e ? {
      title: a(
        "media.audio-suspended-title",
        "Have you muted your microphone using an external source?"
      ),
      warning: W.Microphone,
      message: a(
        "media.audio-suspended-description",
        "Please check if you have muted yourself using a headset or your browser, and unmute your microphone from there first."
      )
    } : void 0,
    video: t ? {
      title: a(
        "media.video-suspended-title",
        "Have you turned off your camera using an external source?"
      ),
      warning: W.Camera,
      message: a(
        "media.video-suspended-description",
        "Please check if you have turned off your camera with your browser. This may happen if you open a new tab that is using your camera."
      )
    } : void 0
  };
}, lc = "_container_15vkg_74", dc = "_pip_15vkg_80", mc = "_external_15vkg_88", uc = "_emphasized_15vkg_92", pc = "_deemphasized_15vkg_96", hc = "_browserPip_15vkg_102", gc = "_videoWrapper_15vkg_106", fc = "_splashScreen_15vkg_119", Ec = "_expanded_15vkg_123", vc = "_centeredInWideContainer_15vkg_123", Cc = "_overlay_15vkg_131", Ce = {
  container: lc,
  pip: dc,
  external: mc,
  emphasized: uc,
  deemphasized: pc,
  browserPip: hc,
  videoWrapper: gc,
  splashScreen: fc,
  expanded: Ec,
  centeredInWideContainer: vc,
  overlay: Cc
}, bc = (e, t) => e ? t ? u.PresentationPip : u.PresentationFull : t ? u.MeetingVideoPip : u.MeetingVideoFull, Xn = n.forwardRef(
  ({
    mediaStream: e,
    selectedAudioOutputDeviceId: t,
    isPresentation: a = !1,
    status: o,
    isFullHeight: r,
    isFullWidth: i,
    handleVideoClick: s,
    onVideoPlaying: c,
    onPictureInPictureChange: l,
    onDoubleClick: d,
    isContainerWide: m = !1,
    splashScreen: p,
    videoElementId: g,
    tabIndex: f = -1,
    onKeyDown: v,
    ...E
  }, C) => {
    const { t: B } = y(), w = ee(null), [M, P] = x("loading"), T = ee(null);
    nr(C, () => ({
      focus: () => {
        w.current?.focus(), T.current?.focus();
      }
    }));
    const R = o === X.Expanded, O = o === X.External, G = o === X.Pip, Y = bc(a, G);
    A(() => {
      ve.debug(
        { mediaStream: e },
        "Media stream attached to Video component"
      );
    }, [e]);
    const J = L(() => {
      ve.debug("onPlaying callback called"), P(() => (c?.(), "playing"));
    }, [c]), _ = L(() => {
      P("failed");
    }, []), U = L(() => {
      w.current?.resume();
    }, []);
    return /* @__PURE__ */ n.createElement(
      Ko,
      {
        className: b(Ce.videoWrapper, {
          [Ce.centeredInWideContainer]: m,
          [Ce.expanded]: R
        }),
        isFullHeight: r,
        isFullWidth: i,
        borderRadius: O ? "none" : "box",
        onDoubleClick: d,
        background: O ? "black" : "none",
        flexDirection: "row",
        "data-testid": Y,
        ...E
      },
      p && "text" in p ? /* @__PURE__ */ n.createElement(
        Wn,
        {
          ref: T,
          tabIndex: f,
          background: "image",
          backgroundImageSrc: p.background,
          className: Ce.splashScreen,
          onClick: s,
          onKeyDown: v
        },
        /* @__PURE__ */ n.createElement(Ln, { centerText: !0 }, /* @__PURE__ */ n.createElement(
          N,
          {
            fontVariant: S.H2,
            whiteSpace: "preLine",
            "data-testid": u.VideoSplashText
          },
          p.text
        ), /* @__PURE__ */ n.createElement(
          Pr,
          {
            srcObject: e,
            autoPlay: !0,
            sinkId: t
          }
        ))
      ) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
        _o,
        {
          tabIndex: f,
          id: g,
          ref: w,
          srcObject: e,
          onPlaying: J,
          onFailedToResume: _,
          onPictureInPictureChange: l,
          onClick: s,
          onKeyDown: v,
          disablePictureInPicture: gt(),
          sinkId: a ? void 0 : t,
          muted: a,
          "data-testid": a ? u.VideoPresentation : u.VideoMeeting,
          "aria-label": a ? B(
            "meeting.video-label-presentation",
            "Live video of another participant’s presentation"
          ) : B(
            "meeting.video-label",
            "Live video of the meeting"
          )
        }
      ), (!e || M === "loading") && /* @__PURE__ */ n.createElement(
        $o,
        {
          className: Ce.overlay,
          colorScheme: "dark",
          sizeModifier: G ? "small" : "medium"
        }
      ), M === "failed" && /* @__PURE__ */ n.createElement(
        D,
        {
          onClick: U,
          enhancerStart: /* @__PURE__ */ n.createElement(F, { source: k.IconPlayRound }),
          className: Ce.overlay
        },
        B(
          "meeting.error",
          "Click to resume the meeting video"
        )
      ))
    );
  }
);
Xn.displayName = "MeetingVideo";
const yc = (e) => /* @__PURE__ */ n.createElement("div", { className: b(Ce.container, Ce.external) }, /* @__PURE__ */ n.createElement(Xn, { ...e })), Bc = "_closeButton_1k468_1", kc = {
  closeButton: Bc
}, wc = ({ onClose: e }) => {
  const { t } = y();
  return /* @__PURE__ */ n.createElement(Nr, null, /* @__PURE__ */ n.createElement(N, { fontVariant: S.H3 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "media.presentation.nobody-sharing-screen" }, "No-one is currently sharing their screen")), /* @__PURE__ */ n.createElement(N, { fontVariant: S.H6, className: "mt-2" }, /* @__PURE__ */ n.createElement(
    Z,
    {
      t,
      i18nKey: "media.presentation.share-screen-placeholder"
    },
    "When someone shares their screen it’ll appear here"
  )), /* @__PURE__ */ n.createElement(
    D,
    {
      className: b("mt-5", kc.closeButton),
      modifier: "fullWidth",
      onClick: e,
      variant: "tertiary"
    },
    /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "common.close-window" }, "Close window")
  ));
}, xc = "_inMeetingDraggable_1hgnz_26", Mc = "_overlapsControls_1hgnz_34", Ic = "_desktopToolbar_1hgnz_34", Sc = "_header_1hgnz_37", Pc = "_footer_1hgnz_41", Nc = "_phone_1hgnz_45", Tc = "_center_1hgnz_48", Rc = "_centerInitial_1hgnz_76", zc = "_sidePanelOpen_1hgnz_81", ze = {
  inMeetingDraggable: xc,
  overlapsControls: Mc,
  desktopToolbar: Ic,
  header: Sc,
  footer: Pc,
  phone: Nc,
  center: Tc,
  centerInitial: Rc,
  sidePanelOpen: zc
}, mn = n.forwardRef(
  ({
    draggableAriaLabel: e = "",
    autoHideProps: t,
    center: a = !1,
    isMoveableWithArrowKeys: o,
    isSidePanelVisible: r,
    isSidePanelTransformEnabled: i = !0,
    isDisabled: s,
    alwaysAllowStyles: c = !1,
    floatRoot: l,
    isPhone: d,
    className: m,
    beforeRepositionSideEffect: p,
    onRepositionSideEffect: g,
    shouldCaptureClick: f = !0,
    showFocus: v = !0,
    alignWithFloatRootTrigger: E,
    pointerCapture: C,
    pointerCaptureTarget: B,
    children: w,
    style: M
  }, P) => {
    let T = ee(null);
    T = P ?? T;
    const { i18n: R } = y(), O = Ke(R), [G, Y] = x(!1), [J, _] = x(!1), { controlsOverlap: U, update: H } = Ws(T), q = rc(
      r,
      T,
      i
    ), te = L(
      (Q) => {
        H();
        const ne = Q.getBoundingClientRect();
        Ta(ne, O) ? q(Te + ct) : q(void 0);
      },
      [H, q, O]
    ), V = L(() => {
      T.current && T.current.style.removeProperty("transform"), _(!0), p && p();
    }, [p]), I = L(
      (Q, ne) => {
        te(Q);
        let se = Q.offsetLeft;
        O === "rtl" && (se = window.innerWidth - Q.offsetLeft - Q.offsetWidth), r && se < Ze && (O === "ltr" ? Q.style.left = `${Ze / window.innerWidth * 100}%` : (Q.style.left = `calc(${(window.innerWidth - Ze) / window.innerWidth * 100}% - ${Q.offsetWidth}px)`, Q.style.right = "auto")), g && g(Q, { floatRootOverflow: ne });
      },
      [te, g, r, O]
    );
    A(() => {
      const Q = T.current;
      Q && ((U.header || U.footer) && (Q.style.removeProperty("top"), Q.style.removeProperty("bottom")), U.desktopToolbar && (O === "ltr" ? Q.style.removeProperty("left") : Q.style.right = `${ct + Te}px`));
    }, [U, O]), A(() => {
      if (J && T.current) {
        const Q = T.current;
        Q.style.removeProperty("transition"), Q.ontransitionend = (ne) => {
          if (ne.propertyName !== "transform") {
            Q.ontransitionend = null;
            return;
          }
          let se;
          requestAnimationFrame((Be) => {
            se = Be, Q.style.transition = "none", O === "ltr" ? Q.style.left = `${Q.getBoundingClientRect().left / window.innerWidth * 100}%` : r ? Q.style.right = `${Ze / window.innerWidth * 100}%` : Q.style.right = `${ct / window.innerWidth * 100}%`, Q.style.removeProperty("transform");
          });
          const Se = () => {
            requestAnimationFrame((Be) => {
              Be <= se ? Se() : (H(), Q.style.removeProperty("transition"));
            });
          };
          Se(), Q.ontransitionend = null;
        };
      }
    }, [
      J,
      r,
      H,
      O
    ]), A(() => {
      s ? (H({
        desktopToolbar: !1,
        footer: !1,
        header: !1
      }), Y(!0)) : (H(), Y(!1));
    }, [s, H]);
    const z = (Q) => (c || !s) && Q;
    return /* @__PURE__ */ n.createElement(
      ea,
      {
        ariaLabel: e,
        isMoveableWithArrowKeys: o,
        isDisabled: s,
        showFocus: v,
        floatRoot: l,
        onReposition: I,
        beforeReposition: V,
        shouldCaptureClick: f,
        ref: T,
        pointerCapture: C,
        pointerCaptureTarget: B,
        alignWithFloatRootTrigger: E,
        className: b(
          {
            [ze.inMeetingDraggable]: z(!0),
            [ze.overlapsControls]: z(
              zs(U)
            ),
            [ze.desktopToolbar]: z(
              U.desktopToolbar
            ),
            [ze.footer]: z(U.footer),
            [ze.header]: z(U.header),
            [ze.center]: z(
              a && !J && !G
            ),
            [ze.centerInitial]: z(
              a && !J && G
            ),
            [ze.sidePanelOpen]: z(r),
            [ze.phone]: z(d)
          },
          m
        ),
        style: M,
        ...t
      },
      w
    );
  }
);
mn.displayName = "InMeetingDraggable";
const za = n.forwardRef(
  ({
    autoHideProps: e,
    draggableAriaLabel: t,
    isSidePanelVisible: a,
    floatRoot: o,
    videoElementId: r,
    ...i
  }, s) => {
    const { containerRef: c, isContainerWide: l } = xr(), d = i.status === X.Pip, m = i.status === X.BrowserPip, p = i.status === X.Deemphasized, g = i.status === X.Emphasized;
    return /* @__PURE__ */ n.createElement(
      mn,
      {
        draggableAriaLabel: t,
        autoHideProps: d ? e : void 0,
        isDisabled: !d,
        isSidePanelVisible: a,
        isSidePanelTransformEnabled: d,
        floatRoot: o,
        center: !0,
        className: b(Ce.container, {
          [Ce.pip]: d,
          [Ce.emphasized]: g,
          [Ce.deemphasized]: p,
          [Ce.browserPip]: m,
          "m-0": Ki && !d
        }),
        ref: c
      },
      /* @__PURE__ */ n.createElement(
        Xn,
        {
          ...i,
          ref: s,
          isContainerWide: l,
          videoElementId: r
        }
      )
    );
  }
);
za.displayName = "DraggableMeetingVideo";
const Wc = n.forwardRef(
  ({
    autoHideProps: e,
    draggableAriaLabel: t,
    status: a,
    localIsPresenting: o,
    localMediaStream: r,
    remoteIsPresenting: i,
    remoteMediaStream: s,
    remotePopOut: c,
    handleVideoClick: l,
    setIsPresentationBrowserPip: d,
    setIsPresentationPoppedOut: m,
    isSidePanelVisible: p,
    floatRoot: g,
    videoElementId: f,
    tabIndex: v,
    onKeyDown: E
  }, C) => {
    const { t: B } = y(), w = Xo(), M = i || o, P = L(() => {
      m(!1);
    }, [m]);
    return a === X.External ? /* @__PURE__ */ n.createElement(
      Tr,
      {
        onUnload: P,
        remotePopOut: c,
        title: B(
          "media.presentation.pexip-presentation",
          "Presentation Window"
        )
      },
      M ? /* @__PURE__ */ n.createElement(
        yc,
        {
          handleVideoClick: l,
          isFullHeight: !0,
          isFullWidth: !0,
          isPresentation: !0,
          mediaStream: o ? r : i ? s : void 0,
          onPictureInPictureChange: d,
          status: a
        }
      ) : /* @__PURE__ */ n.createElement(
        wc,
        {
          onClose: P
        }
      )
    ) : /* @__PURE__ */ n.createElement(
      za,
      {
        draggableAriaLabel: t,
        ref: C,
        autoHideProps: e,
        handleVideoClick: l,
        isPresentation: !0,
        mediaStream: o ? r : i ? s : void 0,
        onDoubleClick: w,
        onPictureInPictureChange: d,
        status: a,
        isSidePanelVisible: p,
        floatRoot: g,
        videoElementId: f,
        tabIndex: v,
        onKeyDown: E
      }
    );
  }
);
Wc.displayName = "PresentationMeetingVideo";
const Lc = "_audioMeterWrapper_1q9kq_1", Fc = {
  audioMeterWrapper: Lc
}, Qc = ({ colorScheme: e, progress: t, text: a, width: o, ...r }) => /* @__PURE__ */ n.createElement("div", { className: Fc.audioMeterWrapper, ...r }, /* @__PURE__ */ n.createElement("div", { style: { width: o ?? "100%" } }, /* @__PURE__ */ n.createElement(
  ta,
  {
    barColor: na.Primary,
    progress: t,
    colorScheme: e
  }
)), a && /* @__PURE__ */ n.createElement("div", { className: "text-right" }, /* @__PURE__ */ n.createElement(N, { fontVariant: S.Small }, " ", a))), cv = ({ analyzer: e, colorScheme: t, text: a, width: o, ...r }) => {
  const i = xi(e);
  return /* @__PURE__ */ n.createElement(
    Qc,
    {
      progress: i,
      colorScheme: t,
      text: a,
      width: o,
      ...r
    }
  );
}, Ac = 510, Vc = 419, un = () => {
  const e = to(`(max-width: ${Ac}px)`), t = to(`(max-width: ${Vc}px)`);
  return {
    hideVisualizer: e,
    isGridXs: t
  };
}, Oc = "_secureCheckCode_chbpg_1", Dc = {
  secureCheckCode: Oc
}, jc = ({ secureCheckCode: e }) => {
  const { isGridXs: t } = un(), { t: a } = y();
  return e ? /* @__PURE__ */ n.createElement(ye, null, /* @__PURE__ */ n.createElement(
    N,
    {
      fontVariant: t ? S.XSmallBold : S.BodyBold
    },
    /* @__PURE__ */ n.createElement(Z, { t: a, i18nKey: "stats.secure-check-code" }, "Secure check code")
  ), /* @__PURE__ */ n.createElement(
    N,
    {
      className: Dc.secureCheckCode,
      fontVariant: t ? S.XSmall : S.Small
    },
    e
  )) : null;
}, Yc = "_modalContent_1u2qv_8", Hc = "_statsBox_1u2qv_14", Zc = "_metricCell_1u2qv_21", Gc = "_dataText_1u2qv_37", je = {
  modalContent: Yc,
  statsBox: Hc,
  metricCell: Zc,
  dataText: Gc
}, Jc = ({ isOpen: e = !0, onClose: t, secureCheckCode: a, stats: o, children: r }) => {
  const { t: i } = y();
  return /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, /* @__PURE__ */ n.createElement(
    at,
    {
      "data-testid": u.StatsModal,
      isOpen: e,
      onClose: t,
      sizeModifier: "medium",
      withCloseButton: !0,
      className: "light",
      uniqueTitle: i("stats.media-stats", "Media statistics"),
      withScrollbars: !1
    },
    /* @__PURE__ */ n.createElement("div", { className: je.modalContent }, /* @__PURE__ */ n.createElement(ae, { className: "pt-1 mb-1 ml-3 mr-3" }, /* @__PURE__ */ n.createElement(N, { fontVariant: S.H5 }, /* @__PURE__ */ n.createElement(Z, { t: i, i18nKey: "stats.media-stats" }, "Media statistics"))), o ? /* @__PURE__ */ n.createElement("div", { className: je.statsBox }, r, /* @__PURE__ */ n.createElement(Uc, { stats: o }), a && /* @__PURE__ */ n.createElement(
      jc,
      {
        secureCheckCode: a
      }
    )) : /* @__PURE__ */ n.createElement(
      N,
      {
        "data-testid": u.TextNoStatsAvailable,
        className: "ml-3"
      },
      /* @__PURE__ */ n.createElement(Z, { t: i, i18nKey: "stats.no-stats-available" }, "No stats available")
    ))
  ));
}, Uc = ({ stats: e }) => {
  const { t } = y(), a = qc(e).filter(
    ([l, d, m]) => d != null || m != null
  ), o = Co(e).filter(
    ([l, d, m]) => d != null || m != null
  ), r = bo(
    e,
    "video"
  ).filter(([l, d]) => d != null), i = Co(e, "preso").filter(
    ([l, d, m]) => d != null || m != null
  ), s = bo(
    e,
    "preso"
  ).filter(([l, d]) => d != null), { isGridXs: c } = un();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(ye, null, /* @__PURE__ */ n.createElement(be, { className: b({ "mb-1": c }) }, /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(oe, { bold: !0, left: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.audio" }, "Audio"))), /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(oe, { bold: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.in" }, "In"))), /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(oe, { bold: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.out" }, "Out")))), a.map(([l, d, m]) => /* @__PURE__ */ n.createElement(
    be,
    {
      className: b(je.dataText, { "mb-1": c }),
      key: `audio ${l}`
    },
    /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricAudio}-${l}`,
        left: !0
      },
      t(`stats.[${l}]`)
    )),
    /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricAudioIn}-${l}`
      },
      d
    )),
    /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricAudioOut}-${l}`
      },
      m
    ))
  ))), /* @__PURE__ */ n.createElement(ye, null, /* @__PURE__ */ n.createElement(be, { className: b({ "mb-1": c }) }, /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(oe, { bold: !0, left: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.video" }, "Video"))), /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(oe, { bold: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.in" }, "In"))), /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(oe, { bold: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.out" }, "Out")))), o.map(([l, d, m]) => /* @__PURE__ */ n.createElement(
    be,
    {
      className: b(je.dataText, { "mb-1": c }),
      key: `video ${l}`
    },
    /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricVideo}-${l}`,
        left: !0
      },
      t(`stats.[${l}]`)
    )),
    /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricVideoIn}-${l}`
      },
      d
    )),
    /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricVideoOut}-${l}`
      },
      m
    ))
  )), r.map(([l, d]) => /* @__PURE__ */ n.createElement(
    be,
    {
      className: b(je.dataText, { "mb-1": c }),
      key: `video ${l}`
    },
    /* @__PURE__ */ n.createElement(K, { xs: 9 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricVideo}-${l}`,
        left: !0
      },
      t(`stats.[${l}]`)
    )),
    /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricVideoOut}-${l}`
      },
      d
    ))
  ))), /* @__PURE__ */ n.createElement(ye, null, /* @__PURE__ */ n.createElement(be, { className: b({ "mb-1": c }) }, /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(oe, { bold: !0, left: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.preso" }, "Presentation"))), /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(oe, { bold: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.in" }, "In"))), /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(oe, { bold: !0 }, /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "stats.out" }, "Out")))), i.map(([l, d, m]) => /* @__PURE__ */ n.createElement(
    be,
    {
      className: b(je.dataText, { "mb-1": c }),
      key: `preso ${l}`
    },
    /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricPreso}-${l}`,
        left: !0
      },
      t(`stats.[${l}]`)
    )),
    /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricPresoIn}-${l}`
      },
      d
    )),
    /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricPresoOut}-${l}`
      },
      m
    ))
  )), s.map(([l, d]) => /* @__PURE__ */ n.createElement(
    be,
    {
      className: b(je.dataText, { "mb-1": c }),
      key: `video ${l}`
    },
    /* @__PURE__ */ n.createElement(K, { xs: 9 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricVideo}-${l}`,
        left: !0
      },
      t(`stats.[${l}]`)
    )),
    /* @__PURE__ */ n.createElement(K, { xs: 3 }, /* @__PURE__ */ n.createElement(
      oe,
      {
        "data-testid": `${u.MetricVideoOut}-${l}`
      },
      d
    ))
  ))));
}, Ge = (e) => typeof e == "number" ? Tn(e * 100) : null, Tn = (e) => typeof e == "number" ? `${e.toFixed(1)}%` : null, tn = (e) => typeof e != "number" ? e : e > 1e3 ? `${Math.round(e / 1e3)}Kbps` : Math.round(e), vo = (e, t) => e && t ? `${e}p${Math.round(t)}` : e, lt = (e) => typeof e == "number" ? `${Math.round(e * 1e3)}ms` : e, ft = (e, t) => typeof e == "number" ? `${e}${t}` : e, qc = (e) => [
  [
    "packets-transmitted",
    e.inbound?.audio?.packetsTransmitted,
    e.outbound?.audio?.packetsTransmitted
  ],
  [
    "packets-lost",
    e.inbound?.audio?.packetsLost,
    e.outbound?.audio?.packetsLost
  ],
  [
    "recent-packet-loss",
    Ge(e.inbound?.audio?.recentPercentageLost),
    Ge(e.outbound?.audio?.recentPercentageLost)
  ],
  [
    "total-packet-loss",
    Ge(e.inbound?.audio?.totalPercentageLost),
    Ge(e.outbound?.audio?.totalPercentageLost)
  ],
  [
    "jitter",
    lt(e.inbound?.audio?.jitter),
    lt(e.outbound?.audio?.jitter)
  ],
  [
    "bitrate",
    tn(e.inbound?.audio?.bitrate),
    tn(e.outbound?.audio?.bitrate)
  ],
  ["codec", e.inbound?.audio?.codec, e.outbound?.audio?.codec],
  [
    "roundtrip-time",
    lt(e.outbound?.audio?.roundTripTime),
    ""
  ],
  [
    "time-to-capture-stats",
    ft(e.inbound?.audio?.timeToCaptureStats, "ms"),
    ft(e.outbound?.audio?.timeToCaptureStats, "ms")
  ]
], Co = (e, t = "video") => [
  [
    "packets-transmitted",
    e.inbound?.[t]?.packetsTransmitted,
    e.outbound?.[t]?.packetsTransmitted
  ],
  [
    "packets-lost",
    e.inbound?.[t]?.packetsLost,
    e.outbound?.[t]?.packetsLost
  ],
  [
    "recent-packet-loss",
    Ge(e.inbound?.[t]?.recentPercentageLost),
    Ge(e.outbound?.[t]?.recentPercentageLost)
  ],
  [
    "total-packet-loss",
    Ge(e.inbound?.[t]?.totalPercentageLost),
    Ge(e.outbound?.[t]?.totalPercentageLost)
  ],
  [
    "bitrate",
    tn(e.inbound?.[t]?.bitrate),
    tn(e.outbound?.[t]?.bitrate)
  ],
  [
    "codec",
    e.inbound?.[t]?.codec,
    e.outbound?.[t]?.codec
  ],
  [
    "resolution",
    vo(
      e.inbound?.[t]?.resolution,
      e.inbound?.[t]?.framesPerSecond
    ),
    vo(
      e.outbound?.[t]?.resolution,
      e.outbound?.[t]?.framesPerSecond
    )
  ],
  [
    "roundtrip-time",
    lt(e.outbound?.[t]?.roundTripTime),
    ""
  ],
  [
    "average-encode-time",
    null,
    lt(e.outbound?.[t]?.averageEncodeTime)
  ],
  [
    "average-decode-time",
    lt(e.inbound?.[t]?.averageDecodeTime),
    null
  ],
  [
    "time-to-capture-stats",
    ft(
      e.inbound?.[t]?.timeToCaptureStats,
      "ms"
    ),
    ft(
      e.outbound?.[t]?.timeToCaptureStats,
      "ms"
    )
  ],
  [
    "fps-volatility",
    Tn(e.inbound?.[t]?.fpsVolatility),
    Tn(e.outbound?.[t]?.fpsVolatility)
  ],
  [
    "quality-limitation-reason",
    null,
    e.outbound?.[t]?.qualityLimitationReason
  ]
], bo = (e, t = "video") => [
  [
    "quality-limitation-durations-cpu",
    ft(
      e.outbound?.[t]?.qualityLimitationDurations?.cpu,
      "s"
    )
  ],
  [
    "quality-limitation-durations-bandwidth",
    ft(
      e.outbound?.[t]?.qualityLimitationDurations?.bandwidth,
      "s"
    )
  ]
], oe = ({
  children: e,
  left: t = !1,
  bold: a = !1,
  ...o
}) => {
  const { isGridXs: r } = un();
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(je.metricCell, {
        "text-left": t,
        "text-right": !t
      }),
      ...o
    },
    /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: r ? a ? S.XSmallBold : S.XSmall : a ? S.BodyBold : S.Body
      },
      e
    )
  );
};
var nt = /* @__PURE__ */ ((e) => (e.GOOD = "Good", e.OK = "Ok", e.BAD = "Bad", e.TERRIBLE = "Terrible", e))(nt || {});
const Xc = (e) => `${Math.round(e * 100)}%`, Rn = n.forwardRef(({ width: e, height: t, quality: { name: a, value: o }, icon: r }, i) => {
  const s = a === "Bad" || a === "Terrible", { isGridXs: c, hideVisualizer: l } = un();
  return /* @__PURE__ */ n.createElement(Xe, null, /* @__PURE__ */ n.createElement(ye, { spacing: "none" }, /* @__PURE__ */ n.createElement(
    N,
    {
      fontVariant: c ? S.XSmallBold : S.BodyBold,
      variant: s ? "danger" : void 0
    },
    Xc(o)
  ), /* @__PURE__ */ n.createElement(
    N,
    {
      fontVariant: c ? S.XSmall : S.Body,
      variant: s ? "danger" : void 0,
      isTruncated: !0
    },
    a,
    " ",
    /* @__PURE__ */ n.createElement(F, { size: "mini", source: r })
  )), !l && /* @__PURE__ */ n.createElement("canvas", { ref: i, width: e, height: t }));
});
Rn.displayName = "CallQualityVisualizer";
const yo = 170, Bo = 18, Kc = ii, _c = Me.DeepBlue90, $c = ({
  callQualityStatsSignal: e
}) => {
  const t = ee(null), a = ee(null), [o, r] = x({
    name: nt.GOOD,
    value: 1
  }), [i, s] = x({
    name: nt.GOOD,
    value: 1
  });
  return A(
    () => e.add((c) => {
      t.current && c?.inbound?.audio.length > 0 && r(
        ko(c.inbound.audio, t.current)
      ), a.current && c?.outbound?.audio.length > 0 && s(
        ko(
          c.outbound.audio,
          a.current
        )
      );
    }),
    [e]
  ), /* @__PURE__ */ n.createElement(ye, null, /* @__PURE__ */ n.createElement(be, null, /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(
    Rn,
    {
      ref: t,
      width: yo,
      height: Bo,
      quality: o,
      icon: k.IconArrowDown
    }
  )), /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(
    Rn,
    {
      ref: a,
      width: yo,
      height: Bo,
      quality: i,
      icon: k.IconArrowUp
    }
  ))));
};
function ko(e, t) {
  const { goodOrOkQuality: a, quality: o, qualityOverTime: r } = ri(e);
  return el(t, r), {
    value: a,
    name: tl(o)
  };
}
function el(e, t, a = Kc) {
  const o = e.getContext("2d");
  o && (o.clearRect(0, 0, e.width, e.height), o.beginPath(), o.lineJoin = "round", o.strokeStyle = _c, o.moveTo(
    e.width,
    wo(t[0]) * e.height
  ), t.forEach((r, i) => {
    i !== 0 && o.lineTo(
      e.width - i * e.width / a,
      wo(r) * e.height
    );
  }), o.stroke());
}
function wo(e) {
  switch (e) {
    case Le.GOOD:
      return 0;
    case Le.OK:
      return 0.33;
    case Le.BAD:
      return 0.66;
    default:
      return 1;
  }
}
function tl(e) {
  switch (e) {
    case Le.TERRIBLE:
      return nt.TERRIBLE;
    case Le.BAD:
      return nt.BAD;
    case Le.OK:
      return nt.OK;
    default:
      return nt.GOOD;
  }
}
const lv = ({
  cachedStats: e,
  statsSignal: t,
  callQualityStatsSignal: a,
  isOpen: o,
  onClose: r,
  secureCheckCode: i
}) => {
  const [s, c] = x(
    e
  );
  return A(() => t.add(c), [t]), /* @__PURE__ */ n.createElement(
    Jc,
    {
      isOpen: o,
      onClose: r,
      stats: s,
      secureCheckCode: i
    },
    /* @__PURE__ */ n.createElement($c, { callQualityStatsSignal: a })
  );
}, nl = "_container_ohk7p_4", ol = "_roomName_ohk7p_14", al = "_truncated_ohk7p_14", rl = "_timeLeft_ohk7p_18", il = "_smallText_ohk7p_23", yt = {
  container: nl,
  roomName: ol,
  truncated: al,
  timeLeft: rl,
  smallText: il
}, sl = ({
  roomName: e,
  timeLeft: t,
  headingTestId: a,
  isSmallText: o = !1,
  isTruncated: r = !1,
  ...i
}) => /* @__PURE__ */ n.createElement("div", { className: yt.container, ...i }, /* @__PURE__ */ n.createElement(
  Ie,
  {
    htmlTag: "h2",
    fontVariant: o ? S.SmallBold : S.H5,
    className: b(yt.roomName, { [yt.truncated]: r }),
    "data-testid": a,
    isTruncated: !0
  },
  e
), t && /* @__PURE__ */ n.createElement(
  N,
  {
    className: b("ml-2", yt.timeLeft, {
      [yt.smallText]: o
    }),
    fontVariant: o ? S.Body : S.H6
  },
  `/ ${t}`
)), dv = ({ roomEndAt: e, ...t }) => {
  const [a, o] = x("");
  return A(() => {
    let r;
    if ((e ?? 0 - Date.now() / 1e3) > 0) {
      const s = () => {
        o(lr(e ?? 0, Date.now() / 1e3));
      };
      s(), r = window.setInterval(s, 1e3);
    }
    return () => clearInterval(r);
  }, [e]), /* @__PURE__ */ n.createElement(sl, { timeLeft: a, ...t });
}, cl = (e, t) => !e && t && t?.getVideoTracks().length > 0, ll = (e, t) => {
  const a = !!t && (Cr(t) || qo(t));
  return e && a || t !== j.InitialPermissionsNotGranted;
}, mv = (e, { audio: t, video: a }) => !!e && (fr(e) || Er(e) && a || qo(e) && t || vr(e)), dl = "_wrapper_1dpb5_174", ml = "_overlayWrapper_1dpb5_179", ul = "_childWrapper_1dpb5_188", pl = "_overlayWrapperShadow_1dpb5_192", hl = "_videoWrapper_1dpb5_200", gl = "_hide_1dpb5_212", fl = "_video_1dpb5_200", El = "_withInfoBorder_1dpb5_229", vl = "_withErrorBorder_1dpb5_233", Cl = "_flipper_1dpb5_238", bl = "_flipped_1dpb5_261", yl = "_label_1dpb5_265", Bl = "_previewLabel_1dpb5_280", ge = {
  wrapper: dl,
  overlayWrapper: ml,
  childWrapper: ul,
  overlayWrapperShadow: pl,
  videoWrapper: hl,
  hide: gl,
  video: fl,
  withInfoBorder: El,
  withErrorBorder: vl,
  flipper: Cl,
  flipped: bl,
  label: yl,
  previewLabel: Bl
}, kl = ({ displayName: e = "Guest", size: t }) => /* @__PURE__ */ n.createElement(Ln, null, /* @__PURE__ */ n.createElement(
  on,
  {
    type: Vt.Initials,
    translate: "no",
    displayName: e,
    sizeModifier: t
  }
)), wl = ({
  className: e,
  children: t,
  isPhone: a,
  showLabel: o,
  labelContent: r,
  labelTestId: i,
  showVideo: s,
  isMobileDevice: c,
  isVideoInitiallyShown: l,
  isFlipped: d,
  showPlaceholder: m,
  username: p,
  sizeModifier: g,
  showShadow: f = !1
}) => /* @__PURE__ */ n.createElement(
  "div",
  {
    className: b(ge.overlayWrapper, e, {
      [ge.overlayWrapperShadow]: f
    })
  },
  s && c && l && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(ge.flipper, {
        [ge.flipped]: d
      })
    }
  ),
  o && r && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(
        ge.childWrapper,
        ge.label,
        "d-flex flex-direction-column align-items-end",
        "justify-content-start"
      ),
      "data-testid": i
    },
    /* @__PURE__ */ n.createElement(oa, { className: ge.previewLabel }, r)
  ),
  (!!t || m) && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(
        ge.childWrapper,
        "d-flex flex-direction-column align-items-stretch",
        {
          "justify-content-center": a,
          "justify-content-end": !a
        }
      )
    },
    m && /* @__PURE__ */ n.createElement(
      kl,
      {
        displayName: p,
        size: g === "small" ? g : "medium"
      }
    ),
    t
  )
), xl = ({
  "aria-label": e,
  "data-testid": t,
  "wrapper-data-testid": a,
  children: o,
  className: r,
  isMirrored: i,
  isMobileDevice: s = !1,
  isVideoInputMuted: c,
  labelContent: l,
  labelTestId: d,
  localMediaStream: m,
  overlayClassName: p,
  shouldShowBorder: g,
  shouldShowErrorBorder: f = !1,
  shouldShowUserAvatar: v,
  showLabel: E,
  showOverlayShadow: C,
  sizeModifier: B,
  username: w,
  ...M
}) => {
  const { t: P } = y(), T = cl(c, m), [R, O] = x(!1);
  return A(() => {
    T && O(!0);
  }, [T]), /* @__PURE__ */ n.createElement("div", { className: ge.wrapper, ...M }, /* @__PURE__ */ n.createElement(
    Ko,
    {
      className: b(
        ge.videoWrapper,
        {
          [ge.withInfoBorder]: g,
          [ge.withErrorBorder]: f
        },
        r
      ),
      size: B,
      background: "secondary",
      alignItems: "stretch",
      isFullHeight: !0,
      "data-testid": a ?? u.VideoSelfviewWrapper
    },
    /* @__PURE__ */ n.createElement(
      _o,
      {
        "aria-label": e ?? P("media.selfview", "Selfview"),
        "data-testid": t ?? u.VideoSelfview,
        isMirrored: i,
        srcObject: m,
        disablePictureInPicture: s,
        muted: !0,
        className: b(ge.video, {
          [ge.hide]: !T
        })
      }
    )
  ), /* @__PURE__ */ n.createElement(
    wl,
    {
      className: p,
      isVideoInitiallyShown: R,
      labelContent: l,
      labelTestId: d,
      showLabel: E,
      showPlaceholder: !T && !f && v,
      showShadow: C,
      username: w
    },
    o
  ));
}, Ml = "_selfviewAspectRatio_kqohx_137", Il = "_cameraStep_kqohx_145", Sl = "_readyToJoinExpress_kqohx_148", Pl = "_readyToJoinStep_kqohx_152", Nl = "_forceLandscape_kqohx_156", Bt = {
  selfviewAspectRatio: Ml,
  cameraStep: Il,
  readyToJoinExpress: Sl,
  readyToJoinStep: Pl,
  forceLandscape: Nl
};
function Tl(e) {
  return function(a) {
    const {
      aspectRatioType: o = "camera-step",
      aspectRatioWrapperClassName: r,
      ...i
    } = a;
    return /* @__PURE__ */ n.createElement(
      Fn,
      {
        className: b(
          Bt.selfviewAspectRatio,
          {
            [Bt.cameraStep]: o === "camera-step",
            [Bt.readyToJoinStep]: o === "ready-to-join-step",
            [Bt.readyToJoinExpress]: o === "ready-to-join-express",
            [Bt.forceLandscape]: o === "force-landscape"
          },
          r
        )
      },
      /* @__PURE__ */ n.createElement(e, { ...i })
    );
  };
}
const Kn = Tl(xl), Rl = "_wrapper_wdkwq_4", zl = "_inner_wdkwq_21", Wl = "_selfviewWrapper_wdkwq_34", Ll = "_joinWrapper_wdkwq_49", Fl = "_aspectRatio_wdkwq_67", kt = {
  wrapper: Rl,
  inner: zl,
  selfviewWrapper: Wl,
  joinWrapper: Ll,
  aspectRatio: Fl
}, uv = ({ media: e, children: t }) => /* @__PURE__ */ n.createElement("div", { className: kt.wrapper }, /* @__PURE__ */ n.createElement("div", { className: kt.inner }, /* @__PURE__ */ n.createElement("div", { className: kt.selfviewWrapper }, /* @__PURE__ */ n.createElement(Fn, { className: kt.aspectRatio }, e)), /* @__PURE__ */ n.createElement("div", { className: kt.joinWrapper }, t))), Ql = "_wrapper_mkdbw_28", Al = "_phone_mkdbw_31", xo = {
  wrapper: Ql,
  phone: Al
}, Vl = ({ children: e, isPhone: t, position: a, shouldCenter: o }) => /* @__PURE__ */ n.createElement(
  Xe,
  {
    className: b(xo.wrapper, {
      [xo.phone]: t,
      "justify-content-center": o
    }),
    padding: a === "relative" && !t ? "medium" : "small",
    position: a
  },
  o ? /* @__PURE__ */ n.createElement(Ne, { spacing: "compact", justifyContent: "center" }, e) : e
), Ol = "_close_gpt3y_8", Dl = {
  close: Ol
}, jl = ({ content: e, children: t, onClose: a, visible: o, ...r }) => {
  const { t: i } = y();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    at,
    {
      isOpen: o,
      closeOnOutsideClick: !0,
      withCloseButton: !1,
      onClose: a,
      ...r
    },
    e,
    /* @__PURE__ */ n.createElement(
      D,
      {
        size: "large",
        className: "mt-3",
        modifier: "fullWidth",
        onClick: a
      },
      i("common.ok", "Ok")
    )
  ), t);
}, Yl = ({
  content: e,
  children: t,
  visible: a,
  wrapperClassName: o,
  position: r,
  testid: i,
  ...s
}) => /* @__PURE__ */ n.createElement(
  ot,
  {
    header: void 0,
    text: "",
    controlledIsVisible: a,
    ctaText: /* @__PURE__ */ n.createElement("div", { className: "p-0" }, e),
    position: r,
    testIdInner: i,
    ...s
  },
  t
), Wa = ({
  isTouch: e = wa(navigator.userAgent).isTouch,
  children: t,
  content: a,
  contentWrapperClassName: o,
  mainWrapperClassName: r,
  position: i = "topCenter",
  onClose: s,
  visible: c,
  testid: l,
  ...d
}) => e ? /* @__PURE__ */ n.createElement(
  jl,
  {
    content: a,
    visible: c,
    onClose: s,
    ...d
  },
  t
) : /* @__PURE__ */ n.createElement(
  Yl,
  {
    visible: c,
    position: i,
    content: a,
    testid: l,
    ...d
  },
  t
), Hl = (e) => {
  const { t } = y();
  return /* @__PURE__ */ n.createElement(
    Qn,
    {
      className: Dl.close,
      "aria-label": t("common.close-tooltip", "Close tooltip"),
      ...e
    }
  );
}, Zl = "_close_1y0pv_8", Gl = {
  close: Zl
}, _n = ({
  children: e,
  contentWrapperClassName: t,
  deniedDevice: a,
  setShowHelpVideo: o,
  learnHowToGrantAccessURL: r,
  permissionInfoType: i,
  mainWrapperClassName: s,
  onClose: c,
  visible: l,
  isTouch: d = wa(navigator.userAgent).isTouch,
  ...m
}) => {
  const { t: p } = y(), g = /* @__PURE__ */ n.createElement(ye, { className: b([d ? "pl-0 pr-0" : ""]) }, /* @__PURE__ */ n.createElement(ae, { className: "pt-3 pb-1" }, a === W.Camera && /* @__PURE__ */ n.createElement(N, { fontVariant: S.BodyBold }, p(
    "media.you-blocked-access-tooltip.camera",
    "You blocked access to your camera"
  )), a === W.Microphone && /* @__PURE__ */ n.createElement(N, { fontVariant: S.BodyBold }, p(
    "media.you-blocked-access-tooltip.mic",
    "You blocked access to your microphone"
  )), a === W.Both && /* @__PURE__ */ n.createElement(N, { fontVariant: S.BodyBold }, p(
    "media.you-blocked-access-tooltip.camera-and-mic",
    "You blocked access to your camera & microphone"
  )), /* @__PURE__ */ n.createElement(
    Qn,
    {
      className: Gl.close,
      onClose: c,
      "aria-label": p("common.close-tooltip", "Close tooltip")
    }
  )), /* @__PURE__ */ n.createElement(ae, { className: "pt-0" }, (i === Ut.Complete || i === Ut.CompleteReload) && /* @__PURE__ */ n.createElement(N, null, /* @__PURE__ */ n.createElement(
    Z,
    {
      t: p,
      i18nKey: "media.permissions-help-video-link"
    },
    "To grant access please follow the steps in",
    " ",
    /* @__PURE__ */ n.createElement(
      pt,
      {
        onClick: () => o(!0),
        target: "_blank",
        "data-testid": u.TextLinkUnblockPermissionsVideo
      },
      "this short video"
    )
  ), " ", /* @__PURE__ */ n.createElement(Z, { t: p, i18nKey: "media.learn-how-to-grant-access" }, " ", "or go to the", " ", /* @__PURE__ */ n.createElement(
    pt,
    {
      href: r,
      target: "_blank",
      "data-testid": u.TextLinkLearnRequestPermissions
    },
    "privacy settings"
  ), " ", "of your browser")), i === Ut.Void && /* @__PURE__ */ n.createElement(N, null, p(
    "media.other-browsers-privacy-settings",
    "To grant access please go to the privacy settings of your browser or try to refresh the page."
  ))));
  return /* @__PURE__ */ n.createElement(
    Wa,
    {
      isTouch: d,
      mainWrapperClassName: s,
      onClose: c,
      contentWrapperClassName: t,
      visible: l,
      ...m,
      content: g
    },
    e
  );
}, Ye = ({
  hasAudioVideoError: e,
  hasError: t,
  icon: a,
  variant: o = "translucent",
  isActive: r,
  ...i
}) => {
  const s = i.isDisabled ? "translucent" : e || t ? "danger" : o;
  return /* @__PURE__ */ n.createElement(
    D,
    {
      modifier: "square",
      size: "medium",
      isActive: r,
      variant: s,
      ...i
    },
    a
  );
}, Jl = ({
  iconSize: e,
  isTooltipVisible: t,
  tooltipPosition: a = "top",
  isBlurred: o,
  ...r
}) => {
  const { t: i } = y(), s = i(
    "media.background-effects-action",
    "Change background effect"
  ), c = /* @__PURE__ */ n.createElement(
    Ye,
    {
      ...r,
      "aria-label": s,
      icon: /* @__PURE__ */ n.createElement(F, { source: k.IconBackgroundBlur, size: e }),
      isActive: o
    }
  );
  return t ? /* @__PURE__ */ n.createElement(me, { text: s, position: a }, c) : c;
}, Mo = ({
  control: e,
  inputStatusInfo: t,
  isSuspended: a,
  isTooltipVisible: o,
  learnHowToGrantAccessURL: r,
  permissionInfoType: i,
  requestMediaPermissions: s,
  setIsTooltipVisible: c,
  setShowHelpVideo: l,
  testIdCloseButton: d,
  toolTipTestId: m,
  tooltipPosition: p = "topEnd",
  ...g
}) => {
  const { t: f } = y(), v = e && !t?.error && !t?.warning ? e : /* @__PURE__ */ n.createElement(
    Ye,
    {
      ...g,
      variant: a ? "translucent" : g.variant
    }
  );
  return t?.error && t?.controls === "permissions" ? /* @__PURE__ */ n.createElement(
    _n,
    {
      deniedDevice: t.error,
      onClose: () => c(!o),
      visible: o,
      "data-testid": u.TooltipDeniedDevice,
      setShowHelpVideo: l,
      learnHowToGrantAccessURL: r,
      permissionInfoType: i
    },
    v
  ) : /* @__PURE__ */ n.createElement(
    ot,
    {
      controlledIsVisible: o,
      controlledOnChange: c,
      ctaFn: t?.retriable ? s : void 0,
      ctaText: t?.retriable ? /* @__PURE__ */ n.createElement(
        D,
        {
          className: "px-3",
          isLoading: g.isLoading,
          onClick: s,
          size: "small",
          variant: "primary",
          enhancerStart: /* @__PURE__ */ n.createElement(
            F,
            {
              colorScheme: "dark",
              source: k.IconRefresh
            }
          )
        },
        f("common.try-again", "Try again")
      ) : void 0,
      header: t?.title,
      position: p,
      testIdCloseButton: d,
      testIdInner: m,
      text: t?.message ?? "",
      closeButtonAriaLabel: f("common.close-tooltip", "Close tooltip")
    },
    v
  );
}, Ul = ({
  audioInputControl: e,
  deniedDevice: t,
  enhancerEnd: a,
  inputStatusInfo: o,
  isAudioInputMuted: r,
  isAudioInputSuspended: i,
  isAudioInputUnavailable: s,
  isBlurred: c,
  isMobileDevice: l = !1,
  isRequestingAudio: d,
  isRequestingVideo: m,
  isVideoInputMuted: p,
  isVideoInputSuspended: g,
  isVideoInputUnavailable: f,
  learnHowToGrantAccessURL: v,
  permissionInfoType: E,
  requestMediaPermissions: C,
  segmentationEnabled: B,
  setShowHelpVideo: w,
  silentTooltipInfo: M,
  streamStatus: P,
  toggleAudioInput: T,
  toggleBlur: R,
  toggleFacingMode: O,
  toggleVideoInput: G,
  ...Y
}) => {
  const { t: J } = y(), {
    audioProps: _,
    videoProps: U,
    warning: H,
    isAudioIconMuted: q,
    isVideoIconMuted: te
  } = Gs({
    isAudioInputMuted: r,
    isVideoInputMuted: p,
    inputStatusInfo: o,
    iconSize: "medium"
  }), [V, I] = x(
    H === W.Microphone
  ), [z, Q] = x(
    H === W.Both || H === W.Camera
  ), ne = cc(
    i,
    g
  );
  A(() => {
    i || I(!!(M && !z));
  }, [z, M, i]), A(() => {
    Q(
      H === W.Camera || H === W.Both
    );
  }, [H]), A(() => {
    I(H === W.Microphone);
  }, [H]);
  const [se, Se] = x(!0);
  A(() => {
    P && ![
      j.InitialPermissionsNotGranted,
      j.InitialPermissionsGrantedVideoInputDenied
    ].includes(P) && Se(
      p || H === W.Camera || H === W.Both
    );
  }, [P, H, p]);
  const Be = {
    size: "large",
    tooltipPosition: l ? "topCenter" : "topEnd"
  };
  let _e = M;
  (o.error || o.warning) === W.Microphone && (_e = o), _e = ne.audio ?? _e;
  let vt = (o?.error || o?.warning) === W.Camera || (o?.error || o?.warning) === W.Both ? o : void 0;
  vt = ne.video;
  const $a = _e?.error === W.Both || vt?.error === W.Both;
  let hn = T, eo = G;
  return _e?.error || _e?.warning ? hn = () => I((Ct) => !Ct) : $a && (hn = () => Q((Ct) => !Ct)), (vt?.error || vt?.warning) && (eo = () => Q((Ct) => !Ct)), /* @__PURE__ */ n.createElement(
    Ne,
    {
      spacing: l ? "small" : "medium",
      justifyContent: "center",
      ...Y
    },
    !l && !!B && /* @__PURE__ */ n.createElement(
      Jl,
      {
        variant: "transparentAlternative",
        size: "large",
        isBlurred: c,
        isDisabled: f || se,
        onClick: R,
        iconSize: "medium",
        "data-testid": c ? u.ButtonBackgroundEffectsOn : u.ButtonBackgroundEffectsOff
      }
    ),
    O && /* @__PURE__ */ n.createElement(
      D,
      {
        "aria-label": J("media.flip-camera", "Flip camera"),
        "data-testid": u.ButtonFlipCamera,
        modifier: "square",
        onClick: O,
        size: "large",
        variant: "transparentAlternative",
        disabled: p,
        isLoading: m
      },
      /* @__PURE__ */ n.createElement(F, { source: k.IconFlipCamera, size: "medium" })
    ),
    a && a,
    /* @__PURE__ */ n.createElement(
      Mo,
      {
        ..._,
        ...Be,
        isDisabled: s,
        isLoading: d,
        isSuspended: i,
        isTooltipVisible: !s && V,
        setIsTooltipVisible: I,
        toolTipTestId: u.NotificationToolTipAudioProblem,
        "data-testid": q ? u.ButtonAudioMeterMuted : u.ButtonAudioMeter,
        onClick: hn,
        requestMediaPermissions: C,
        testIdCloseButton: u.NotificationToolTipAudioCloseButton,
        variant: "transparentAlternative",
        control: e,
        inputStatusInfo: _e,
        setShowHelpVideo: w,
        learnHowToGrantAccessURL: v,
        permissionInfoType: E
      }
    ),
    /* @__PURE__ */ n.createElement(
      Mo,
      {
        ...U,
        ...Be,
        isDisabled: f,
        isLoading: m,
        isSuspended: g,
        isTooltipVisible: !f && z,
        setIsTooltipVisible: Q,
        toolTipTestId: u.NotificationToolTipVideoProblem,
        "data-testid": te ? u.ButtonVideoinputMuted : u.ButtonVideoInput,
        onClick: eo,
        requestMediaPermissions: C,
        testIdCloseButton: u.NotificationToolTipVideoCloseButton,
        variant: "transparentAlternative",
        inputStatusInfo: vt,
        setShowHelpVideo: w,
        learnHowToGrantAccessURL: v,
        permissionInfoType: E
      }
    )
  );
}, pv = ({
  audioInputControl: e,
  deviceError: t,
  inputStatusInfo: a,
  isAudioInputMuted: o,
  isAudioInputSuspended: r,
  isAudioInputUnavailable: i,
  isBlurred: s,
  isMobileDevice: c,
  isRequestingAudio: l,
  isRequestingVideo: d,
  isVideoInputMuted: m,
  isVideoInputSuspended: p,
  isVideoInputUnavailable: g,
  learnHowToGrantAccessURL: f,
  permissionInfoType: v,
  requestMediaPermissions: E,
  segmentationEnabled: C,
  setShowHelpVideo: B,
  shouldCenter: w,
  shouldShowVideoStatus: M,
  silentTooltipInfo: P,
  streamStatus: T,
  toggleAudioInput: R,
  toggleBlur: O,
  toggleFacingMode: G,
  toggleVideoInput: Y
}) => /* @__PURE__ */ n.createElement(
  Vl,
  {
    position: M ? "relative" : "absoluteBottom",
    isPhone: c,
    shouldCenter: w
  },
  /* @__PURE__ */ n.createElement(
    Ul,
    {
      audioInputControl: e,
      deniedDevice: t.deniedDevice,
      inputStatusInfo: a,
      isAudioInputMuted: o,
      isAudioInputSuspended: r,
      isAudioInputUnavailable: i,
      isBlurred: s,
      isMobileDevice: c,
      isRequestingAudio: l,
      isRequestingVideo: d,
      isVideoInputMuted: m,
      isVideoInputSuspended: p,
      isVideoInputUnavailable: g,
      learnHowToGrantAccessURL: f,
      permissionInfoType: v,
      requestMediaPermissions: E,
      segmentationEnabled: C,
      setShowHelpVideo: B,
      silentTooltipInfo: P,
      streamStatus: T,
      toggleAudioInput: R,
      toggleBlur: O,
      toggleFacingMode: G,
      toggleVideoInput: Y
    }
  )
), ql = "_selfView_1tpp7_1", Xl = "_portrait_1tpp7_8", Kl = "_withVideo_1tpp7_8", vn = {
  selfView: ql,
  portrait: Xl,
  withVideo: Kl
}, _l = { width: 9, height: 16 }, $l = { width: 16, height: 9 }, hv = ({ children: e, isPhone: t, media: a, shouldShowAspectRatio: o }) => {
  const { t: r } = y(), { isPortrait: i } = sc();
  return /* @__PURE__ */ n.createElement(
    Wn,
    {
      background: "dark",
      flexDirection: "column",
      justifyContent: t ? "flexStart" : "center",
      padding: "none"
    },
    /* @__PURE__ */ n.createElement(
      An,
      {
        "aria-label": r("common.label-pexip-logo", "Pexip logo"),
        className: "mb-5 mt-4",
        colorScheme: "dark",
        size: "small"
      }
    ),
    /* @__PURE__ */ n.createElement(
      Ie,
      {
        className: t ? "mb-4" : "mb-5",
        fontVariant: S.H4,
        htmlTag: "h1"
      },
      /* @__PURE__ */ n.createElement(Z, { t: r, i18nKey: "preflight.get-ready" }, "Get ready for your meeting")
    ),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        className: b(vn.selfView, {
          [vn.portrait]: i,
          [vn.withVideo]: o
        })
      },
      /* @__PURE__ */ n.createElement(
        Fn,
        {
          className: "justify-content-center",
          dimensions: i ? _l : $l,
          isActive: o
        },
        a
      )
    ),
    e
  );
}, ed = "_videoStatus_1tiqs_1", td = "_phone_1tiqs_9", Io = {
  videoStatus: ed,
  phone: td
}, nd = ({ title: e, body: t, isPhone: a, ...o }) => /* @__PURE__ */ n.createElement(
  "div",
  {
    className: b(Io.videoStatus, {
      [Io.phone]: a,
      "pl-5": !a,
      "px-4": a
    })
  },
  /* @__PURE__ */ n.createElement(
    Ie,
    {
      className: "pb-1",
      htmlTag: "h5",
      "data-testid": o["heading-data-testid"] ?? u.VideoStatusTitle
    },
    e
  ),
  /* @__PURE__ */ n.createElement(
    N,
    {
      variant: "tinted",
      "data-testid": o["body-data-testid"] ?? u.VideoStatusBody
    },
    t
  )
), od = "_preflightSelfViewWrapper_1js44_203", ad = "_hideBackground_1js44_215", So = {
  preflightSelfViewWrapper: od,
  hideBackground: ad
}, gv = (e) => {
  const {
    aspectRatioType: t = "camera-step",
    isMobileDevice: a = !1,
    isVideoInputMuted: o,
    shouldShowErrorBorder: r,
    streamStatus: i,
    preflightControls: s,
    requestedVideo: c = !0,
    requestedAudio: l = !0,
    ...d
  } = e, m = qn(e.streamStatus, {
    audio: l,
    video: c
  }), p = ll(o, i) || !c, g = c && i && Uo(i);
  return /* @__PURE__ */ n.createElement("div", { className: So.preflightSelfViewWrapper }, /* @__PURE__ */ n.createElement(
    Kn,
    {
      isVideoInputMuted: o,
      ...d,
      shouldShowUserAvatar: p,
      shouldShowErrorBorder: r,
      className: b({
        [So.hideBackground]: a && g
      }),
      aspectRatioType: t
    },
    g && /* @__PURE__ */ n.createElement(
      nd,
      {
        title: m.title,
        body: m.message,
        "data-testid": u.VideoStatus,
        isPhone: a
      }
    ),
    s
  ));
}, rd = (e) => {
  const { level: t = 0, peak: a = 0, enabled: o = !0, isHoveringButton: r } = e, i = o ? "enabled" : `disabled-${r ? "hovering" : "not-hovering"}`;
  return `linear-gradient(
        to top,
        var(--mic-button-${i}-background-color-dark) 0% ${t}%,
        var(--mic-button-${i}-background-color-light) ${t}% ${a}%,
        var(--mic-button-${i}-background-color) ${a}% 100%)`;
}, id = (e = 0, t = 3e3, a = 0) => {
  let o, r = e, i = a;
  const s = () => {
    o?.();
  }, c = (l = 0) => new Promise((d, m) => {
    o = m, r > l ? i > 0 ? d({ level: l, peak: r }) : i = window.setTimeout(() => {
      i = 0, clearTimeout(i), r = 0, d({
        level: l,
        peak: 0
      }), s();
    }, t) : (r = l, d({
      level: l,
      peak: 0
    }));
  });
  return c.cancel = s, c;
}, sd = "_enabled_1n0g5_19", cd = "_disabled_1n0g5_23", ld = {
  enabled: sd,
  disabled: cd
}, Po = id(), fv = ({ level: e, hasAudioVideoError: t, hasError: a, isMuted: o, ...r }) => {
  const [i, s] = x(""), [c, l] = x(!1);
  return A(() => {
    let d = !1;
    return Po(e).then((m) => {
      d || s(
        rd({
          ...m,
          enabled: !o,
          isHoveringButton: c
        })
      );
    }).catch(() => {
    }), () => {
      d = !0, Po?.cancel();
    };
  }, [o, c, e]), /* @__PURE__ */ n.createElement(
    Ye,
    {
      style: t || a ? {} : {
        backgroundImage: i
      },
      className: b(ld[o ? "disabled" : "enabled"]),
      variant: "transparentAlternative",
      size: "large",
      hasAudioVideoError: t,
      hasError: a,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      ...r
    }
  );
}, dd = (e) => {
  const { t } = y();
  return /* @__PURE__ */ n.createElement(
    Wa,
    {
      content: /* @__PURE__ */ n.createElement(ye, { className: "p-0" }, /* @__PURE__ */ n.createElement(ae, { className: "pt-0 pb-1" }, /* @__PURE__ */ n.createElement(N, { fontVariant: S.BodyBold }, t(
        "media.host-muted-you",
        "The host has muted you."
      )), /* @__PURE__ */ n.createElement(Hl, { onClose: e.onClose })), /* @__PURE__ */ n.createElement(ae, { className: "pt-0" }, /* @__PURE__ */ n.createElement(N, null, /* @__PURE__ */ n.createElement(
        Z,
        {
          t,
          i18nKey: "media.host-muted-you-descriptions"
        },
        "You will be able to unmute yourself once the host has given you permission."
      ), " "))),
      position: "topEnd",
      testid: u.TooltipMuteDisabled,
      ...e
    }
  );
}, Ae = ({
  canMute: e = !0,
  errorTooltipCloseBtnTestID: t,
  errorTooltipTestID: a,
  inputStatusInfo: o,
  isSuspended: r,
  learnHowToGrantAccessURL: i,
  permissionInfoType: s,
  requestDeviceAgain: c,
  setShowHelpVideo: l,
  shouldShowTooltip: d = !0,
  showDeniedDeviceTooltip: m = !1,
  size: p = "large",
  toggleTooltip: g,
  tooltipClassName: f,
  tooltipPosition: v = "top",
  tooltipText: E,
  variant: C = "translucent",
  ...B
}) => {
  const { t: w } = y();
  return e ? o?.error && o?.controls === "permissions" && l ? /* @__PURE__ */ n.createElement(
    _n,
    {
      "data-testid": u.TooltipDeniedDevice,
      deniedDevice: o.error,
      learnHowToGrantAccessURL: i,
      permissionInfoType: s,
      visible: m,
      setShowHelpVideo: l
    },
    /* @__PURE__ */ n.createElement(Ye, { variant: C, size: p, ...B })
  ) : o?.error || o?.warning ? /* @__PURE__ */ n.createElement(
    ot,
    {
      controlledIsVisible: d,
      controlledOnChange: g,
      ctaFn: o.retriable && c ? c : void 0,
      ctaText: o.retriable ? /* @__PURE__ */ n.createElement(
        D,
        {
          className: "px-3",
          isLoading: B.isLoading,
          onClick: c,
          size: "small",
          variant: "primary",
          enhancerStart: /* @__PURE__ */ n.createElement(
            F,
            {
              colorScheme: "dark",
              source: k.IconRefresh
            }
          )
        },
        w("common.try-again", "Try again")
      ) : void 0,
      header: o.title,
      position: "topEnd",
      testIdCloseButton: t,
      testIdInner: a,
      role: "tooltip",
      text: o.message,
      "aria-label": B["aria-label"],
      closeButtonAriaLabel: w(
        "common.close-tooltip",
        "Close tooltip"
      )
    },
    /* @__PURE__ */ n.createElement(
      Ye,
      {
        variant: r ? "translucent" : C,
        size: p,
        ...B,
        onClick: g
      }
    )
  ) : !d || !E ? /* @__PURE__ */ n.createElement(Ye, { size: p, variant: C, ...B }) : /* @__PURE__ */ n.createElement(
    me,
    {
      text: E,
      position: v,
      className: f,
      role: "tooltip",
      "aria-label": B["aria-label"]
    },
    /* @__PURE__ */ n.createElement(Ye, { size: p, variant: C, ...B })
  ) : /* @__PURE__ */ n.createElement(
    dd,
    {
      onClose: g,
      visible: d
    },
    /* @__PURE__ */ n.createElement(
      Ye,
      {
        variant: C,
        size: p,
        ...B,
        onClick: g
      }
    )
  );
}, Ev = ({
  isFeccHidden: e,
  iconSource: t,
  tooltipPosition: a = "top",
  onClickFecc: o,
  ...r
}) => {
  const { t: i } = y();
  return e ? null : /* @__PURE__ */ n.createElement(
    Ae,
    {
      icon: /* @__PURE__ */ n.createElement(Vn, { size: "small", source: t }),
      "aria-label": i("fecc.camera-control", "Camera control"),
      tooltipText: i("fecc.camera-control", "Camera control"),
      tooltipPosition: a,
      onClick: o,
      ...r
    }
  );
}, md = ({
  isHandRaised: e,
  isRaiseHandHidden: t = !1,
  onRaiseHand: a,
  iconSize: o,
  tooltipPosition: r = "top",
  ...i
}) => {
  const { t: s } = y();
  return t ? null : /* @__PURE__ */ n.createElement(
    Ae,
    {
      icon: /* @__PURE__ */ n.createElement(F, { source: k.IconRaiseHand, size: o }),
      "aria-label": e ? s("common.lower-hand", "Lower hand") : s("common.raise-hand", "Raise hand"),
      tooltipText: e ? s("common.lower-hand", "Lower hand") : s("common.raise-hand", "Raise hand"),
      tooltipPosition: r,
      onClick: () => a(!e),
      isActive: e,
      "data-testid": e ? u.ButtonLowerHand : u.ButtonRaiseHand,
      ...i
    }
  );
}, ud = ({
  localIsPresenting: e,
  tooltipPosition: t = "top",
  iconSize: a,
  isDisabled: o = !1,
  disabledReason: r,
  startPresentation: i,
  stopPresentation: s,
  ...c
}) => {
  const { t: l } = y(), d = aa(), p = (e ? "stop" : "start") === "stop", g = p ? l("media.presentation.stop-share-screen", "Stop sharing") : l("media.presentation.share-screen", "Share screen"), f = o && r ? r : g;
  return /* @__PURE__ */ n.createElement(
    Ae,
    {
      onClick: () => e ? s() : i(),
      "aria-label": f,
      tooltipText: f,
      tooltipPosition: t,
      icon: /* @__PURE__ */ n.createElement(F, { source: k.IconShare, size: a }),
      isActive: e,
      shouldShowTooltip: !d,
      "data-testid": p ? u.ButtonStopPresentation : u.ButtonStartPresentation,
      isDisabled: o,
      ...c
    }
  );
}, pd = "_callControlsWrapper_3deb1_4", hd = "_desktopWrapper_3deb1_15", gd = "_desktopMediaBtnWrapper_3deb1_22", fd = "_desktopLeaveBtn_3deb1_28", Ed = "_desktopLeaveBtnWrapper_3deb1_34", vd = "_desktopLeaveText_3deb1_44", Cd = "_desktopVideoButtonTooltip_3deb1_48", bd = "_desktopAudioButtonTooltip_3deb1_58", yd = "_touchWrapper_3deb1_69", Bd = "_touchCallControlBtnWrapper_3deb1_74", kd = "_moreMenu_3deb1_81", wd = "_moreMenuItem_3deb1_89", xd = "_moreMenuBadge_3deb1_93", Ee = {
  callControlsWrapper: pd,
  desktopWrapper: hd,
  desktopMediaBtnWrapper: gd,
  desktopLeaveBtn: fd,
  desktopLeaveBtnWrapper: Ed,
  desktopLeaveText: vd,
  desktopVideoButtonTooltip: Cd,
  desktopAudioButtonTooltip: bd,
  touchWrapper: yd,
  touchCallControlBtnWrapper: Bd,
  moreMenu: kd,
  moreMenuItem: wd,
  moreMenuBadge: xd
}, Md = 30, Id = 19, Sd = ({ items: e, isTouch: t = !1, ...a }) => /* @__PURE__ */ n.createElement(
  an,
  {
    items: e,
    popoverPlacement: t ? "top" : "right",
    popoverOffset: t ? Md : Id,
    menuClassName: Ee.moreMenu,
    itemClassName: Ee.moreMenuItem,
    ...a
  }
), Pd = ({
  items: e,
  onOpenChange: t,
  isTouch: a = !1,
  isMobile: o = !1,
  children: r,
  ...i
}) => {
  const [s, c] = x(!1), { t: l, i18n: d } = y(), m = Ke(d), p = l("meeting.more-controls", "More controls");
  return /* @__PURE__ */ n.createElement(
    Sd,
    {
      items: e,
      onOpenChange: (g) => {
        c(g), t?.(g);
      },
      button: /* @__PURE__ */ n.createElement(
        me,
        {
          text: p,
          role: "tooltip",
          position: a ? "top" : m === "rtl" ? "left" : "right"
        },
        /* @__PURE__ */ n.createElement(
          D,
          {
            isActive: s,
            "aria-label": p,
            modifier: "square",
            "data-testid": u.ButtonToolbarMoreItems,
            variant: a ? "neutral" : "translucent",
            size: "large"
          },
          /* @__PURE__ */ n.createElement(
            F,
            {
              source: o ? k.IconMoreHorizontal : k.IconMoreVertical,
              size: o ? "medium" : void 0
            }
          ),
          r
        )
      ),
      isTouch: a,
      ...i
    }
  );
}, Nd = "_footer_3y421_39", Td = "_phone_3y421_44", Rd = "_start_3y421_55", zd = "_middle_3y421_56", Wd = "_end_3y421_57", Ld = "_singleEnhancer_3y421_79", $e = {
  footer: Nd,
  phone: Td,
  start: Rd,
  middle: zd,
  end: Wd,
  singleEnhancer: Ld
}, vv = ({ className: e, start: t, middle: a, end: o, isPhone: r = !1, ...i }) => /* @__PURE__ */ n.createElement(
  Xe,
  {
    position: "absoluteBottom",
    padding: r ? "none" : "small",
    className: b($e.footer, r && $e.phone, e),
    ...i
  },
  t && /* @__PURE__ */ n.createElement("div", { className: $e.start }, /* @__PURE__ */ n.createElement(Ne, { spacing: "compact" }, t)),
  a && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b($e.middle, {
        [$e.singleEnhancer]: !t && !o,
        [$e.phone]: r
      })
    },
    /* @__PURE__ */ n.createElement(Ne, { spacing: r ? "small" : "compact" }, a)
  ),
  o && /* @__PURE__ */ n.createElement("div", { className: $e.end }, /* @__PURE__ */ n.createElement(Ne, { spacing: "compact" }, o))
), Fd = "_toolbar_1toph_106", Qd = "_withBoxShadow_1toph_123", Ad = "_withSidePanel_1toph_127", Vd = "_core_1toph_143", Zt = {
  toolbar: Fd,
  withBoxShadow: Qd,
  withSidePanel: Ad,
  core: Vd
}, Cv = ({
  core: e,
  withSidePanel: t = !1,
  withBoxShadow: a = !0,
  className: o,
  ...r
}) => /* @__PURE__ */ n.createElement(
  Xe,
  {
    flexDirection: "column",
    className: b(
      Zt.toolbar,
      {
        [Zt.withSidePanel]: t,
        [Zt.withBoxShadow]: a
      },
      o
    ),
    ...r
  },
  e && /* @__PURE__ */ n.createElement("div", { className: Zt.core }, e)
), Od = "_foldedSelfview_1gtna_15", Dd = "_inheritCursor_1gtna_21", jd = "_notificationTooltipInner_1gtna_25", Yd = "_selfviewBtnTooltipContainer_1gtna_29", Hd = "_foldedSelfviewButton_1gtna_33", Zd = "_disabled_1gtna_36", Gd = "_miniButton_1gtna_41", Jd = "_disabledIcon_1gtna_47", He = {
  foldedSelfview: Od,
  inheritCursor: Dd,
  notificationTooltipInner: jd,
  selfviewBtnTooltipContainer: Yd,
  foldedSelfviewButton: Hd,
  disabled: Zd,
  miniButton: Gd,
  disabledIcon: Jd
}, Rt = ({
  icon: e,
  iconClassName: t,
  isDisabled: a,
  isMobileDevice: o,
  onClick: r,
  tooltipPosition: i = "topEnd",
  tooltipText: s,
  variant: c = "translucent",
  tooltipContainerClassName: l = He.selfviewBtnTooltipContainer,
  className: d,
  ...m
}) => {
  const p = /* @__PURE__ */ n.createElement(
    D,
    {
      onClick: r,
      className: b(
        He.foldedSelfviewButton,
        {
          [He.disabled]: a,
          [He.miniButton]: o
        },
        d
      ),
      variant: c,
      modifier: "square",
      ...m
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        source: e,
        className: b(a && He.disabledIcon, t),
        size: o ? "compact" : "small"
      }
    )
  );
  return a || o || !s ? p : /* @__PURE__ */ n.createElement(
    me,
    {
      text: s,
      position: i,
      onPointerDownCapture: Kt(
        r !== void 0
      ),
      tooltipContainerClassName: l
    },
    p
  );
}, Ud = ({
  isAudioInputMuted: e,
  isVideoInputMuted: t,
  isAudioInputMissing: a,
  isVideoInputMissing: o,
  isAudioInputDisabled: r,
  onToggleVideoClick: i,
  onExpandSelfview: s,
  onToggleAudioClick: c,
  showSelfviewTooltip: l,
  setShowSelfviewTooltip: d,
  notificationTooltipPos: m = "bottomEnd",
  selfviewBtnTooltipPos: p = "topEnd"
}) => {
  const { t: g } = y(), f = e ? g("media.unmute-microphone", "Unmute microphone") : g("media.mute-microphone", "Mute microphone"), v = g("meeting.show-self-view", "Show self-view"), E = g("media.turn-camera-on", "Turn camera on"), C = g("meeting.folded-selfview.drag", "Move self-view");
  return /* @__PURE__ */ n.createElement(
    ot,
    {
      controlledIsVisible: l && !t && !o,
      controlledOnChange: d,
      header: g("settings.selfview-hidden", "Self-view hidden"),
      position: m,
      testIdInner: u.NotificationTooltipSelfviewHidden,
      text: g(
        "settings.collapsed-selfview-tooltip-description",
        "You’re still sending video to other people in the meeting"
      ),
      closeButtonAriaLabel: g("common.close-tooltip", "Close tooltip"),
      stopPointerDownPropagation: !0,
      className: He.notificationTooltipInner
    },
    /* @__PURE__ */ n.createElement(
      Re,
      {
        className: b(He.foldedSelfview, "foldedSelfviewGlobal"),
        "data-testid": u.FoldedSelfview
      },
      /* @__PURE__ */ n.createElement(
        Rt,
        {
          "data-testid": u.ButtonDragFoldedSelfview,
          icon: k.IconDraggable,
          "aria-label": C,
          className: He.inheritCursor
        }
      ),
      /* @__PURE__ */ n.createElement(
        Rt,
        {
          onClick: c,
          "data-testid": u.ButtonToggleAudioInFoldedSelfview,
          tooltipText: f,
          tooltipPosition: p,
          "aria-label": f,
          isDisabled: r || a,
          icon: e || a ? k.IconMicrophoneOff : k.IconMicrophoneOn
        }
      ),
      t || o ? /* @__PURE__ */ n.createElement(
        Rt,
        {
          onClick: i,
          "data-testid": u.ButtonToggleVideoInFoldedSelfview,
          tooltipText: E,
          tooltipPosition: p,
          "aria-label": E,
          icon: k.IconVideoOff,
          isDisabled: o
        }
      ) : /* @__PURE__ */ n.createElement(
        Rt,
        {
          onClick: s,
          "data-testid": u.ButtonExpandSelfview,
          tooltipText: v,
          tooltipPosition: p,
          "aria-label": v,
          icon: k.IconFullscreenOn
        }
      )
    )
  );
}, qd = "_header_58s03_31", Xd = "_footer_58s03_32", Kd = "_selfviewOverlay_58s03_37", _d = "_collapseSelfviewButton_58s03_37", $d = "_mobile_58s03_40", em = "_flipCameraIcon_58s03_47", dt = {
  header: qd,
  footer: Xd,
  selfviewOverlay: Kd,
  collapseSelfviewButton: _d,
  mobile: $d,
  flipCameraIcon: em
}, tm = ({ isMobileDevice: e, isMaximized: t, onClick: a, setIsMaximized: o }) => {
  const { t: r } = y();
  return /* @__PURE__ */ n.createElement(
    Xe,
    {
      className: dt.header,
      position: "absoluteTop",
      flexDirection: "rowReverse"
    },
    e && t ? /* @__PURE__ */ n.createElement(
      D,
      {
        colorScheme: "light",
        variant: "secondary",
        onClick: () => o?.(!1),
        onPointerDownCapture: Kt()
      },
      r("common.close", "Close")
    ) : /* @__PURE__ */ n.createElement(
      Rt,
      {
        onClick: a,
        "data-testid": u.ButtonCollapseSelfview,
        tooltipText: r("meeting.hide-self-view", "Hide self-view"),
        "aria-label": r("meeting.hide-self-view", "Hide self-view"),
        className: b(
          dt.collapseSelfviewButton,
          e && dt.mobile
        ),
        icon: k.IconFullscreenOff,
        variant: "neutral",
        isMobileDevice: e
      }
    )
  );
}, nm = "_miniButton_18gb6_1", om = "_disabled_18gb6_7", No = {
  miniButton: nm,
  disabled: om
}, Cn = ({
  ariaLabel: e,
  className: t,
  children: a,
  iconClassName: o,
  isDisabled: r,
  isActive: i,
  isMobileDevice: s,
  onClick: c,
  onPointerDownCapture: l,
  source: d,
  ...m
}) => /* @__PURE__ */ n.createElement(
  D,
  {
    modifier: "square",
    size: "compact",
    variant: "neutral",
    className: b(
      {
        [No.miniButton]: s,
        [No.disabled]: r
      },
      t
    ),
    "aria-label": e,
    disabled: r || !1,
    isActive: i,
    onClick: c,
    onPointerDownCapture: l,
    noHover: s || r || !0,
    ...m
  },
  a || /* @__PURE__ */ n.createElement(
    F,
    {
      source: d || k.IconAdd,
      size: s ? "mini" : "compact",
      className: o
    }
  )
), am = ({
  isAudioInputMuted: e,
  isAudioInputDisabled: t = !1,
  // isAudioInputMissing,
  isMobileDevice: a,
  areEffectsEnabled: o,
  areEffectsApplied: r,
  onToggleAudioClick: i,
  toggleFacingMode: s,
  openEffectsModal: c
}) => {
  const { t: l } = y();
  return /* @__PURE__ */ n.createElement(Xe, { className: dt.footer, position: "absoluteBottom" }, /* @__PURE__ */ n.createElement(
    Cn,
    {
      ariaLabel: e ? l("media.unmute-microphone", "Unmute microphone") : l("media.mute-microphone", "Mute microphone"),
      onClick: i,
      isActive: e,
      source: e ? k.IconMicrophoneOff : k.IconMicrophoneOn,
      onPointerDownCapture: Kt(!0),
      isMobileDevice: a,
      className: b(a && "mr-1", {
        "visibility-hidden": t
      }),
      "data-testid": u.ButtonToggleAudioInSelfview
    }
  ), a && /* @__PURE__ */ n.createElement(
    Cn,
    {
      onClick: s,
      source: k.IconFlipCamera,
      isMobileDevice: a,
      iconClassName: dt.flipCameraIcon
    }
  ), o && /* @__PURE__ */ n.createElement(
    Cn,
    {
      ariaLabel: l(
        "media.background-effects-action",
        "Change background effect"
      ),
      onClick: c,
      isActive: r,
      source: k.IconBackgroundBlur,
      onPointerDownCapture: Kt(!0),
      isMobileDevice: a,
      className: b(a && "ml-1"),
      "data-testid": r ? u.ButtonMeetingBackgroundEffectsOn : u.ButtonMeetingBackgroundEffectsOff
    }
  ));
}, La = ({
  overlayClassName: e,
  isAudioInputMuted: t,
  isAudioInputDisabled: a,
  isAudioInputMissing: o,
  isMobileDevice: r,
  quality: i,
  areEffectsEnabled: s,
  areEffectsApplied: c,
  isMaximized: l,
  onCollapseSelfview: d,
  onToggleAudioClick: m,
  toggleFacingMode: p,
  openEffectsModal: g,
  setIsMaximized: f,
  ...v
}) => /* @__PURE__ */ n.createElement(
  Kn,
  {
    isMobileDevice: r,
    aspectRatioType: "in-meeting",
    overlayClassName: b(dt.selfviewOverlay, e),
    ...v
  },
  /* @__PURE__ */ n.createElement(
    tm,
    {
      onClick: d,
      isMobileDevice: r,
      isMaximized: l,
      setIsMaximized: f
    }
  ),
  /* @__PURE__ */ n.createElement(
    am,
    {
      isAudioInputMuted: t,
      isAudioInputDisabled: a,
      isAudioInputMissing: o,
      isMobileDevice: r,
      quality: i,
      areEffectsEnabled: s,
      areEffectsApplied: c,
      onToggleAudioClick: m,
      toggleFacingMode: p,
      openEffectsModal: g
    }
  )
), rm = (e, t = 300) => {
  const a = ee(0);
  return L(
    (r) => {
      r.preventDefault();
      const i = Date.now(), s = i - a.current;
      a.current > 0 && s < t && e(r), a.current = i;
    },
    [e, t]
  );
}, im = "_pip_cnzjz_184", sm = "_foldedSelfviewWrapper_cnzjz_204", cm = "_inMeetingSelfviewPosition_cnzjz_216", lm = "_maximized_cnzjz_222", dm = "_maximizedMask_cnzjz_247", tt = {
  pip: im,
  foldedSelfviewWrapper: sm,
  inMeetingSelfviewPosition: cm,
  maximized: lm,
  maximizedMask: dm
}, bv = ({
  isFolded: e,
  draggableAriaLabel: t,
  floatRoot: a,
  isSidePanelVisible: o,
  autoHideProps: r,
  ...i
}) => {
  const s = ee(null), c = ee(null), { isInBottomHalf: l, update: d } = Mr(), { isInRightHalf: m, update: p } = Ir(), [g, f] = x(!1), v = rm((z) => {
    z.stopPropagation(), f((Q) => !Q);
  }), { i18n: E } = y(), C = Ke(E), B = L(
    (z, Q) => {
      d(z), p(z), C === "ltr" && Q.floatRootOverflow.right && z.style.removeProperty("left");
    },
    [d, p, C]
  );
  A(() => {
    s.current && p(s.current);
  }, [p]), A(() => {
    s.current && d(s.current);
  }, [d]), At(() => {
    s.current && a?.current && c.current && c.current();
  }, [a, e]), At(() => {
    s.current?.style.removeProperty("top"), s.current?.style.removeProperty("bottom"), s.current?.style.removeProperty("left"), s.current?.style.removeProperty("right"), s.current?.style.removeProperty("transform");
  }, [g]);
  const w = () => l ? m ? C === "ltr" ? "topEnd" : "topStart" : C === "ltr" ? "topStart" : "topEnd" : m ? C === "ltr" ? "bottomEnd" : "bottomStart" : C === "ltr" ? "bottomStart" : "bottomEnd", M = L(
    () => e ? { [tt.foldedSelfviewWrapper]: !0 } : {
      [tt.pip]: !0,
      [tt.maximized]: g
    },
    [e, g]
  ), P = w(), T = w(), {
    isAudioInputMuted: R,
    isAudioInputDisabled: O,
    isVideoInputMuted: G,
    isAudioInputMissing: Y,
    isVideoInputMissing: J,
    onToggleVideoClick: _,
    onExpandSelfview: U,
    onToggleAudioClick: H,
    showSelfviewTooltip: q,
    setShowSelfviewTooltip: te,
    ...V
  } = i, I = {
    isAudioInputDisabled: O,
    isAudioInputMuted: R,
    isVideoInputMuted: G,
    isAudioInputMissing: Y,
    isVideoInputMissing: J,
    onToggleVideoClick: _,
    onExpandSelfview: U,
    onToggleAudioClick: H,
    showSelfviewTooltip: q,
    setShowSelfviewTooltip: te
  };
  return /* @__PURE__ */ n.createElement(n.Fragment, null, g && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: tt.maximizedMask,
      onPointerUp: (z) => z.stopPropagation()
    }
  ), /* @__PURE__ */ n.createElement(
    mn,
    {
      isDisabled: g,
      draggableAriaLabel: t,
      isMoveableWithArrowKeys: !0,
      showFocus: !1,
      floatRoot: a,
      isSidePanelVisible: o,
      isPhone: i.isMobileDevice,
      onRepositionSideEffect: B,
      shouldCaptureClick: !1,
      className: b(
        tt.inMeetingSelfviewPosition,
        M()
      ),
      ref: s,
      alignWithFloatRootTrigger: c,
      autoHideProps: r
    },
    e && /* @__PURE__ */ n.createElement(
      Ud,
      {
        ...I,
        notificationTooltipPos: P,
        selfviewBtnTooltipPos: T
      }
    ),
    /* @__PURE__ */ n.createElement(
      La,
      {
        isAudioInputMuted: R,
        isAudioInputDisabled: O,
        isAudioInputMissing: Y,
        isVideoInputMuted: G,
        onToggleAudioClick: H,
        aspectRatioWrapperClassName: e ? "d-none" : "",
        ...V,
        onPointerDownCapture: i.isMobileDevice ? (z) => {
          g && z.stopPropagation(), v(z);
        } : void 0,
        isMaximized: g,
        setIsMaximized: f
      }
    )
  ));
}, yv = ({
  autoHideProps: e,
  draggableAriaLabel: t,
  floatRoot: a,
  isSidePanelVisible: o,
  isMobileDevice: r,
  ...i
}) => /* @__PURE__ */ n.createElement(
  mn,
  {
    draggableAriaLabel: t,
    autoHideProps: e,
    floatRoot: a,
    isSidePanelVisible: o,
    isPhone: r,
    className: b(tt.inMeetingSelfviewPosition, tt.pip)
  },
  /* @__PURE__ */ n.createElement(La, { ...i })
), mm = "_joinCallDetailsWrapper_172vs_4", um = "_joinCallDetailsInnerWrapper_172vs_18", To = {
  joinCallDetailsWrapper: mm,
  joinCallDetailsInnerWrapper: um
}, pm = ({
  className: e,
  children: t,
  otherWaysToJoin: a,
  onMouseOut: o,
  onMouseOver: r,
  wrapperClassName: i,
  ...s
}) => /* @__PURE__ */ n.createElement(
  ye,
  {
    className: b(To.joinCallDetailsWrapper, i),
    ...s,
    "data-testid": u.JoinCallDetailsWrapper
  },
  /* @__PURE__ */ n.createElement(
    "div",
    {
      role: "region",
      onMouseOut: o,
      onMouseOver: r,
      onFocus: r,
      onBlur: o,
      className: To.joinCallDetailsInnerWrapper
    },
    /* @__PURE__ */ n.createElement("div", { className: e }, t),
    a
  )
), hm = "_joinTextWrapper_16hcp_1", gm = "_joinTextMargin_16hcp_5", Ro = {
  joinTextWrapper: hm,
  joinTextMargin: gm
}, zo = ({ children: e, displayInviteesModal: t, ...a }) => /* @__PURE__ */ n.createElement(pt, { onClick: t, ...a }, e), Fa = ({
  displayInviteesModal: e,
  descriptionFontVariant: t = S.H6,
  descriptionVariant: a = "tinted",
  isGuest: o,
  inMeetingCount: r,
  headingFontVariant: i = S.H3,
  headingClassName: s = "mb-2"
}) => {
  const { t: c } = y();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    Ie,
    {
      htmlTag: S.H1,
      fontVariant: i,
      className: s,
      "data-testid": u.CheckEverythingWorksText
    },
    /* @__PURE__ */ n.createElement(Z, { t: c, i18nKey: "media.check-everything-works" }, "Check that everything works")
  ), /* @__PURE__ */ n.createElement(
    N,
    {
      fontVariant: t,
      variant: a
    },
    !o && r ? r === 1 ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
      Z,
      {
        t: c,
        i18nKey: "preflight.in-this-meeting.singular"
      },
      /* @__PURE__ */ n.createElement(
        zo,
        {
          displayInviteesModal: e,
          fontVariant: t
        },
        "1 other person"
      ),
      " ",
      "is already inside."
    ), " ") : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
      Z,
      {
        t: c,
        i18nKey: "preflight.in-this-meeting.plural"
      },
      /* @__PURE__ */ n.createElement(
        zo,
        {
          displayInviteesModal: e,
          fontVariant: t
        },
        r,
        " other people"
      ),
      " ",
      "are already inside."
    ), " ") : null,
    /* @__PURE__ */ n.createElement(Z, { t: c, i18nKey: "media.check-everything-works-description" }, "Make sure that your equipment works so you can be heard and seen when you join.")
  ));
}, Bv = ({ displayInviteesModal: e, inMeetingCount: t, isGuest: a }) => /* @__PURE__ */ n.createElement("div", { className: Ro.joinTextMargin }, /* @__PURE__ */ n.createElement(ye, { className: Ro.joinTextWrapper }, /* @__PURE__ */ n.createElement(
  Fa,
  {
    displayInviteesModal: e,
    isGuest: a,
    inMeetingCount: t
  }
))), fm = "_joinCallDetails_mv0je_4", Em = "_blockingOverlay_mv0je_9", Wo = {
  joinCallDetails: fm,
  blockingOverlay: Em
}, vm = (e) => [
  Ue.DeviceSelection,
  Ue.BlockedDeviceSelection
].includes(e), kv = ({
  children: e,
  displayInviteesModal: t,
  inMeetingCount: a,
  isGuest: o,
  joinDetailsToRender: r,
  onMouseOut: i,
  onMouseOver: s,
  otherWaysToJoin: c,
  preflightDeviceSelection: l
}) => /* @__PURE__ */ n.createElement(
  pm,
  {
    className: b(
      Wo.joinCallDetails,
      r === Ue.BlockedDeviceSelection && Wo.blockingOverlay
    ),
    onMouseOut: i,
    onMouseOver: s,
    otherWaysToJoin: c
  },
  /* @__PURE__ */ n.createElement(
    Fa,
    {
      isGuest: o,
      inMeetingCount: a,
      displayInviteesModal: t,
      descriptionFontVariant: S.Body,
      descriptionVariant: "standard",
      headingFontVariant: S.H4,
      headingClassName: "mb-4"
    }
  ),
  vm(r) && /* @__PURE__ */ n.createElement(
    "div",
    {
      "data-testid": r === Ue.BlockedDeviceSelection ? u.DevicesSelectionBlocked : u.DevicesSelection
    },
    l
  ),
  /* @__PURE__ */ n.createElement(Ne, { spacing: "compact", className: "mt-3" }, e)
), wv = ({ isDisabled: e, onClick: t, className: a, callType: o }) => {
  const { t: r } = y(), i = () => {
    switch (o) {
      case gn.AudioSendRecvVideoSendRecvPresentationSendRecv:
        return r("common.join-with-video", "Join with video");
      case gn.AudioSendRecvPresentationSendRecv:
        return r("common.join-with-audio", "Join with audio");
      case gn.PresentationSendRecv:
        return r(
          "common.join-with-presentation-only",
          "Join with presentation only"
        );
      default:
        return r("common.join", "Join");
    }
  };
  return /* @__PURE__ */ n.createElement(
    D,
    {
      className: a,
      isDisabled: e,
      onClick: t,
      onKeyDown: Rr(t),
      size: "large",
      type: "submit",
      variant: "success",
      modifier: "fullWidth",
      "data-testid": u.ButtonJoinMeeting
    },
    i()
  );
}, xv = ({ isDisabled: e, className: t, onWithVideoClick: a, onWithAudioOnlyClick: o }) => {
  const { t: r } = y(), [i, s] = x(!1), c = [
    {
      key: "join-with-video",
      label: r("common.join-with-video", "Join with video"),
      testId: u.ButtonJoinWithVideo,
      onItemClick: a,
      closeMenuOnItemClick: !0
    },
    {
      key: "join-audio-only",
      label: r("common.join-audio-only", "Join audio only"),
      testId: u.ButtonJoinAudioOnly,
      onItemClick: o,
      closeMenuOnItemClick: !0
    }
  ];
  return /* @__PURE__ */ n.createElement(
    an,
    {
      onOpenChange: s,
      items: c,
      button: /* @__PURE__ */ n.createElement(
        D,
        {
          className: t,
          isActive: i,
          enhancerStart: /* @__PURE__ */ n.createElement(F, { source: k.IconVideoOn }),
          enhancerEnd: /* @__PURE__ */ n.createElement(
            F,
            {
              source: i ? k.IconChevronUp : k.IconChevronDown
            }
          ),
          isDisabled: e,
          size: "medium",
          variant: "success",
          "data-testid": u.ButtonJoinMeetingWithOptions
        },
        r("common.join", "Join")
      ),
      popoverPlacement: "bottom right"
    }
  );
}, Mv = ({ join: e, children: t }) => {
  const { t: a } = y();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    D,
    {
      size: "large",
      modifier: "fullWidth",
      onClick: e,
      variant: "tertiary",
      className: "mt-5"
    },
    /* @__PURE__ */ n.createElement(Z, { t: a, i18nKey: "preflight.join-browser" }, "Join meeting in browser")
  ), t);
}, Cm = ({
  devices: e,
  defaultDeviceLabel: t,
  label: a,
  selectedDeviceId: o
}) => {
  if (e.length === 0)
    return [];
  if (!e.some(li)) {
    const i = e.at(0);
    return Xt(i, "Placeholder device must be defined"), [
      { id: "", label: a },
      {
        id: In(i),
        label: t
      }
    ];
  }
  const r = e.map((i) => ({
    id: In(i),
    label: i.label
  }));
  return o ? r : [{ label: a, id: "" }, ...r];
}, mt = ({
  devices: e,
  kind: t,
  iconType: a,
  isDisabled: o = !1,
  label: r,
  selected: i,
  onDeviceChange: s,
  className: c,
  sizeModifier: l = "small",
  ...d
}) => {
  const { t: m } = y(), p = i ? In(i) : "", g = Fe(() => {
    let f = "";
    switch (t) {
      case "audioinput": {
        f = m(
          "media.default-microphone-label",
          "Default microphone"
        );
        break;
      }
      case "videoinput": {
        f = m(
          "media.default-camera-label",
          "Default camera"
        );
        break;
      }
      case "audiooutput": {
        f = m(
          "media.default-speaker-label",
          "Default speaker"
        );
        break;
      }
    }
    return Cm({
      devices: e.get({ kind: t }),
      defaultDeviceLabel: f,
      selectedDeviceId: p,
      label: r
    });
  }, [e, t, m, p, r]);
  return /* @__PURE__ */ n.createElement(
    ra,
    {
      value: p,
      onValueChange: s,
      options: g,
      iconType: a,
      label: r,
      labelModifier: "hidden",
      className: b("mb-1", c),
      isFullWidth: !0,
      isDisabled: o,
      sizeModifier: l,
      ...d
    }
  );
}, bm = "_missingDeviceButton_1h04w_13", ym = "_deviceDeniedTooltipMainWrapper_1h04w_28", Bm = "_deviceDeniedTooltipWrapper_1h04w_32", km = "_warningIcon_1h04w_36", wt = {
  missingDeviceButton: bm,
  deviceDeniedTooltipMainWrapper: ym,
  deviceDeniedTooltipWrapper: Bm,
  warningIcon: km
}, Lo = ({
  className: e,
  deniedDevice: t,
  learnHowToGrantAccessURL: a,
  permissionInfoType: o,
  title: r,
  tooltip: i,
  setIsTooltipVisible: s,
  isTooltipVisible: c,
  icon: l = k.IconAlert,
  setShowHelpVideo: d,
  showTooltip: m = !0,
  ...p
}) => {
  const { t: g } = y(), f = /* @__PURE__ */ n.createElement(
    rn,
    {
      htmlTag: "div",
      className: b(
        "pl-2",
        "pr-3",
        wt.missingDeviceButton,
        e
      ),
      onClick: () => s(!c),
      title: r,
      ...p
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        source: l,
        className: b("mr-2", wt.warningIcon),
        colorScheme: "dark",
        size: "compact"
      }
    ),
    /* @__PURE__ */ n.createElement(N, { isTruncated: !0, colorScheme: "light", variant: "danger" }, r)
  );
  return m ? t && d ? /* @__PURE__ */ n.createElement(
    _n,
    {
      learnHowToGrantAccessURL: a,
      permissionInfoType: o,
      deniedDevice: t,
      onClose: () => s(!c),
      visible: c,
      "data-testid": u.TooltipDeniedDevice,
      contentWrapperClassName: wt.deviceDeniedTooltipWrapper,
      mainWrapperClassName: wt.deviceDeniedTooltipMainWrapper,
      setShowHelpVideo: d
    },
    f
  ) : /* @__PURE__ */ n.createElement(
    ot,
    {
      header: r,
      text: i || "",
      position: "topCenter",
      ctaFn: () => s(!c),
      controlledIsVisible: c,
      controlledOnChange: s,
      testIdInner: u.NotificationToolTipDeviceError,
      mainWrapperClassName: wt.deviceDeniedTooltipMainWrapper,
      closeButtonAriaLabel: g("common.close-tooltip", "Close tooltip")
    },
    f
  ) : f;
}, wm = "_deviceListWrapper_a3bcs_1", xm = {
  deviceListWrapper: wm
}, Mm = ({
  audioInput: e,
  audioInputError: t,
  audioOutput: a,
  devices: o,
  isLoading: r = !1,
  requestedAudio: i = !0,
  requestedVideo: s = !0,
  onAudioInputChange: c,
  onAudioOutputChange: l,
  onVideoInputChange: d,
  inputAudioTester: m,
  outputAudioTester: p,
  videoInput: g,
  videoInputError: f,
  learnHowToGrantAccessURL: v,
  permissionInfoType: E,
  sizeModifier: C,
  setShowHelpVideo: B,
  showTooltip: w = !1,
  disableAudioInputSelector: M,
  disableVideoInputSelector: P,
  disableAudioOutputSelector: T
}) => {
  const { t: R } = y(), [O, G] = x({
    audio: !1,
    video: !1
  }), Y = (q) => {
    G({
      audio: !1,
      video: q
    });
  }, J = (q) => {
    G({
      audio: q,
      video: !1
    });
  }, _ = !P && f?.title && o.size("videoinput") < 2, U = !M && t?.title && o.size("audioinput") < 2, H = o.size("audiooutput") > 0 && !t?.title;
  return /* @__PURE__ */ n.createElement(ye, { spacing: "none", className: xm.deviceListWrapper }, _ ? /* @__PURE__ */ n.createElement(
    Lo,
    {
      className: "mb-3",
      title: f.title,
      tooltip: f.description,
      deniedDevice: f.deniedDevice,
      learnHowToGrantAccessURL: v,
      permissionInfoType: E,
      "data-testid": u.MissingVideoDeviceAlert,
      setIsTooltipVisible: Y,
      isTooltipVisible: O.video,
      setShowHelpVideo: B,
      showTooltip: w
    }
  ) : /* @__PURE__ */ n.createElement(
    mt,
    {
      className: "mb-3",
      kind: "videoinput",
      isDisabled: r || P,
      label: R(
        "settings.device-select.select-camera",
        "Select camera"
      ),
      "data-testid": u.SelectVideoInput,
      errorText: f?.title,
      errorTextTestId: u.SelectVideoInputErrorText,
      hasError: s && !!f?.title,
      onDeviceChange: d,
      iconType: k.IconVideoOn,
      selected: g,
      devices: o,
      sizeModifier: C
    }
  ), U ? /* @__PURE__ */ n.createElement(
    Lo,
    {
      className: "mb-2",
      title: t.title,
      tooltip: t.description,
      deniedDevice: t.deniedDevice,
      learnHowToGrantAccessURL: v,
      permissionInfoType: E,
      "data-testid": u.MissingAudioDeviceAlert,
      setIsTooltipVisible: J,
      isTooltipVisible: O.audio,
      setShowHelpVideo: B,
      showTooltip: w
    }
  ) : /* @__PURE__ */ n.createElement(
    mt,
    {
      className: m ? "mb-2" : "mb-3",
      kind: "audioinput",
      isDisabled: r || M,
      label: R(
        "settings.device-select.select-microphone",
        "Select microphone"
      ),
      "data-testid": u.SelectAudioInput,
      errorText: t?.title,
      errorTextTestId: u.SelectAudioInputErrorText,
      hasError: i && !!t?.title,
      onDeviceChange: c,
      iconType: k.IconMicrophoneOn,
      selected: e,
      devices: o,
      sizeModifier: C
    }
  ), m && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(
        "p-0",
        "mb-2",
        "d-flex",
        "flex-direction-column",
        "align-items-end"
      )
    },
    m,
    !H && p
  ), H && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    mt,
    {
      isDisabled: r || T,
      kind: "audiooutput",
      label: R(
        "settings.device-select.select-speaker",
        "Select speaker"
      ),
      "data-testid": u.SelectAudioOutput,
      onDeviceChange: l,
      iconType: k.IconSpeakerOn,
      selected: a,
      devices: o,
      sizeModifier: C,
      className: "m-0"
    }
  ), p && /* @__PURE__ */ n.createElement(ae, { className: "p-0 mt-2 justify-content-end" }, p)));
}, Iv = ({
  devices: e,
  videoInputError: t,
  audioInputError: a,
  videoInput: o,
  audioInput: r,
  audioOutput: i,
  disableAudioInputSelector: s,
  disableVideoInputSelector: c,
  disableAudioOutputSelector: l,
  onAudioInputChange: d,
  onAudioOutputChange: m,
  onVideoInputChange: p,
  isLoading: g = !1,
  requestedAudio: f = !0,
  requestedVideo: v = !0,
  inputAudioTester: E,
  outputAudioTester: C,
  learnHowToGrantAccessURL: B,
  permissionInfoType: w,
  sizeModifier: M,
  setShowHelpVideo: P
}) => /* @__PURE__ */ n.createElement(ae, { spacing: "medium" }, /* @__PURE__ */ n.createElement(
  Mm,
  {
    disableVideoInputSelector: c,
    disableAudioInputSelector: s,
    disableAudioOutputSelector: l,
    requestedAudio: f,
    requestedVideo: v,
    devices: e,
    videoInputError: t,
    audioInputError: a,
    videoInput: o,
    audioInput: r,
    audioOutput: i,
    onAudioInputChange: d,
    onAudioOutputChange: m,
    onVideoInputChange: p,
    isLoading: g,
    inputAudioTester: E,
    outputAudioTester: C,
    learnHowToGrantAccessURL: B,
    permissionInfoType: w,
    sizeModifier: M,
    setShowHelpVideo: P,
    showTooltip: !0
  }
)), Im = "_wrapper_pgsa7_1", Sm = {
  wrapper: Im
}, Sv = ({ onClick: e, shouldPlay: t }) => {
  const { t: a } = y();
  return /* @__PURE__ */ n.createElement(
    pt,
    {
      fontVariant: S.SmallLink,
      "data-testid": u.LinkTestAudioOutput,
      onClick: e,
      className: Sm.wrapper
    },
    t ? a("settings.playing-sound", "Playing sound...") : a("settings.test-your-sound", "Test your sound")
  );
}, Pm = "_modal_1x9k0_4", Nm = "_audioSelect_1x9k0_8", Tm = "_playingBackDeviceSelectionContent_1x9k0_12", Rm = "_contentBoxWrapper_1x9k0_16", zm = "_playbackDescriptionRow_1x9k0_27", Wm = "_tryThis_1x9k0_31", Lm = "_tryThisOrderedList_1x9k0_34", Fm = "_replayButton_1x9k0_45", Qm = "_replayText_1x9k0_51", xe = {
  modal: Pm,
  audioSelect: Nm,
  playingBackDeviceSelectionContent: Tm,
  contentBoxWrapper: Rm,
  playbackDescriptionRow: zm,
  tryThis: Wm,
  tryThisOrderedList: Lm,
  replayButton: Fm,
  replayText: Qm
}, Am = ({ devices: e, selectedAudioInput: t, onAudioInputChange: a, startTest: o }) => {
  const { t: r } = y();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(ae, null, /* @__PURE__ */ n.createElement(N, { fontVariant: S.H6 }, r(
    "media.first-check-that-you-have-selected-microphone",
    "First, check that you have selected the correct microphone and that your volume is turned up."
  ))), /* @__PURE__ */ n.createElement(ae, { className: "p-0 mt-4" }, /* @__PURE__ */ n.createElement(
    mt,
    {
      isDisabled: !1,
      kind: "audioinput",
      onDeviceChange: a,
      selected: t,
      iconType: k.IconMicrophoneOn,
      label: r(
        "settings.device-select.select-microphone",
        "Select microphone"
      ),
      devices: e,
      className: xe.audioSelect,
      sizeModifier: "medium",
      "data-testid": u.SelectTestAudioInput
    }
  )), /* @__PURE__ */ n.createElement(ae, { className: "p-0 mt-10 justify-content-center" }, /* @__PURE__ */ n.createElement(
    D,
    {
      onClick: o,
      size: "large",
      "data-testid": u.ButtonTestAudioInputStart
    },
    r("media.start-test", "Start test")
  )));
}, Qa = ({
  className: e,
  titleVariant: t = S.H6,
  countTitleVariant: a = S.H5
}) => {
  const { t: o } = y();
  return /* @__PURE__ */ n.createElement("div", { className: e }, /* @__PURE__ */ n.createElement(N, { fontVariant: t }, /* @__PURE__ */ n.createElement(Z, { t: o, i18nKey: "media.you-can-say-something-like" }, "You can say something like", " "), /* @__PURE__ */ n.createElement(N, { fontVariant: a }, o("media.testing-my-microphone", '"Testing 1, 2, 3"'))));
}, Aa = ({ children: e, showBorder: t }) => /* @__PURE__ */ n.createElement(
  Re,
  {
    className: b(xe.contentBoxWrapper),
    isWithShadow: !1,
    isWithBorder: t
  },
  e
), Vm = 3, Om = () => /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(Qa, { className: "mt-2 mb-4" }), /* @__PURE__ */ n.createElement(ae, null, /* @__PURE__ */ n.createElement(Aa, null, /* @__PURE__ */ n.createElement(
  zr,
  {
    shouldStartCountDown: !0,
    startCountFrom: Vm
  }
)))), Dm = ({ children: e, isRecordSuccess: t }) => /* @__PURE__ */ n.createElement("div", null, !t && /* @__PURE__ */ n.createElement(Qa, { className: "mt-2 mb-4" }), /* @__PURE__ */ n.createElement(ae, { className: b("mt-2", t && "mt-10") }, e)), jm = ({
  devices: e,
  selectedAudioInput: t,
  selectedAudioOutput: a,
  onOutputInputChange: o,
  onAudioInputChange: r,
  tryAgain: i
}) => {
  const { t: s } = y();
  return /* @__PURE__ */ n.createElement(ae, { className: xe.playingBackDeviceSelectionContent }, /* @__PURE__ */ n.createElement(
    ia,
    {
      className: xe.tryThis,
      title: s(
        "media.if-you-dont-hear-yourself-try-this",
        "If you don't hear yourself, try this"
      ),
      dataTestId: u.ButtonTestAudioInputTryAgain
    },
    /* @__PURE__ */ n.createElement(ae, null, /* @__PURE__ */ n.createElement("ol", { className: xe.tryThisOrderedList }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement(N, null, s(
      "media.make-sure-you-have-the-correct-microphone",
      "Make sure you have the correct microphone"
    )), /* @__PURE__ */ n.createElement(ae, null, /* @__PURE__ */ n.createElement(
      mt,
      {
        isDisabled: !1,
        kind: "audioinput",
        onDeviceChange: r,
        selected: t,
        iconType: k.IconMicrophoneOn,
        label: s(
          "settings.device-select.select-microphone",
          "Select microphone"
        ),
        devices: e,
        className: xe.audioSelect,
        "data-testid": u.SelectTestAudioInputPlayback
      }
    )), e.size("audiooutput") > 0 && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(N, null, s(
      "media.make-sure-you-have-the-correct-speaker",
      "Make sure you have the correct speaker"
    )), /* @__PURE__ */ n.createElement(ae, null, /* @__PURE__ */ n.createElement(
      mt,
      {
        isDisabled: !1,
        kind: "audiooutput",
        onDeviceChange: o,
        selected: a,
        iconType: k.IconSpeakerOn,
        label: s(
          "settings.device-select.select-speaker",
          "Select speaker"
        ),
        devices: e,
        className: xe.audioSelect,
        "data-testid": u.SelectTestAudioInputSpeakerPlayback
      }
    ))), /* @__PURE__ */ n.createElement(ae, { className: "justify-content-end" }, /* @__PURE__ */ n.createElement(
      D,
      {
        onClick: i,
        "data-testid": u.ButtonTestAudioInputAgain
      },
      s("common.try-again", "Try again")
    ))), /* @__PURE__ */ n.createElement("li", null, s(
      "media.make-sure-the-volume-is-turned-up-on-your-device",
      "Make sure the volume is turned up on your device."
    )), /* @__PURE__ */ n.createElement("li", null, s(
      "media.do you have headphones connected to-your-device",
      "Do you have headphones connected to your device? Make sure the microphone of the headphones is near your mouth."
    )), /* @__PURE__ */ n.createElement("li", null, s(
      "media.you-may-need-to-connect-speakers-or-headphones",
      "If you are using a desktop computer, you may need to connect speakers or headphones."
    ))))
  ));
}, Ym = ({
  devices: e,
  children: t,
  selectedAudioInput: a,
  selectedAudioOutput: o,
  onOutputInputChange: r,
  onAudioInputChange: i,
  tryAgain: s
}) => {
  const { t: c } = y();
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(ae, { className: b("mt-2", xe.playbackDescriptionRow) }, /* @__PURE__ */ n.createElement(N, { fontVariant: S.H6 }, c(
    "media.this-is-how-you-will-sound-to-others",
    "This is how you will sound to others"
  ))), t, /* @__PURE__ */ n.createElement(ae, { className: "mt-2" }, /* @__PURE__ */ n.createElement(
    jm,
    {
      devices: e,
      selectedAudioInput: a,
      selectedAudioOutput: o,
      onOutputInputChange: r,
      onAudioInputChange: i,
      tryAgain: s
    }
  )));
}, Hm = ({ currentStage: e }) => {
  const { t } = y();
  return /* @__PURE__ */ n.createElement(Ie, { htmlTag: "h3", fontVariant: S.H3 }, t(
    [
      // FIXME: Cast is wrong, but the combination of an array as
      // an argument to t and typed t doesn't seem to work very well
      `media.test-your-microphone-title-[${e}]`,
      `media.test-your-microphone-title-[${Va.BeforeTesting}]`
    ],
    "Test your microphone"
  ));
}, Zm = ({ replay: e }) => {
  const { t } = y();
  return /* @__PURE__ */ n.createElement(Aa, null, /* @__PURE__ */ n.createElement("div", { className: "d-flex flex-direction-column align-items-center" }, /* @__PURE__ */ n.createElement(
    D,
    {
      onClick: e,
      className: xe.replayButton,
      variant: "tertiary",
      size: "none"
    },
    /* @__PURE__ */ n.createElement(F, { source: k.IconRefresh })
  ), /* @__PURE__ */ n.createElement(N, { className: xe.replayText }, t("common.replay", "Replay"))));
};
var Va = /* @__PURE__ */ ((e) => (e.BeforeTesting = "before-testing", e.GetReady = "get-ready", e.Recording = "recording", e.RecordingSuccess = "recording-success", e.PlayingBack = "playing-back", e.PlaybackFinished = "playback-finished", e))(Va || {});
const Pv = ({
  audioMeter: e,
  className: t,
  currentStage: a = "before-testing",
  devices: o,
  selectedAudioInput: r,
  selectedAudioOutput: i,
  isOpen: s,
  onClose: c,
  onAudioInputChange: l,
  onAudioOutputChange: d,
  startTest: m,
  closeOnOutsideClick: p = !1,
  tryAgain: g,
  replay: f
}) => {
  const { t: v } = y(), { modalHandleRef: E, focusModal: C } = sa(), B = () => {
    switch (a) {
      case "get-ready":
        return /* @__PURE__ */ n.createElement(Om, null);
      case "recording":
      case "recording-success":
        return /* @__PURE__ */ n.createElement(
          Dm,
          {
            isRecordSuccess: a === "recording-success"
            /* RecordingSuccess */
          },
          e
        );
      case "playing-back":
      case "playback-finished":
        return /* @__PURE__ */ n.createElement(
          Ym,
          {
            devices: o,
            onAudioInputChange: l,
            onOutputInputChange: d,
            selectedAudioInput: r,
            selectedAudioOutput: i,
            tryAgain: g
          },
          a === "playback-finished" ? /* @__PURE__ */ n.createElement(Zm, { replay: f }) : e
        );
      default:
        return /* @__PURE__ */ n.createElement(
          Am,
          {
            onAudioInputChange: l,
            selectedAudioInput: r,
            devices: o,
            startTest: m
          }
        );
    }
  };
  return A(() => {
    s && C();
  }, [s, a, C]), s ? /* @__PURE__ */ n.createElement(
    at,
    {
      ref: E,
      padding: "medium",
      isOpen: s,
      closeOnOutsideClick: p,
      onClose: c,
      withCloseButton: !0,
      uniqueTitle: v(
        "media.test-your-microphone",
        "Test your microphone"
      ),
      className: b(xe.modal, t)
    },
    /* @__PURE__ */ n.createElement(Hm, { currentStage: a }),
    B()
  ) : null;
}, Gm = "_wrapper_pgsa7_1", Jm = {
  wrapper: Gm
}, Nv = ({ onClick: e, isDisabled: t }) => /* @__PURE__ */ n.createElement(
  pt,
  {
    fontVariant: S.SmallLink,
    "data-testid": u.LinkTestAudioInput,
    onClick: e,
    isDisabled: t,
    className: Jm.wrapper
  },
  /* @__PURE__ */ n.createElement(Z, { i18nKey: "media.test-your-microphone" }, "Test your microphone")
), Um = "_fullSizeWindow_t2v2h_1", qm = {
  fullSizeWindow: Um
}, Tv = ({ ...e }) => /* @__PURE__ */ n.createElement(
  Wn,
  {
    padding: "none",
    background: "dark",
    flexDirection: "column",
    justifyContent: "center",
    className: qm.fullSizeWindow,
    "data-testid": u.MeetingWrapper,
    "data-meeting-wrapper": !0,
    ...e
  }
), Xm = (e) => /* @__PURE__ */ h.createElement("svg", { width: 348, height: 177, viewBox: "0 0 348 177", fill: "none", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ h.createElement("rect", { width: 348, height: 177, rx: 6.51312, fill: "#F4F4F4" }), /* @__PURE__ */ h.createElement("rect", { x: 51, y: 29, width: 235.287, height: 120.164, rx: 4.0707, fill: "#E0E0E0" }), /* @__PURE__ */ h.createElement("rect", { x: 129.148, y: 49.1641, width: 139.491, height: 10.0837, rx: 4.0707, fill: "#AEAEAE" }), /* @__PURE__ */ h.createElement("rect", { x: 129.148, y: 68.4961, width: 139.491, height: 10.0837, rx: 4.0707, fill: "#AEAEAE" }), /* @__PURE__ */ h.createElement("rect", { x: 129.148, y: 89.5, width: 139.491, height: 10.0837, rx: 4.0707, fill: "#AEAEAE" }), /* @__PURE__ */ h.createElement("rect", { x: 189.094, y: 110.914, width: 78.7858, height: 23.4242, rx: 4.38484, stroke: "#575757" }), /* @__PURE__ */ h.createElement("path", { d: "M206.076 127.113H204.587L207.297 119.416H209.018L211.732 127.113H210.244L208.188 120.995H208.128L206.076 127.113ZM206.124 124.095H210.184V125.215H206.124V124.095ZM214.046 119.416V127.113H212.686V119.416H214.046ZM216.806 119.416V127.113H215.445V119.416H216.806ZM220.723 127.226C220.159 127.226 219.671 127.102 219.257 126.854C218.844 126.606 218.523 126.259 218.295 125.813C218.07 125.367 217.957 124.846 217.957 124.249C217.957 123.653 218.07 123.131 218.295 122.682C218.523 122.234 218.844 121.885 219.257 121.637C219.671 121.389 220.159 121.265 220.723 121.265C221.287 121.265 221.776 121.389 222.189 121.637C222.602 121.885 222.922 122.234 223.147 122.682C223.375 123.131 223.489 123.653 223.489 124.249C223.489 124.846 223.375 125.367 223.147 125.813C222.922 126.259 222.602 126.606 222.189 126.854C221.776 127.102 221.287 127.226 220.723 127.226ZM220.731 126.136C221.036 126.136 221.292 126.052 221.497 125.884C221.703 125.714 221.856 125.486 221.956 125.2C222.059 124.915 222.11 124.596 222.11 124.246C222.11 123.892 222.059 123.573 221.956 123.287C221.856 122.999 221.703 122.77 221.497 122.599C221.292 122.429 221.036 122.344 220.731 122.344C220.417 122.344 220.157 122.429 219.949 122.599C219.743 122.77 219.589 122.999 219.487 123.287C219.386 123.573 219.336 123.892 219.336 124.246C219.336 124.596 219.386 124.915 219.487 125.2C219.589 125.486 219.743 125.714 219.949 125.884C220.157 126.052 220.417 126.136 220.731 126.136ZM225.67 127.113L224.039 121.34H225.426L226.441 125.399H226.493L227.531 121.34H228.903L229.94 125.377H229.996L230.996 121.34H232.387L230.752 127.113H229.335L228.252 123.212H228.173L227.091 127.113H225.67Z", fill: "#333333" }), /* @__PURE__ */ h.createElement("rect", { x: 85.7812, y: 110.414, width: 79.7858, height: 24.4242, rx: 4.0707, fill: "#AEAEAE" }), /* @__PURE__ */ h.createElement("circle", { cx: 94.6987, cy: 73.5385, r: 20.1674, fill: "#AEAEAE" }), /* @__PURE__ */ h.createElement("rect", { x: 159, y: 98, width: 143.694, height: 49.8195, fill: "url(#pattern0)" }), /* @__PURE__ */ h.createElement("defs", null, /* @__PURE__ */ h.createElement("pattern", { id: "pattern0", patternContentUnits: "objectBoundingBox", width: 1, height: 1 }, /* @__PURE__ */ h.createElement("use", { xlinkHref: "#image0_4573_112121", transform: "scale(0.00286533 0.00826446)" })), /* @__PURE__ */ h.createElement("image", { id: "image0_4573_112121", width: 349, height: 121, xlinkHref: "data:image/png;base64,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" }))), Km = "_boxWrapper_17qck_1", _m = "_svgWrapper_17qck_5", Fo = {
  boxWrapper: Km,
  svgWrapper: _m
}, Rv = ({ requestAccess: e, requesting: t, title: a, message: o }) => {
  const { t: r } = y();
  return /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, /* @__PURE__ */ n.createElement(Re, { padding: "large", className: Fo.boxWrapper }, /* @__PURE__ */ n.createElement(ye, { spacing: "none" }, /* @__PURE__ */ n.createElement(Vn, { className: Fo.svgWrapper, source: Xm }), /* @__PURE__ */ n.createElement(N, { fontVariant: S.H3, className: "mt-4" }, a), /* @__PURE__ */ n.createElement(N, { className: "mt-4" }, o), /* @__PURE__ */ n.createElement(Xe, { className: "mt-7" }, /* @__PURE__ */ n.createElement(
    D,
    {
      "data-testid": u.ButtonRequestPermissions,
      modifier: "fullWidth",
      onClick: e,
      size: "large",
      isLoading: t
    },
    /* @__PURE__ */ n.createElement(Z, { t: r, i18nKey: "common.ask-for-permission" }, "Request permission")
  )))));
}, $m = "_newMessagesPillWrapper_1bmzr_4", eu = "_newMessagesPill_1bmzr_4", tu = "_newMessagesPillContent_1bmzr_12", nu = "_newMessageText_1bmzr_18", ou = "_closeButton_1bmzr_25", xt = {
  newMessagesPillWrapper: $m,
  newMessagesPill: eu,
  newMessagesPillContent: tu,
  newMessageText: nu,
  closeButton: ou
}, au = ({ newMessagesCount: e, closeNewChatMessage: t, scrollToLastMessage: a }) => {
  const { t: o } = y(), r = Fe(
    () => e > 1 ? o("meeting.chat-new-messages", {
      defaultValue: "{{newMessagesCount}} new messages",
      newMessagesCount: e
    }) : o("meeting.chat-new-message", "new message"),
    [e, o]
  );
  return /* @__PURE__ */ n.createElement("div", { className: xt.newMessagesPillWrapper }, /* @__PURE__ */ n.createElement(
    rn,
    {
      "aria-label": o(
        "meeting.chat-scroll-last-message",
        "Scroll to last chat message"
      ),
      onClick: a,
      "data-testid": u.PillNewChatMessage
    },
    /* @__PURE__ */ n.createElement(oa, { className: xt.newMessagesPill }, /* @__PURE__ */ n.createElement("div", { className: xt.newMessagesPillContent }, /* @__PURE__ */ n.createElement(F, { source: k.IconArrowDown, size: "compact" }), /* @__PURE__ */ n.createElement("div", { className: "ml-2 mr-2" }, /* @__PURE__ */ n.createElement(N, { className: xt.newMessageText }, r))), /* @__PURE__ */ n.createElement("div", { className: "pr-3" }))
  ), /* @__PURE__ */ n.createElement(
    Qn,
    {
      onClose: t,
      "aria-label": o(
        "meeting.close-new-chat-alert",
        "Close new chat message alert"
      ),
      className: xt.closeButton
    }
  ));
}, Oa = ({
  iconSource: e,
  iconSize: t = "compact",
  children: a,
  variant: o = "translucent",
  hideChildren: r,
  ...i
}) => {
  const s = On(), c = !!a, l = r ?? s;
  return /* @__PURE__ */ n.createElement(
    D,
    {
      variant: o,
      hideChildren: l,
      noEnhancerPadding: !c || l,
      modifier: l ? "square" : void 0,
      enhancerStart: e && /* @__PURE__ */ n.createElement(F, { source: e, size: t }),
      ...i
    },
    a
  );
}, ru = ({ onLeave: e }) => {
  const { t } = y();
  return /* @__PURE__ */ n.createElement(
    Oa,
    {
      className: Ee.desktopLeaveBtn,
      iconSource: k.IconPhoneHorisontal,
      onClick: e,
      variant: "danger",
      "data-testid": u.ButtonLeave,
      hideChildren: !1,
      size: "large",
      "aria-label": t("meeting.leave-aria-label", "Leave meeting"),
      noEnhancerPadding: !0
    },
    /* @__PURE__ */ n.createElement("div", { className: Ee.desktopLeaveText }, t("meeting.leave", "Leave"))
  );
}, iu = ({ onLeave: e, iconSize: t, ...a }) => {
  const { t: o } = y();
  return /* @__PURE__ */ n.createElement(
    D,
    {
      onClick: e,
      variant: "danger",
      modifier: "square",
      size: "large",
      "aria-label": o("meeting.leave-aria-label", "Leave meeting"),
      "data-testid": u.ButtonLeave,
      ...a
    },
    /* @__PURE__ */ n.createElement(F, { source: k.IconPhoneHorisontal, size: t })
  );
}, Da = ({ isVideoMuted: e, onVideoBtnClick: t, iconSize: a, tooltipClassName: o, ...r }) => {
  const { t: i } = y(), s = e ? i("media.turn-camera-on", "Turn camera on") : i("media.turn-camera-off", "Turn camera off"), c = e ? u.ButtonMeetingVideoInputMuted : u.ButtonMeetingVideoInput;
  return /* @__PURE__ */ n.createElement(
    Ae,
    {
      isActive: e,
      onClick: t,
      tooltipPosition: "top",
      tooltipText: s,
      tooltipClassName: o,
      "data-testid": c,
      "aria-label": s,
      icon: e ? /* @__PURE__ */ n.createElement(F, { source: k.IconVideoOff, size: a }) : /* @__PURE__ */ n.createElement(F, { source: k.IconVideoOn, size: a }),
      ...r
    }
  );
}, su = ({ isAudioMuted: e, muteText: t }) => {
  const { t: a } = y();
  return /* @__PURE__ */ n.createElement("div", { className: "p-2 d-flex flex-direction-column align-items-center" }, /* @__PURE__ */ n.createElement(N, null, `${t} (M)`), e && /* @__PURE__ */ n.createElement(N, { fontVariant: S.Small, className: "mt-1" }, /* @__PURE__ */ n.createElement(Z, { t: a, i18nKey: "media.push-to-talk" }, "Push and hold your space bar to unmute yourself temporarily")));
}, ja = ({
  isMicrophoneMuted: e,
  onAudioBtnClick: t,
  iconSize: a,
  canMute: o = !0,
  tooltipClassName: r,
  ...i
}) => {
  const { t: s } = y(), c = e ? s("media.unmute-microphone", "Unmute microphone") : s("media.mute-microphone", "Mute microphone"), l = e ? u.ButtonMeetingAudioInputMuted : u.ButtonMeetingAudioInput;
  return /* @__PURE__ */ n.createElement(
    Ae,
    {
      canMute: o,
      isActive: e,
      onClick: t,
      tooltipPosition: "top",
      tooltipText: /* @__PURE__ */ n.createElement(
        su,
        {
          isAudioMuted: e,
          muteText: c
        }
      ),
      tooltipClassName: r,
      "data-testid": l,
      "aria-label": c,
      icon: e ? /* @__PURE__ */ n.createElement(
        F,
        {
          source: k.IconMicrophoneOff,
          size: a
        }
      ) : /* @__PURE__ */ n.createElement(F, { source: k.IconMicrophoneOn, size: a }),
      ...i
    }
  );
}, zv = ({
  isAudioError: e,
  isVideoError: t,
  isBothError: a,
  audioTooltipVisible: o,
  videoTooltipVisible: r,
  toggleAudioTooltip: i,
  toggleVideoTooltip: s,
  audioStatusInfo: c,
  videoStatusInfo: l,
  audioTooltipText: d,
  canMuteAudio: m,
  iconSize: p,
  isAudioMuteDisabled: g,
  isAudioSuspended: f,
  isMicrophoneMuted: v,
  isRequestingAudio: E,
  isRequestingVideo: C,
  isVideoMuteDisabled: B,
  isVideoMuted: w,
  isVideoSuspended: M,
  onAudioBtnClick: P,
  onLeave: T,
  onVideoBtnClick: R,
  requestDeviceAgain: O,
  ...G
}) => {
  const Y = "neutral";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(Ee.callControlsWrapper, Ee.desktopWrapper),
      ...G
    },
    /* @__PURE__ */ n.createElement("div", { className: Ee.desktopMediaBtnWrapper }, /* @__PURE__ */ n.createElement(
      ja,
      {
        canMute: m,
        hasError: e || a,
        iconSize: p,
        inputStatusInfo: c,
        isDisabled: g,
        isLoading: E,
        isMicrophoneMuted: v,
        isSuspended: f,
        onAudioBtnClick: a ? s : P,
        requestDeviceAgain: O,
        shouldShowTooltip: o,
        toggleTooltip: i,
        tooltipClassName: Ee.desktopAudioButtonTooltip,
        variant: Y
      }
    ), /* @__PURE__ */ n.createElement(
      Da,
      {
        hasError: t,
        iconSize: p,
        inputStatusInfo: l,
        isDisabled: B,
        isLoading: C,
        isSuspended: M,
        isVideoMuted: w,
        onVideoBtnClick: R,
        requestDeviceAgain: O,
        shouldShowTooltip: r,
        toggleTooltip: s,
        tooltipClassName: Ee.desktopVideoButtonTooltip,
        variant: Y
      }
    )),
    /* @__PURE__ */ n.createElement("div", { className: Ee.desktopLeaveBtnWrapper }, /* @__PURE__ */ n.createElement(ru, { onLeave: T }))
  );
}, cu = "_container_mqb2l_4", lu = "_nonePaddingTop_mqb2l_7", du = "_nonePaddingRight_mqb2l_10", mu = "_nonePaddingBottom_mqb2l_13", uu = "_nonePaddingLeft_mqb2l_16", pu = "_compactPaddingTop_mqb2l_19", hu = "_compactPaddingRight_mqb2l_22", gu = "_compactPaddingBottom_mqb2l_25", fu = "_compactPaddingLeft_mqb2l_28", Eu = "_smallPaddingTop_mqb2l_31", vu = "_smallPaddingRight_mqb2l_34", Cu = "_smallPaddingBottom_mqb2l_37", bu = "_smallPaddingLeft_mqb2l_40", yu = "_mediumPaddingTop_mqb2l_43", Bu = "_mediumPaddingRight_mqb2l_46", ku = "_mediumPaddingBottom_mqb2l_49", wu = "_mediumPaddingLeft_mqb2l_52", xu = "_largePaddingTop_mqb2l_55", Mu = "_largePaddingRight_mqb2l_58", Iu = "_largePaddingBottom_mqb2l_61", Su = "_largePaddingLeft_mqb2l_64", Pu = "_topContentContainer_mqb2l_68", Nu = "_startContent_mqb2l_73", Tu = "_endContent_mqb2l_78", Ve = {
  container: cu,
  nonePaddingTop: lu,
  nonePaddingRight: du,
  nonePaddingBottom: mu,
  nonePaddingLeft: uu,
  compactPaddingTop: pu,
  compactPaddingRight: hu,
  compactPaddingBottom: gu,
  compactPaddingLeft: fu,
  smallPaddingTop: Eu,
  smallPaddingRight: vu,
  smallPaddingBottom: Cu,
  smallPaddingLeft: bu,
  mediumPaddingTop: yu,
  mediumPaddingRight: Bu,
  mediumPaddingBottom: ku,
  mediumPaddingLeft: wu,
  largePaddingTop: xu,
  largePaddingRight: Mu,
  largePaddingBottom: Iu,
  largePaddingLeft: Su,
  topContentContainer: Pu,
  startContent: Nu,
  endContent: Tu
}, Et = ({
  padding: e,
  topPadding: t = e,
  rightPadding: a = e,
  bottomPadding: o = e,
  leftPadding: r = e,
  endContent: i,
  bottomContent: s,
  backButtonAriaLabel: c = "Go back",
  closeButtonAriaLabel: l = "Close panel",
  closeButtonTestId: d = "",
  backButtonTestId: m,
  title: p,
  onCloseClick: g,
  onBackClick: f
}) => {
  const { i18n: v } = y(), E = Ke(v);
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(
        Ve.container,
        t && Ve[`${jt(t)}Top`],
        a && Ve[`${jt(a)}Right`],
        o && Ve[`${jt(o)}Bottom`],
        r && Ve[`${jt(r)}Left`]
      )
    },
    /* @__PURE__ */ n.createElement("div", { className: Ve.topContentContainer }, /* @__PURE__ */ n.createElement("div", { className: Ve.startContent }, f && /* @__PURE__ */ n.createElement(
      D,
      {
        "aria-label": c,
        onClick: f,
        className: "me-1",
        size: "none",
        variant: "translucent",
        "data-testid": m
      },
      /* @__PURE__ */ n.createElement(
        F,
        {
          size: "small",
          source: k.IconArrowLeftRegular,
          style: {
            transform: `rotateY(${E === "rtl" ? 180 : 0}deg)`
          }
        }
      )
    ), p && /* @__PURE__ */ n.createElement(
      Ie,
      {
        "data-testid": u.PanelHeaderTitle,
        htmlTag: "h2",
        fontVariant: S.H5
      },
      p
    )), (i ?? g) && /* @__PURE__ */ n.createElement("div", { className: Ve.endContent }, i, g && /* @__PURE__ */ n.createElement(
      D,
      {
        "aria-label": l,
        onClick: g,
        size: "compact",
        modifier: "square",
        variant: "translucent",
        "data-testid": d
      },
      /* @__PURE__ */ n.createElement(F, { source: k.IconClose })
    ))),
    s
  );
}, Wv = ({
  ableToPresent: e,
  allowedToPresent: t,
  canMuteAudio: a = !0,
  clearPluginMenu: o,
  inputStatusInfo: r,
  isAudioMuteDisabled: i,
  isHandRaised: s,
  isMicrophoneMuted: c,
  isMoreMenuBadgeCounterVisible: l = !1,
  isRaiseHandHidden: d,
  isRequestingAudio: m,
  isRequestingVideo: p,
  isVideoMuteDisabled: g,
  isVideoMuted: f,
  localIsPresenting: v,
  moreMenuItems: E,
  onAudioBtnClick: C,
  onLeave: B,
  onMoreMenuOpenChange: w,
  onRaiseHand: M,
  onVideoBtnClick: P,
  pluginMenuParent: T,
  presentationDisabledText: R,
  requestDeviceAgain: O,
  startPresentation: G,
  stopPresentation: Y,
  isAudioError: J,
  isVideoError: _,
  isBothError: U,
  audioTooltipVisible: H,
  videoTooltipVisible: q,
  toggleAudioTooltip: te,
  toggleVideoTooltip: V,
  audioStatusInfo: I,
  videoStatusInfo: z,
  ...Q
}) => {
  const ne = aa(), se = Wr(), Se = ne ? "medium" : "small", Be = "neutral";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(Ee.callControlsWrapper, Ee.touchWrapper),
      ...Q
    },
    /* @__PURE__ */ n.createElement("div", { className: Ee.touchCallControlBtnWrapper }, /* @__PURE__ */ n.createElement(
      Pd,
      {
        isTouch: !0,
        isMobile: ne,
        items: E,
        onOpenChange: w,
        headerContent: T ? /* @__PURE__ */ n.createElement(
          Et,
          {
            title: T,
            onBackClick: o,
            backButtonTestId: u.ButtonCallControlsTouchMoreMenuBack
          }
        ) : void 0
      },
      /* @__PURE__ */ n.createElement(
        Ot,
        {
          variant: "info",
          isTruncated: !0,
          isVisible: l,
          badgeClassName: Ee.moreMenuBadge
        }
      )
    ), !se && /* @__PURE__ */ n.createElement(
      md,
      {
        variant: Be,
        isHandRaised: s,
        onRaiseHand: M,
        iconSize: Se,
        isRaiseHandHidden: d
      }
    ), e && /* @__PURE__ */ n.createElement(
      ud,
      {
        variant: Be,
        localIsPresenting: v,
        iconSize: Se,
        stopPresentation: Y,
        startPresentation: G,
        isDisabled: !t,
        disabledReason: R
      }
    ), /* @__PURE__ */ n.createElement(
      ja,
      {
        canMute: a,
        hasError: J || U,
        iconSize: Se,
        inputStatusInfo: I,
        isDisabled: i,
        isLoading: m,
        isMicrophoneMuted: c,
        onAudioBtnClick: U ? V : C,
        requestDeviceAgain: O,
        shouldShowTooltip: H,
        toggleTooltip: te,
        variant: Be
      }
    ), /* @__PURE__ */ n.createElement(
      Da,
      {
        hasError: _,
        iconSize: Se,
        inputStatusInfo: z,
        isDisabled: g,
        isLoading: p,
        isVideoMuted: f,
        onVideoBtnClick: P,
        requestDeviceAgain: O,
        shouldShowTooltip: q,
        toggleTooltip: V,
        variant: Be
      }
    ), /* @__PURE__ */ n.createElement(iu, { onLeave: B, iconSize: Se }))
  );
}, Ru = "_wrapper_kcjjv_18", zu = "_sendButton_kcjjv_24", Ya = {
  wrapper: Ru,
  sendButton: zu
}, Wu = ({ disabled: e }) => {
  const { t } = y(), a = t("common.send", "Send"), o = /* @__PURE__ */ n.createElement(
    D,
    {
      "aria-label": a,
      className: b(Ya.sendButton),
      disabled: e,
      "data-testid": u.ButtonChatSend,
      variant: "text",
      type: "submit"
    },
    /* @__PURE__ */ n.createElement(F, { source: k.IconSend, size: "compact" })
  );
  return e ? o : /* @__PURE__ */ n.createElement(
    me,
    {
      text: /* @__PURE__ */ n.createElement(N, { variant: "standard" }, a),
      position: "top"
    },
    o
  );
}, Lu = ({ isDisabled: e }) => /* @__PURE__ */ n.createElement("div", { className: b(Ya.wrapper) }, /* @__PURE__ */ n.createElement(Wu, { disabled: e })), Fu = "_form_1dooc_123", Qu = "_wrapper_1dooc_136", Au = "_input_1dooc_154", bn = {
  form: Fu,
  wrapper: Qu,
  input: Au
}, Vu = "chatInputForm", Ou = "chatTextInput", Lv = ({
  onSubmit: e,
  isDisabled: t = !1,
  placeholder: a,
  className: o,
  maxHeight: r = gi,
  ...i
}) => {
  const { t: s } = y(), [c, l] = x("");
  return /* @__PURE__ */ n.createElement(
    Lr,
    {
      onSubmit: (d) => {
        d.preventDefault(), e(c), l("");
      },
      id: Vu,
      className: b(bn.form, o),
      "data-testid": u.ChatForm
    },
    /* @__PURE__ */ n.createElement(
      Fr,
      {
        isAutoResize: !0,
        isLabelHidden: !0,
        autoResizeMaxHeight: r,
        rows: 1,
        id: Ou,
        label: s("meeting.write-message", "Write a message"),
        className: bn.wrapper,
        textareaClassname: bn.input,
        onValueChange: (d) => l(d),
        value: c,
        placeholder: a,
        isDisabled: t,
        autoComplete: "off",
        "data-testid": u.ChatInput,
        maxLength: ui,
        onKeyDown: (d) => {
          d.key === ht.enter && (d.shiftKey || (d.preventDefault(), d.currentTarget.form?.dispatchEvent(
            new Event("submit", {
              cancelable: !0,
              bubbles: !0
            })
          )));
        },
        ...i
      }
    ),
    /* @__PURE__ */ n.createElement(Lu, { isDisabled: !c || t })
  );
}, $n = (e) => {
  const t = Qr(), [a, o] = x(!1);
  return A(() => {
    o(t && e);
  }, [e, t]), a;
}, Du = "_panel_b65tz_106", ju = "_show_b65tz_134", Yu = "_animateIn_b65tz_138", Hu = "_animateOut_b65tz_144", Zu = "_wrapper_b65tz_247", Mt = {
  panel: Du,
  show: ju,
  animateIn: Yu,
  animateOut: Hu,
  wrapper: Zu
}, Fv = ({ children: e, className: t, isShown: a, animateIn: o, animateOut: r, ...i }) => {
  const [s, c] = x(null);
  Dn(s, a);
  const l = $n(a), { ref: d } = jn(l);
  return /* @__PURE__ */ n.createElement("div", { ref: d }, /* @__PURE__ */ n.createElement(
    "div",
    {
      "data-testid": u.ChatPanel,
      ref: c,
      className: b(
        Mt.panel,
        Mt.wrapper,
        {
          [Mt.show]: a,
          [Mt.animateIn]: !!o,
          [Mt.animateOut]: !!r
        },
        t
      ),
      ...i
    },
    e
  ));
}, Gu = "_container_1t8ak_4", Ju = {
  container: Gu
}, zn = ({ className: e, testId: t }) => /* @__PURE__ */ n.createElement("div", { "data-testid": t, className: b(Ju.container, e) }), Uu = "_box_1f6eh_11", qu = "_useHover_1f6eh_16", Xu = "_isYou_1f6eh_19", Ku = "_light_1f6eh_19", _u = "_dark_1f6eh_20", $u = "_messageInformationContainer_1f6eh_24", ep = "_timestamp_1f6eh_29", tp = "_activityMessageWrapper_1f6eh_33", np = "_messageTitle_1f6eh_41", op = "_messageName_1f6eh_48", ap = "_messageDate_1f6eh_54", rp = "_messageText_1f6eh_59", ip = "_truncated_1f6eh_59", sp = "_messagePending_1f6eh_80", cp = "_activityMessageIcon_1f6eh_84", le = {
  box: Uu,
  useHover: qu,
  isYou: Xu,
  light: Ku,
  dark: _u,
  messageInformationContainer: $u,
  timestamp: ep,
  activityMessageWrapper: tp,
  messageTitle: np,
  messageName: op,
  messageDate: ap,
  messageText: rp,
  truncated: ip,
  messagePending: sp,
  activityMessageIcon: cp
}, lp = Ar(Re, "light"), Ha = ({
  isYou: e = !1,
  message: t,
  withAvatar: a = !1,
  isUnread: o = !1,
  isTruncated: r = !1,
  noPadding: i = !1,
  useHoverStyle: s = !1,
  className: c,
  children: l
}) => {
  const { t: d } = y();
  return /* @__PURE__ */ n.createElement(sn, null, ({ colorScheme: m }) => /* @__PURE__ */ n.createElement(
    lp,
    {
      isWithShadow: !1,
      className: b(
        c,
        le.box,
        m,
        le[m],
        {
          [le.messagePending]: t.pending,
          "p-3": !i,
          [le.useHover]: s,
          [le.isYou]: e
        }
      ),
      key: t.id,
      "data-testid": u.ChatMessage
    },
    a && /* @__PURE__ */ n.createElement(
      on,
      {
        className: "mr-2",
        colorScheme: "dark",
        displayName: t.displayName,
        sizeModifier: "small",
        type: Vt.Initials
      }
    ),
    /* @__PURE__ */ n.createElement("div", { className: le.messageInformationContainer }, /* @__PURE__ */ n.createElement("div", { className: le.messageTitle }, /* @__PURE__ */ n.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.BodyBold,
        className: le.messageName,
        "data-testid": u.ChatMessageName,
        translate: "no"
      },
      e ? d("meeting.you", "You") : t.displayName
    ), o && /* @__PURE__ */ n.createElement(
      zn,
      {
        testId: u.ChatUnreadMessageIndicator,
        className: "ml-1"
      }
    )), /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.Small,
        className: le.messageDate
      },
      t.timestamp
    )), /* @__PURE__ */ n.createElement(
      N,
      {
        htmlTag: "p",
        fontVariant: o ? S.BodyBold : S.Body,
        className: b(le.messageText, {
          [le.truncated]: r
        }),
        "data-testid": u.ChatMessageText
      },
      l ?? t.message
    ))
  ));
}, dp = (e) => {
  switch (e) {
    case "removed":
      return u.ChatRemoveActivityMessage;
    case "empty-chat":
      return u.ChatEmptyActivityMessage;
    default:
      return u.ChatActivityMessage;
  }
}, mp = ({ message: e, className: t }) => /* @__PURE__ */ n.createElement(
  Re,
  {
    isWithShadow: !1,
    className: b("p-3", le.activityMessageWrapper, t),
    key: e.id,
    "data-testid": dp(e.activityType),
    hasBackground: !1
  },
  /* @__PURE__ */ n.createElement("div", { className: le.messageText }, /* @__PURE__ */ n.createElement(N, { isItalicized: !0, htmlTag: "p", className: le.messageText }, /* @__PURE__ */ n.createElement(
    N,
    {
      variant: "tinted",
      "data-testid": u.ChatActivityMessageText
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        color: Me.Neutral70,
        className: le.activityMessageIcon,
        size: "compact",
        source: k.IconInfoRound
      }
    ),
    e.message
  ), e.activityType === "removed" && /* @__PURE__ */ n.createElement(
    N,
    {
      variant: "tinted",
      className: le.messageName,
      translate: "no"
    },
    " ",
    e.removedParticipant?.displayName
  )), (e.activityType === "joined" || e.activityType === "left") && /* @__PURE__ */ n.createElement(
    N,
    {
      fontVariant: S.Small,
      className: le.messageDate
    },
    e.timestamp
  ))
), up = ({ messages: e, className: t, currentUserId: a }) => /* @__PURE__ */ n.createElement("div", { "data-testid": u.ChatMessages, className: t }, e.map((o, r, i) => {
  const s = r + 1 === i.length, c = a ? o.userId === a : !1, l = r > 0 ? i[r - 1]?.userId === a : !1, d = r + 1 < i.length ? i[r + 1]?.userId === a : !1;
  return o.type === "activity" ? /* @__PURE__ */ n.createElement(
    mp,
    {
      key: o.id,
      className: b({
        "mt-3": l,
        "mb-3": d
      }),
      message: o
    }
  ) : /* @__PURE__ */ n.createElement(
    Ha,
    {
      isYou: c,
      className: b({
        "mt-1": l && c,
        "mb-1": s && c
      }),
      key: o.id,
      message: o
    },
    /* @__PURE__ */ n.createElement(Yn, { text: o.message })
  );
})), pp = "_chatWrapper_f8hty_136", hp = "_chatMessagesWrapper_f8hty_144", gp = "_newMessagesPillWrapper_f8hty_176", yn = {
  chatWrapper: pp,
  chatMessagesWrapper: hp,
  newMessagesPillWrapper: gp
}, Qv = ({
  currentUserId: e,
  closeNewChatMessage: t,
  displayNewMessageToast: a,
  messages: o,
  newMessagesCount: r,
  scrollbarRef: i,
  chatPanelMessagesClassName: s
}) => /* @__PURE__ */ n.createElement("div", { className: yn.chatWrapper }, a && /* @__PURE__ */ n.createElement("div", { className: yn.newMessagesPillWrapper }, /* @__PURE__ */ n.createElement(
  au,
  {
    newMessagesCount: r,
    scrollToLastMessage: () => ga(i),
    closeNewChatMessage: t
  }
)), /* @__PURE__ */ n.createElement("div", { className: yn.chatMessagesWrapper }, o.length > 0 && /* @__PURE__ */ n.createElement(
  up,
  {
    currentUserId: e,
    messages: o,
    className: s
  }
))), fp = "_enhancerStart_1yb1h_11", Ep = "_enhancerEnd_1yb1h_19", vp = "_logoWrapper_1yb1h_25", Cp = "_logoText_1yb1h_32", bp = "_interactive_1yb1h_37", yp = "_titleSection_1yb1h_41", Bp = "_title_1yb1h_41", kp = "_subTitle_1yb1h_53", Je = {
  enhancerStart: fp,
  enhancerEnd: Ep,
  logoWrapper: vp,
  logoText: Cp,
  interactive: bp,
  titleSection: yp,
  title: Bp,
  subTitle: kp
}, wp = ({
  className: e,
  onClick: t,
  ...a
}) => {
  const { t: o } = y();
  return /* @__PURE__ */ n.createElement(
    N,
    {
      className: b(e, {
        [Je.interactive]: !!t
      }),
      "data-testid": u.HeaderLogo,
      fontVariant: S.Body,
      onClick: t,
      ...a
    },
    /* @__PURE__ */ n.createElement(Z, { t: o, i18nKey: "common.a-pexip-meeting" }, "a", /* @__PURE__ */ n.createElement(
      An,
      {
        "aria-label": o("common.label-pexip-logo", "Pexip logo"),
        size: "medium",
        className: "ml-1 mr-1"
      }
    ), "meeting")
  );
}, xp = ({ className: e, text: t, ...a }) => /* @__PURE__ */ n.createElement(
  Ie,
  {
    htmlTag: "h1",
    fontVariant: S.H5,
    className: b(Je.title, e),
    ...a
  },
  t
), Mp = ({ text: e, className: t, ...a }) => /* @__PURE__ */ n.createElement(
  N,
  {
    fontVariant: S.Body,
    className: b(Je.subTitle, t),
    ...a
  },
  "/ ",
  e
), Ip = ({ enhancerStartActions: e, onClick: t, subTitle: a, title: o }) => /* @__PURE__ */ n.createElement("div", { className: Je.enhancerStart }, /* @__PURE__ */ n.createElement("div", { className: Je.logoWrapper }, /* @__PURE__ */ n.createElement(
  wp,
  {
    className: b(Je.logoText, "ml-4"),
    onClick: t
  }
), /* @__PURE__ */ n.createElement(cn, { direction: "vertical", className: "ml-4" })), /* @__PURE__ */ n.createElement(Ne, { spacing: "compact", className: Je.titleSection }, o && /* @__PURE__ */ n.createElement(
  xp,
  {
    text: o,
    "data-testid": u.HeaderTitle,
    className: "hideOnMobile"
  }
), a && /* @__PURE__ */ n.createElement(
  Mp,
  {
    text: a,
    "data-testid": u.HeaderSubTitle,
    className: "hideOnMobile"
  }
), e)), Av = ({
  enhancerEndActions: e,
  enhancerStartActions: t,
  onClick: a,
  subTitle: o,
  title: r,
  userAvatar: i,
  ...s
}) => /* @__PURE__ */ n.createElement(
  Vr,
  {
    enhancerStart: /* @__PURE__ */ n.createElement(
      Ip,
      {
        enhancerStartActions: t,
        onClick: a,
        subTitle: o,
        title: r
      }
    ),
    enhancerEnd: /* @__PURE__ */ n.createElement(Ne, { spacing: "small", className: Je.enhancerEnd }, e, i),
    ...s
  }
), Sp = "_container_d8ax4_113", Pp = "_expanded_d8ax4_130", Np = "_withSidePanel_d8ax4_135", Bn = {
  container: Sp,
  expanded: Pp,
  withSidePanel: Np
}, Tp = n.forwardRef(
  ({
    children: e,
    className: t,
    isPrimaryVideoExpanded: a,
    isSidePanelVisible: o,
    ...r
  }, i) => /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(Bn.container, t, {
        [Bn.withSidePanel]: !!o,
        [Bn.expanded]: !!a
      }),
      ...r,
      ref: i
    },
    e
  )
);
Tp.displayName = "MeetingStageContainer";
const Vv = ({ isPanelOpen: e, newMessagesCount: t, isTouchDevice: a, ...o }) => {
  const { t: r, i18n: i } = y(), s = Ke(i);
  return /* @__PURE__ */ n.createElement(
    Ot,
    {
      number: 0,
      isVisible: !e && t > 0,
      isTruncated: !0
    },
    /* @__PURE__ */ n.createElement(
      Ae,
      {
        shouldShowTooltip: !a,
        tooltipPosition: s === "rtl" ? "left" : "right",
        tooltipText: r("meeting.toggle-chat-tooltip", "Chat"),
        "aria-label": r("meeting.toggle-chat", "Chat panel toggle"),
        "data-testid": u.ButtonChat,
        icon: /* @__PURE__ */ n.createElement(F, { source: k.IconChat, size: "small" }),
        isActive: e,
        ...o
      }
    )
  );
}, Rp = "_panel_1rnst_243", zp = "_show_1rnst_271", Wp = "_animateIn_1rnst_275", Lp = "_animateOut_1rnst_281", Fp = "_participantList_1rnst_288", Qp = "_networkAlert_1rnst_302", rt = {
  panel: Rp,
  show: zp,
  animateIn: Wp,
  animateOut: Lp,
  participantList: Fp,
  networkAlert: Qp
}, Ov = ({ children: e, panelsState: t, isNetworkAlertDisplayed: a }) => {
  const [o, r] = x(null);
  Dn(o, t.openParticipantPanel);
  const i = $n(
    t.openParticipantPanel
  ), { ref: s } = jn(i);
  return /* @__PURE__ */ n.createElement("div", { ref: s }, /* @__PURE__ */ n.createElement(
    Re,
    {
      ref: r,
      className: b(rt.panel, rt.participantList, {
        [rt.show]: t.openParticipantPanel,
        [rt.animateIn]: t.animationType === $t.PARTICIPANTS_IN,
        [rt.animateOut]: t.animationType === $t.PARTICIPANTS_OUT,
        [rt.networkAlert]: a
      }),
      "data-testid": u.ParticipantPanel
    },
    e
  ));
}, Ap = "_container_1oh3w_1", Vp = {
  container: Ap
}, Za = ({
  isTouchDevice: e,
  className: t,
  displayName: a,
  isAuthenticated: o,
  showParticipantAuthenticatedState: r
}) => {
  const { t: i } = y();
  return /* @__PURE__ */ n.createElement("div", { className: b(Vp.container, t) }, /* @__PURE__ */ n.createElement(
    on,
    {
      colorScheme: "dark",
      displayName: a,
      sizeModifier: e ? "medium" : "small",
      type: Vt.Initials
    }
  ), /* @__PURE__ */ n.createElement(
    Ie,
    {
      htmlTag: e ? S.H2 : S.H5,
      fontVariant: e ? S.H2 : S.H5,
      className: `${e ? "mt-3" : "mt-1"} text-center`
    },
    a
  ), r && /* @__PURE__ */ n.createElement(
    N,
    {
      fontVariant: e ? S.BodyBold : S.Small,
      variant: o ? "success" : "danger",
      className: `${e ? "mt-2" : ""} text-center`
    },
    o ? i("meeting.authenticated", "Authenticated") : i("meeting.unauthenticated", "Unauthenticated")
  ));
}, Op = "_modalContent_1kvwc_4", Dp = "_buttonContainer_1kvwc_8", Qo = {
  modalContent: Op,
  buttonContainer: Dp
}, jp = ({
  displayName: e,
  isAuthenticated: t,
  showParticipantAuthenticatedState: a,
  isOpen: o,
  button: r,
  menuContent: i,
  onOpenChange: s
}) => /* @__PURE__ */ n.createElement(n.Fragment, null, r, /* @__PURE__ */ n.createElement(
  at,
  {
    padding: "compact",
    withCloseButton: !0,
    closeOnOutsideClick: !0,
    isOpen: o,
    onClose: () => s(!1)
  },
  /* @__PURE__ */ n.createElement("div", { className: Qo.modalContent }, /* @__PURE__ */ n.createElement(
    Za,
    {
      isTouchDevice: !0,
      displayName: e,
      isAuthenticated: t,
      showParticipantAuthenticatedState: a
    }
  ), /* @__PURE__ */ n.createElement("div", { className: Qo.buttonContainer }, i.map((c) => /* @__PURE__ */ n.createElement(
    D,
    {
      className: "justify-content-start",
      size: "large",
      modifier: "fullWidth",
      key: c.key,
      variant: "text",
      enhancerStart: c.icon,
      onClick: () => {
        c.onItemClick?.(), s(!1);
      }
    },
    c.label
  ))))
)), Yp = ({
  isOpen: e,
  isTouchDevice: t,
  showParticipantAuthenticatedState: a,
  displayName: o,
  handleTransfer: r,
  handleDTMF: i,
  handleFecc: s,
  handleRemoveUserRequest: c,
  shouldShowHostActions: l,
  shouldShowHostActionsForCurrentPeer: d,
  isMuted: m,
  isDirectMedia: p,
  isCurrentPeer: g,
  isSpotlight: f,
  isSpotlightAvailable: v,
  participant: E,
  additionalMenuContent: C,
  button: B,
  onOpenChange: w
}) => {
  const { t: M } = y(), P = Fe(() => [
    !!E.lowerHand && !g && E.canRaiseHand && E.raisedHand && {
      label: M("meeting.lower-hand", "Lower hand"),
      onItemClick: () => E.lowerHand?.(),
      testId: u.ActionLowerHand,
      key: "lowerHand",
      closeMenuOnItemClick: !1,
      icon: /* @__PURE__ */ n.createElement(
        F,
        {
          size: t ? "small" : "compact",
          source: k.IconLowerhand
        }
      )
    },
    (l || m && d) && E.canMute && {
      label: m ? M("media.unmute-microphone", "Unmute microphone") : M("media.mute-microphone", "Mute microphone"),
      onItemClick: E.mute,
      testId: m ? u.ActionUnmuteMicrophone : u.ActionMuteMicrophone,
      key: "microphone",
      icon: /* @__PURE__ */ n.createElement(
        F,
        {
          size: t ? "small" : "compact",
          source: m ? k.IconMicrophoneOff : k.IconMicrophoneOn
        }
      )
    },
    !p && v && !!E.spotlight && E.canSpotlight && {
      label: f ? M("media.remove-spotlight", "Remove spotlight") : M("media.spotlight", "Spotlight"),
      onItemClick: () => E.spotlight?.(),
      testId: f ? u.ActionRemoveSpotlight : u.ActionSpotlight,
      closeMenuOnItemClick: !1,
      key: "spotlight",
      icon: /* @__PURE__ */ n.createElement(
        F,
        {
          size: t ? "small" : "compact",
          source: k.IconSpotlight
        }
      )
    },
    !!(E.setRole && !g) && !E.isExternal && E.roomId === ni && {
      label: E.isHost ? M("meeting.make-guest", "Make guest") : M("meeting.make-host", "Make host"),
      onItemClick: () => E.setRole?.(),
      testId: E.isHost ? u.ActionMakeGuest : u.ActionMakeHost,
      key: "setRole",
      closeMenuOnItemClick: !1,
      icon: /* @__PURE__ */ n.createElement(
        F,
        {
          size: t ? "small" : "compact",
          source: E.isHost ? k.IconGuest : k.IconHost
        }
      )
    },
    !!r && E.canTransfer && {
      label: M("media.transfer", "Transfer"),
      onItemClick: () => r?.(E.uuid),
      testId: u.ActionTransfer,
      key: "transfer",
      icon: /* @__PURE__ */ n.createElement(
        F,
        {
          size: t ? "small" : "compact",
          source: k.IconArrowCornerDown
        }
      )
    },
    !p && !!i && !E.isConnecting && {
      label: M("dtmf.enter-dtmf", "Enter DTMF"),
      onItemClick: () => i?.(E.uuid),
      testId: u.ActionEnterDTMF,
      key: "dtmf",
      icon: /* @__PURE__ */ n.createElement(
        F,
        {
          size: t ? "small" : "compact",
          source: k.IconDtmf
        }
      )
    },
    !!s && E.canFecc && {
      label: M("fecc.camera-control", "Camera control"),
      onItemClick: () => s?.(E.uuid),
      testId: u.ActionFecc,
      key: "fecc",
      icon: /* @__PURE__ */ n.createElement(
        F,
        {
          size: t ? "small" : "compact",
          source: k.IconFecc
        }
      )
    },
    l && E.canDisconnect && {
      label: M("meeting.disconnect", "Disconnect"),
      onItemClick: () => c(E, o),
      testId: u.ButtonKickOffParticipant,
      key: "disconnect",
      icon: /* @__PURE__ */ n.createElement(
        F,
        {
          size: t ? "small" : "compact",
          source: k.IconPhoneHorisontal
        }
      ),
      style: { color: Me.Red70 }
    },
    ...C.map((T) => ({
      label: T.label,
      onItemClick: T.onItemClick,
      key: T.key,
      icon: T.icon,
      isActive: T.isActive
    }))
  ].filter(Boolean), [
    p,
    E,
    f,
    v,
    M,
    r,
    g,
    i,
    s,
    C,
    o,
    c,
    l,
    d,
    m,
    t
  ]);
  return t ? /* @__PURE__ */ n.createElement(
    jp,
    {
      showParticipantAuthenticatedState: a,
      isAuthenticated: !!E.isIdpAuthenticated,
      displayName: o,
      isOpen: e,
      onOpenChange: w,
      menuContent: P,
      button: B
    }
  ) : /* @__PURE__ */ n.createElement(
    an,
    {
      headerContent: /* @__PURE__ */ n.createElement(
        Za,
        {
          isTouchDevice: !1,
          className: "pt-4 pl-4 pr-4 pb-1",
          displayName: o,
          isAuthenticated: !!E.isIdpAuthenticated,
          showParticipantAuthenticatedState: a
        }
      ),
      onOpenChange: w,
      button: B,
      items: P,
      testId: "kebab-menu"
    }
  );
}, Hp = "_background_jsasl_1", Zp = "_bar_jsasl_2", Ao = {
  background: Hp,
  bar: Zp
}, Ga = ({
  ...e
}) => /* @__PURE__ */ n.createElement(
  "svg",
  {
    viewBox: "-2 0 12 1",
    width: "24",
    height: "10",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Speaking indicator",
    ...e
  },
  /* @__PURE__ */ n.createElement("g", null, /* @__PURE__ */ n.createElement("path", { d: "M 0,0.5 h 8", className: Ao.background }), /* @__PURE__ */ n.createElement("path", { d: "M 0,0.5 h 8", className: Ao.bar }))
), Gp = ({
  canPerformHostActions: e,
  isInteracted: t
}) => !e || e && !t, Vo = ({
  canPerformHostActions: e,
  isCurrentPeer: t,
  isHost: a,
  isInteracted: o
}) => a && o && !t && e, Jp = "_actionButtonIcon_1ijs6_4", Up = "_indicator_1ijs6_9", qp = "_dragButton_1ijs6_21", Xp = "_moreMenuAndIndicatorsContainer_1ijs6_25", it = {
  actionButtonIcon: Jp,
  indicator: Up,
  dragButton: qp,
  moreMenuAndIndicatorsContainer: Xp
}, Gt = (e) => /* @__PURE__ */ n.createElement(F, { color: Me.Neutral70, size: "compact", ...e }), Kp = ({
  isTouchDevice: e,
  isDirectMedia: t,
  showParticipantAuthenticatedState: a,
  displayName: o,
  displayLowerHandOnly: r = !1,
  handleRemoveUserRequest: i,
  handleTransfer: s,
  handleDTMF: c,
  handleFecc: l,
  handleLowerHand: d,
  hasChildCalls: m,
  isCurrentPeer: p,
  canPerformHostActions: g,
  isHost: f,
  isHover: v,
  isSpeaking: E,
  participant: C,
  onMouseLeave: B,
  isSpotlightAvailable: w,
  additionalMenuContent: M
}) => {
  const { t: P } = y(), [T, R] = x(!1), { isMuted: O, isClientMuted: G, isCameraMuted: Y, isPresenting: J, isSpotlight: _ } = C, U = /* @__PURE__ */ n.createElement(me, { text: P("common.lower-hand", "Lower hand"), position: "top" }, /* @__PURE__ */ n.createElement(
    D,
    {
      "data-testid": u.ButtonLowerHandParticipantRow,
      "aria-label": P("common.lower-hand", "Lower hand"),
      role: "button",
      variant: "transparent",
      modifier: "square",
      size: "compact",
      onClick: () => d?.(C.uuid)
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        "data-testid": u.ActionLowerHand,
        source: k.IconLowerhand,
        size: "compact"
      }
    )
  ));
  if (d && r && g)
    return /* @__PURE__ */ n.createElement("div", { className: it.moreMenuAndIndicatorsContainer }, U);
  const H = v || T, q = Gp({
    canPerformHostActions: g,
    isInteracted: H
  }), te = Vo({
    canPerformHostActions: g,
    isCurrentPeer: p,
    isHost: f,
    isInteracted: H
  }), V = Vo({
    canPerformHostActions: g,
    isCurrentPeer: !1,
    isHost: f,
    isInteracted: H
  }), I = q || te, z = C.spotlight ?? C.setRole ?? C.lowerHand ?? s ?? c ?? l, Q = V && z && (C.canSpotlight || C.canTransfer || C.canDisconnect), ne = /* @__PURE__ */ n.createElement(
    D,
    {
      "aria-label": "Open menu",
      role: "button",
      className: it.indicator,
      isActive: T,
      variant: "secondary",
      modifier: "square",
      size: "compact",
      onClick: () => R(!T),
      "data-testid": u.ParticipantMenuButton
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        size: "small",
        className: it.actionButtonIcon,
        source: k.IconMoreHorizontal
      }
    )
  );
  return /* @__PURE__ */ n.createElement("div", { className: it.moreMenuAndIndicatorsContainer }, Q && /* @__PURE__ */ n.createElement(
    Yp,
    {
      isOpen: T,
      isTouchDevice: e,
      showParticipantAuthenticatedState: a,
      isMuted: O,
      displayName: o,
      handleTransfer: s,
      handleDTMF: c,
      handleFecc: l,
      handleRemoveUserRequest: i,
      shouldShowHostActions: te,
      shouldShowHostActionsForCurrentPeer: V,
      isDirectMedia: t,
      isCurrentPeer: p,
      participant: C,
      isSpotlight: _,
      isSpotlightAvailable: w,
      additionalMenuContent: M,
      button: ne,
      onOpenChange: (se) => {
        R(se), se || B();
      }
    }
  ), J && I && /* @__PURE__ */ n.createElement(
    me,
    {
      text: P("media.presentation.presenting", "Presenting"),
      position: "top"
    },
    /* @__PURE__ */ n.createElement(
      Gt,
      {
        "data-testid": u.IconPresenting,
        source: k.IconPresentationOn
      }
    )
  ), d && !r && g && U, Y && /* @__PURE__ */ n.createElement(
    me,
    {
      text: P("media.camera-turned-off", "Camera turned off"),
      position: "top"
    },
    /* @__PURE__ */ n.createElement(
      Gt,
      {
        "data-testid": u.IconCameraMuted,
        source: k.IconVideoOff
      }
    )
  ), (O || G) && !m && /* @__PURE__ */ n.createElement(
    me,
    {
      text: O ? P("media.muted-by-a-host", "Muted by a host") : P("media.muted", "Muted"),
      position: "top"
    },
    /* @__PURE__ */ n.createElement(
      Gt,
      {
        "data-testid": O ? u.IconMutedByAHost : u.IconMuted,
        source: O ? k.IconMicrophoneMutedByHost : k.IconMicrophoneOff
      }
    )
  ), _ && /* @__PURE__ */ n.createElement(
    me,
    {
      text: P("media.spotlight", "Spotlight"),
      position: "top"
    },
    /* @__PURE__ */ n.createElement(
      Gt,
      {
        "data-testid": u.IconSpotlight,
        source: k.IconSpotlight
      }
    )
  ), E && !O && q && /* @__PURE__ */ n.createElement(Ga, { "data-testid": u.SpeakingIndicator }));
};
var Ja = /* @__PURE__ */ ((e) => (e.BreakoutParticipantDragSvg = "breakout-participant-drag-svg", e))(Ja || {});
const _p = (e) => (t) => (a) => {
  t?.(), e(a);
}, $p = ({ rooms: e, onRoomChange: t, close: a, onPointerDownCapture: o }) => {
  const { t: r } = y(), i = _p(a), s = Object.entries(e).map(([c, l]) => (dn(c), {
    label: c === pe ? r("breakouts.breakout-room.main-name", "Main Room") : l,
    clickAction: i(() => t(c))
  }));
  return /* @__PURE__ */ n.createElement(
    Dr,
    {
      testId: u.BreakoutAssignRoomMenu,
      onPointerDownCapture: o,
      menuContent: {
        [r(
          "breakouts.breakout-room.send-participant-to",
          "Send participant to:"
        )]: s
      }
    }
  );
}, eh = ({ rooms: e, onRoomChange: t, isHover: a, isDragging: o }) => {
  const [r, i] = x(!1), s = a || r;
  return /* @__PURE__ */ n.createElement(n.Fragment, null, !o && s && /* @__PURE__ */ n.createElement(
    Or,
    {
      "data-testid": u.BreakoutAssignRoomMenuButton,
      position: "bottomMiddle",
      buttonSize: "compact",
      buttonModifier: "square",
      direction: "horizontal",
      buttonVariant: "primary",
      reactiveButtonStyles: !1,
      menuComponent: (c) => /* @__PURE__ */ n.createElement(
        $p,
        {
          onPointerDownCapture: (l) => l.stopPropagation(),
          close: (l) => {
            c(l);
          },
          rooms: e,
          onRoomChange: t
        }
      ),
      onContentVisibilityChange: i,
      onPointerDownCapture: (c) => c.stopPropagation(),
      onPointerUpCapture: (c) => c.stopPropagation()
    }
  ), /* @__PURE__ */ n.createElement(
    D,
    {
      "aria-label": "Drag participant",
      className: b(it.indicator, it.dragButton),
      size: "compact",
      modifier: "square",
      variant: "translucent",
      noHover: !0
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        id: Ja.BreakoutParticipantDragSvg,
        size: "small",
        source: k.IconDraggable
      }
    )
  ));
}, th = "_rows_138rb_11", nh = "_lineWrapper_138rb_18", oh = "_lineTop_138rb_23", ah = "_lineBottom_138rb_24", rh = "_textAndIndicatorWrapper_138rb_35", ih = "_row_138rb_11", sh = "_textWrapper_138rb_56", ch = "_text_138rb_35", lh = "_audioIndicators_138rb_69", dh = "_indicatorsWrapper_138rb_74", mh = "_indicator_138rb_74", uh = "_muteButtonIcon_138rb_85", ce = {
  rows: th,
  lineWrapper: nh,
  lineTop: oh,
  lineBottom: ah,
  textAndIndicatorWrapper: rh,
  row: ih,
  textWrapper: sh,
  text: ch,
  audioIndicators: lh,
  indicatorsWrapper: dh,
  indicator: mh,
  muteButtonIcon: uh
}, ph = (e) => !e || !["web-app", "pexip-room", "mobile-app", "session"].includes(e) ? "session" : e, hh = ({ calls: e }) => {
  const { t } = y();
  return e ? /* @__PURE__ */ n.createElement("div", { className: ce.rows }, e?.map((a) => /* @__PURE__ */ n.createElement("div", { className: ce.row, key: a.identitySession }, /* @__PURE__ */ n.createElement("div", { className: ce.lineWrapper }, /* @__PURE__ */ n.createElement("div", { className: ce.lineTop }), /* @__PURE__ */ n.createElement("div", { className: ce.lineBottom })), /* @__PURE__ */ n.createElement("div", { className: ce.textAndIndicatorWrapper }, /* @__PURE__ */ n.createElement("div", { className: ce.textWrapper }, /* @__PURE__ */ n.createElement(N, { className: ce.text, isTruncated: !0 }, t(
    `common.client-name[${ph(
      a.callDisplayName?.key
    )}]`,
    a.callDisplayName?.name ?? "Session"
  ), " ", "#", a.callDisplayName?.count, a.callDisplayName?.isMe && /* @__PURE__ */ n.createElement(n.Fragment, null, " (", /* @__PURE__ */ n.createElement(Z, { t, i18nKey: "common.me" }, "me"), ")"))), /* @__PURE__ */ n.createElement("div", { className: ce.indicatorsWrapper }, a.isPresenting && /* @__PURE__ */ n.createElement(
    me,
    {
      text: t(
        "media.presentation.presenting",
        "Presenting"
      ),
      position: "top"
    },
    /* @__PURE__ */ n.createElement(
      D,
      {
        className: ce.indicator,
        isActive: !0,
        modifier: "square",
        onClick: st,
        size: "compact",
        variant: "translucent",
        "data-testid": u.ButtonPeerPresenting,
        noHover: !0
      },
      /* @__PURE__ */ n.createElement(
        F,
        {
          className: ce.muteButtonIcon,
          source: k.IconPresentationOn,
          size: "small"
        }
      )
    )
  ), !a.video && /* @__PURE__ */ n.createElement(
    me,
    {
      text: t("media.muted", "Muted"),
      position: "top"
    },
    /* @__PURE__ */ n.createElement(
      D,
      {
        className: ce.indicator,
        isActive: !0,
        modifier: "square",
        onClick: st,
        size: "compact",
        variant: "translucent",
        "data-testid": u.ButtonPeerMutedCamera,
        noHover: !0
      },
      /* @__PURE__ */ n.createElement(
        F,
        {
          className: ce.muteButtonIcon,
          source: k.IconVideoOff,
          size: "small"
        }
      )
    )
  ), /* @__PURE__ */ n.createElement("div", { className: ce.audioIndicators }, a?.isSpeaking && a.audio && /* @__PURE__ */ n.createElement(
    Ga,
    {
      "data-testid": u.SpeakingIndicator,
      className: ce.indicator
    }
  ), !a.audio && /* @__PURE__ */ n.createElement(
    me,
    {
      text: t("media.muted", "Muted"),
      position: "top"
    },
    /* @__PURE__ */ n.createElement(
      D,
      {
        className: ce.indicator,
        isActive: !0,
        modifier: "square",
        onClick: st,
        size: "compact",
        variant: "translucent",
        "data-testid": u.ButtonPeerMuted,
        noHover: !0
      },
      /* @__PURE__ */ n.createElement(
        F,
        {
          className: ce.muteButtonIcon,
          source: k.IconMicrophoneOff,
          size: "small"
        }
      )
    )
  ))))))) : null;
}, gh = "_participantRow_1qw2v_11", fh = "_scrim_1qw2v_27", Eh = "_actionsWrapper_1qw2v_46", vh = "_participant_1qw2v_11", Ch = "_metaText_1qw2v_62", bh = "_mark_1qw2v_67", et = {
  participantRow: gh,
  scrim: fh,
  actionsWrapper: Eh,
  participant: vh,
  metaText: Ch,
  mark: bh
}, yh = (e, t, a) => {
  if (t.length === 0)
    return [e];
  const o = [...t].sort((c, l) => c.start - l.start), r = [];
  for (const c of o)
    if (r.length === 0)
      r.push({ ...c });
    else {
      const l = r[r.length - 1];
      l && c.start <= l.end + 1 ? l.end = Math.max(l.end, c.end) : r.push({ ...c });
    }
  let i = 0;
  const s = [];
  for (let c = 0; c < r.length; c++) {
    const l = r[c];
    if (!l)
      continue;
    const d = Math.max(0, Math.min(l.start, e.length)), m = Math.max(0, Math.min(l.end, e.length - 1));
    i < d && s.push(e.slice(i, d));
    const p = e.slice(d, m + 1), g = `${d}-${m}`;
    p && s.push(
      /* @__PURE__ */ n.createElement("mark", { className: a, key: g }, p)
    ), i = m + 1;
  }
  return i < e.length && s.push(e.slice(i)), s;
}, Bh = ({ isTouchDevice: e, admit: t }) => {
  const { t: a } = y(), [o, r] = x(!1), i = () => {
    r(!0), t?.();
  };
  return /* @__PURE__ */ n.createElement(me, { text: a("meeting.admit", "Admit"), position: "top" }, /* @__PURE__ */ n.createElement(
    D,
    {
      "aria-label": a("meeting.admit-participant", "Admit participant"),
      noEnhancerPadding: !0,
      onClick: i,
      variant: "text",
      isLoading: o,
      isDisabled: o,
      size: e ? "small" : "compact",
      "data-testid": u.ButtonAdmitParticipant
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        source: k.IconAdmit,
        color: Me.Join,
        size: e ? "small" : "compact"
      }
    )
  ));
}, kh = ({ isTouchDevice: e, kick: t }) => {
  const { t: a } = y(), [o, r] = x(!1), i = () => {
    r(!0), t?.();
  };
  return /* @__PURE__ */ n.createElement(me, { text: a("meeting.deny", "Deny"), position: "top" }, /* @__PURE__ */ n.createElement(
    D,
    {
      "aria-label": a("meeting.deny-participant", "Deny participant"),
      noEnhancerPadding: !0,
      onClick: i,
      variant: "text",
      isLoading: o,
      isDisabled: o,
      size: e ? "small" : "compact",
      "data-testid": u.ButtonDenyParticipant
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        source: k.IconDeny,
        color: Me.Red70,
        size: e ? "small" : "compact"
      }
    )
  ));
}, Ua = ({
  isBreakout: e = !1,
  isTouchDevice: t,
  showParticipantAuthenticatedState: a = !1,
  participant: o,
  isCurrentPeer: r,
  onMouseEnter: i,
  onMouseLeave: s,
  onPointerDownCapture: c,
  children: l,
  className: d,
  highlightedCharacters: m
}) => {
  const { t: p } = y();
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      key: o.uuid,
      className: b(et.participantRow, d),
      role: "region",
      "aria-label": p("meeting.participant-row-aria-label", {
        defaultValue: "{{name}} - Participant",
        name: o.displayName ?? ""
      }),
      tabIndex: 0,
      onMouseEnter: i,
      onFocus: i,
      onMouseLeave: s,
      onBlur: (g) => {
        g.currentTarget.contains(g.relatedTarget) || s();
      },
      "data-testid": u.ParticipantRow,
      onPointerDownCapture: c
    },
    /* @__PURE__ */ n.createElement("div", { className: et.participant }, !e && a && /* @__PURE__ */ n.createElement(
      me,
      {
        text: o.isIdpAuthenticated ? p("meeting.authenticated", "Authenticated") : p(
          "meeting.unauthenticated",
          "Unauthenticated"
        ),
        position: "topRight"
      },
      /* @__PURE__ */ n.createElement(
        F,
        {
          className: "mr-1",
          source: o.isIdpAuthenticated ? k.IconAuthenticated : k.IconNotauthenticated,
          size: t ? "medium" : "small",
          color: o.isIdpAuthenticated ? Me.Neutral70 : Me.SignalOrange130
        }
      )
    ), /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.Body,
        isTruncated: !0,
        title: o.displayName,
        translate: "no"
      },
      m && m.length > 0 && o.displayName ? yh(
        o.displayName,
        m,
        et.mark
      ) : o.displayName || "User"
    ), r && /* @__PURE__ */ n.createElement(
      N,
      {
        className: et.metaText,
        fontVariant: S.Body,
        title: "You",
        translate: "no"
      },
      "/ ",
      p("meeting.you", "You")
    ), o.isHost && /* @__PURE__ */ n.createElement(
      N,
      {
        className: et.metaText,
        fontVariant: S.Body,
        title: "Host",
        translate: "no"
      },
      "/ ",
      p("common.host", "Host")
    )),
    /* @__PURE__ */ n.createElement("div", { className: et.actionsWrapper }, /* @__PURE__ */ n.createElement("div", { className: et.scrim }), l)
  );
}, wh = ({
  participant: e,
  isCurrentPeer: t,
  rooms: a,
  onParticipantRoomChange: o,
  isDragging: r,
  className: i
}) => {
  const [s, c] = x(!1), l = L(() => c(!0), []), d = L(() => c(!1), []), m = L(
    (p) => {
      o?.(e.uuid, p);
    },
    [o, e.uuid]
  );
  return /* @__PURE__ */ n.createElement(
    Ua,
    {
      isBreakout: !0,
      participant: e,
      isCurrentPeer: t,
      onMouseEnter: l,
      onMouseLeave: d,
      className: i
    },
    a && Object.entries(a).length > 0 && /* @__PURE__ */ n.createElement(
      eh,
      {
        rooms: a,
        onRoomChange: m,
        isHover: s,
        isDragging: r
      }
    )
  );
}, Dv = ({
  className: e,
  isTouchDevice: t,
  isDirectMedia: a,
  showParticipantAuthenticatedState: o,
  displayName: r,
  handleRemoveUserRequest: i,
  handleTransfer: s,
  handleDTMF: c,
  handleFecc: l,
  isCurrentPeer: d,
  canPerformHostActions: m = !0,
  isHost: p,
  isSpeaking: g,
  participant: f,
  additionalMenuContent: v,
  displayLowerHandOnly: E,
  isSpotlightAvailable: C,
  handleLowerHand: B,
  highlightedCharacters: w
}) => {
  const [M, P] = x(!1), T = L(() => P(!0), []), R = L(() => P(!1), []), { calls: O } = f, G = Fe(
    () => !!(O && O?.length > 1),
    [O]
  );
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    Ua,
    {
      className: e,
      participant: f,
      showParticipantAuthenticatedState: o,
      isCurrentPeer: d,
      onMouseEnter: T,
      onMouseLeave: R,
      isTouchDevice: t,
      highlightedCharacters: w
    },
    f.isWaiting || f.serviceType === "ivr" ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
      Bh,
      {
        isTouchDevice: t,
        admit: f?.admit
      }
    ), /* @__PURE__ */ n.createElement(
      kh,
      {
        isTouchDevice: t,
        kick: f?.kick
      }
    )) : /* @__PURE__ */ n.createElement(
      Kp,
      {
        displayLowerHandOnly: E,
        isTouchDevice: t,
        showParticipantAuthenticatedState: !!o,
        participant: f,
        isDirectMedia: a,
        canPerformHostActions: m,
        isHost: p,
        isSpeaking: G ? !1 : g,
        isHover: M,
        isCurrentPeer: d,
        handleRemoveUserRequest: i,
        handleTransfer: s,
        handleDTMF: c,
        handleFecc: l,
        displayName: r,
        hasChildCalls: G,
        onMouseLeave: R,
        additionalMenuContent: v,
        handleLowerHand: B,
        isSpotlightAvailable: C
      }
    )
  ), G && /* @__PURE__ */ n.createElement(hh, { calls: f.calls }));
}, xh = "_container_1owbl_4", Mh = "_title_1owbl_10", Oo = {
  container: xh,
  title: Mh
}, jv = ({ children: e, closeButtonAriaLabel: t = "Close panel", onCloseClick: a }) => /* @__PURE__ */ n.createElement("div", { className: Oo.container }, /* @__PURE__ */ n.createElement("div", { className: Oo.title }, e), a && /* @__PURE__ */ n.createElement(
  D,
  {
    "aria-label": t,
    onClick: a,
    onPointerDownCapture: (o) => o.stopPropagation(),
    size: "compact",
    variant: "translucent"
  },
  /* @__PURE__ */ n.createElement(F, { size: "compact", source: k.IconClose })
)), Ih = "_scrim_k7eq9_123", Sh = "_scrimTop_k7eq9_130", Do = {
  scrim: Ih,
  scrimTop: Sh
}, Yv = ({
  position: e = "top",
  ...t
}) => /* @__PURE__ */ n.createElement(
  jr,
  {
    className: b(Do.scrim, {
      [Do.scrimTop]: e === "top"
    }),
    position: e,
    ...t
  }
), Hv = ({
  isPanelOpen: e,
  inMeetingParticipantsCount: t = 0,
  participantsActionCount: a = 0,
  shouldAnimate: o,
  isTouchDevice: r,
  ...i
}) => {
  const { t: s, i18n: c } = y(), l = Ke(c), d = !e && a > 0;
  return /* @__PURE__ */ n.createElement(
    Ot,
    {
      "data-testid": u.BadgeCounterParticipantPanelButton,
      variant: "info",
      isTruncated: d,
      isVisible: t > 0,
      number: t,
      shouldAnimate: o
    },
    /* @__PURE__ */ n.createElement(
      Ae,
      {
        "aria-label": s(
          "meeting.toggle-participants-panel",
          "Participants panel toggle"
        ),
        "data-testid": u.ButtonParticipants,
        tooltipText: s(
          "meeting.toggle-participants-panel-tooltip",
          "Participants"
        ),
        tooltipPosition: l === "rtl" ? "left" : "right",
        shouldShowTooltip: !r,
        icon: /* @__PURE__ */ n.createElement(F, { source: k.IconGroup, size: "small" }),
        isActive: e,
        ...i
      }
    )
  );
}, Zv = ({
  isActive: e,
  count: t = 0,
  actionCount: a = 0,
  shouldAnimate: o = !1,
  isTouchDevice: r = !1,
  ariaLabel: i,
  tooltipText: s,
  icon: c,
  badgeTestId: l = "",
  buttonTestId: d = "",
  tooltipPosition: m = "right",
  ...p
}) => {
  const g = !e && a > 0;
  return /* @__PURE__ */ n.createElement(
    Ot,
    {
      "data-testid": l,
      variant: "info",
      isTruncated: g,
      isVisible: t > 0,
      number: t,
      shouldAnimate: o
    },
    /* @__PURE__ */ n.createElement(
      Ae,
      {
        "aria-label": i,
        "data-testid": d,
        tooltipText: s,
        tooltipPosition: m,
        shouldShowTooltip: !r,
        icon: /* @__PURE__ */ n.createElement(F, { source: c, size: "small" }),
        isActive: e,
        ...p
      }
    )
  );
}, Ph = "_boxWrapper_laeoj_14", Nh = "_background_laeoj_20", Th = "_barsWrapper_laeoj_24", Rh = "_frequencyBar_laeoj_34", zh = "_backgroundProgressAnimation_laeoj_43", zt = {
  boxWrapper: Ph,
  background: Nh,
  barsWrapper: Th,
  frequencyBar: Rh,
  backgroundProgressAnimation: zh
}, Wh = ({ className: e }) => /* @__PURE__ */ n.createElement("div", { className: b(zt.frequencyBar, e) }), Lh = ({ barClassName: e, barsNumber: t = 20 }) => /* @__PURE__ */ n.createElement(n.Fragment, null, Array.from({ length: t }, (a, o) => o).map((a) => /* @__PURE__ */ n.createElement(Wh, { key: a, className: e }))), Gv = ({
  backgroundAnimationDuration: e = 5,
  barClassName: t,
  barsWrapperClassName: a,
  barsNumber: o = 20,
  className: r,
  barsWrapperId: i,
  showBackground: s = !1,
  showBackgroundAnimation: c = !0,
  children: l,
  ...d
}) => /* @__PURE__ */ n.createElement(
  "div",
  {
    style: {
      animationDuration: c ? `${e}s` : void 0
    },
    className: b(
      zt.boxWrapper,
      c && zt.backgroundProgressAnimation,
      s && zt.background,
      r
    ),
    "data-testid": u.TestAudioInputIndicator,
    ...d
  },
  /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(zt.barsWrapper, a),
      id: i
    },
    /* @__PURE__ */ n.createElement(
      Lh,
      {
        barsNumber: o,
        barClassName: t
      }
    )
  ),
  l
), Fh = "_main_1rjir_1", Qh = {
  main: Fh
}, Jv = ({
  children: e
}) => /* @__PURE__ */ n.createElement("div", { className: Qh.main }, e), Uv = ({ isOpen: e, presenterName: t, onConfirm: a, onCancel: o }) => {
  const { t: r } = y(), i = t ? Ah(t) : r("media.presentation.the-current", "the current");
  return /* @__PURE__ */ n.createElement(
    Qe,
    {
      cancelButtonTestid: u.ButtonStealPresentationCancel,
      cancelButtonText: r("common.cancel", "Cancel"),
      confirmButtonTestid: u.ButtonStealPresentationConfirm,
      confirmButtonText: r("media.presentation.take-over", "Take over"),
      "data-testid": u.ModalStealPresentation,
      description: r("media.presentation.this-will-end", {
        defaultValue: "This will end {{normalizedPresenterName}} presentation and start your own.",
        normalizedPresenterName: i
      }),
      isOpen: e,
      onCancel: o,
      onConfirm: a,
      title: r(
        "media-presentation.do-you-want-to-take-over",
        "Do you want to take over the presentation?"
      ),
      uniqueTitle: r(
        "media-presentation.do-you-want-to-take-over",
        "Do you want to take over the presentation?"
      )
    }
  );
}, Ah = (e) => e === "" ? e : e.slice(-1).toLowerCase() === "s" ? `${e}’` : `${e}’s`, Vh = "_panel_78sa9_96", Oh = {
  panel: Vh
}, Dh = (e) => /* @__PURE__ */ n.createElement(
  Dt,
  {
    className: Oh.panel,
    colorScheme: "light",
    hasFooterShadow: !0,
    headerPadding: "none",
    ...e
  }
), jh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 89, viewBox: "0 0 140 89", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 3, y: 3, width: 65, height: 36, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 118.5, y: 70, width: 17, height: 16, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 3, y: 41, width: 43, height: 27, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 4.5, y: 70, width: 17, height: 16, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 42.5, y: 70, width: 17, height: 16, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80.5, y: 70, width: 17, height: 16, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 23.5, y: 70, width: 17, height: 16, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 61.5, y: 70, width: 17, height: 16, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 99.5, y: 70, width: 17, height: 16, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 48, y: 41, width: 44, height: 27, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 94, y: 41, width: 43, height: 27, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 70, y: 3, width: 67, height: 36, rx: 2, fill: "#BBBFC3" })), Yh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 90, viewBox: "0 0 140 90", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88.7739, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 33, y: 12.1044, width: 74, height: 45.3913, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 4, y: 66, width: 18, height: 14, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 23, y: 66, width: 18, height: 14, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 42, y: 66, width: 17, height: 14, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 61, y: 66, width: 17, height: 14, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80, y: 66, width: 18, height: 14, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 99, y: 66, width: 18, height: 14, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 118, y: 66, width: 18, height: 14, rx: 2, fill: "#BBBFC3" })), Hh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 90, viewBox: "0 0 140 90", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88.7739, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 23.7891, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 23.7891, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 42.5703, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 42.5703, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 61.3594, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 61.3594, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 98.9297, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 98.9297, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80.1484, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80.1484, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 117.719, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 117.719, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 23.7891, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 42.5703, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 61.3594, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 98.9297, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80.1484, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 117.719, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 37, y: 5, width: 66, height: 38, rx: 2, fill: "#BBBFC3" })), Zh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 90, viewBox: "0 0 140 90", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88.7739, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 5, width: 63, height: 39, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 72, y: 5, width: 63, height: 39, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 23.7891, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 23.7891, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 42.5703, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 42.5703, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 61.3594, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 61.3594, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 98.9297, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 98.9297, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80.1484, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80.1484, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 117.719, y: 59.9163, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 117.719, y: 47, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 23.7891, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 42.5703, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 61.3594, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 98.9297, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80.1484, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 117.719, y: 73.4229, width: 17.2832, height: 11.5771, rx: 2, fill: "#BBBFC3" })), Gh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 90, viewBox: "0 0 140 90", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88.7739, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 43, y: 4, width: 55, height: 39, rx: 2.51724, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 119, y: 45, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 99, y: 45, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80, y: 45, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 62, y: 45, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 43, y: 45, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 24, y: 45, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 45, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 119, y: 18, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 99, y: 18, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 24, y: 18, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 18, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 119, y: 4, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 99, y: 4, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 24, y: 4, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 4, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 119, y: 59, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 99, y: 59, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80, y: 59, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 62, y: 59, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 43, y: 59, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 24, y: 59, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 59, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 119, y: 32, width: 17, height: 11, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 99, y: 32, width: 18, height: 11, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 24, y: 32, width: 18, height: 11, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 32, width: 17, height: 11, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 119, y: 73, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 99, y: 73, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 80, y: 73, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 62, y: 73, width: 17, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 43, y: 73, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 24, y: 73, width: 18, height: 12, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 73, width: 17, height: 12, rx: 2, fill: "#BBBFC3" })), Jh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 89, viewBox: "0 0 140 89", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 9, y: 12, width: 124, height: 65, rx: 2, fill: "#BBBFC3" })), Uh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 89, viewBox: "0 0 140 89", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 8, y: 12, width: 58, height: 29, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 8, y: 49, width: 58, height: 29, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 74, y: 12, width: 58, height: 29, rx: 2, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 74, y: 49, width: 58, height: 29, rx: 2, fill: "#BBBFC3" })), qh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 88, viewBox: "0 0 140 88", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 86.3964, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 8, y: 9.81982, width: 38.6231, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 8, y: 33.3873, width: 38.6231, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 8, y: 56.9551, width: 38.6231, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 50.6875, y: 9.81982, width: 38.6231, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 50.6875, y: 33.3873, width: 38.6231, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 50.6875, y: 56.9551, width: 38.6231, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 92.3594, y: 9.81982, width: 39.6395, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 92.3594, y: 33.3873, width: 39.6395, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 92.3594, y: 56.9551, width: 39.6395, height: 19.9617, rx: 2.03279, fill: "#BBBFC3" })), Xh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 89, viewBox: "0 0 140 89", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 41.1016, y: 63.8228, width: 27.2728, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 71.1953, y: 29.2743, width: 27.9905, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 11, y: 29.2743, width: 27.2728, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 11, y: 12, width: 27.2728, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 11, y: 46.5486, width: 27.2728, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 11, y: 63.8228, width: 27.2728, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 41.1016, y: 29.2743, width: 27.2728, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 41.1016, y: 12, width: 27.2728, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 41.1016, y: 46.5486, width: 27.2728, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 71.1953, y: 12, width: 27.9905, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 102.008, y: 29.2743, width: 27.9905, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 102.008, y: 12, width: 27.9905, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 102.008, y: 46.5486, width: 27.9905, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 102.008, y: 63.8228, width: 27.9905, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 71.1953, y: 46.5486, width: 27.9905, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 71.1953, y: 63.8228, width: 27.9905, height: 14.3541, rx: 1.43541, fill: "#BBBFC3" })), Kh = (e) => /* @__PURE__ */ h.createElement("svg", { width: 140, height: 89, viewBox: "0 0 140 89", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 88, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 31.0859, y: 67.6501, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 57.1717, y: 37.7063, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 37.7063, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 22.7343, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 8, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 52.6782, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 5, y: 67.6501, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 31.0859, y: 37.7063, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 31.0859, y: 22.7344, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 31.0859, y: 8, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 31.0859, y: 52.6782, width: 23.6379, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 57.1717, y: 22.7343, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 57.1717, y: 8, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 83.8828, y: 37.7063, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 110.742, y: 37.7063, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 83.8828, y: 22.7344, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 83.8828, y: 8, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 110.742, y: 22.7344, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 110.742, y: 8, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 83.8828, y: 52.6782, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 110.742, y: 52.6782, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 83.8828, y: 67.6501, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 110.742, y: 67.6501, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 57.1717, y: 52.6782, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" }), /* @__PURE__ */ h.createElement("rect", { x: 57.1717, y: 67.6501, width: 24.26, height: 12.441, rx: 1.2441, fill: "#BBBFC3" })), _h = (e) => /* @__PURE__ */ h.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 140, height: 88, viewBox: "0 0 140 88", fill: "none", ...e }, /* @__PURE__ */ h.createElement("rect", { x: 0.5, y: 0.5, width: 139, height: 87, rx: 3.5, fill: "currentColor", stroke: "#BBBFC3" })), $h = "_thumbnail_1hb4h_12", eg = "_caption_1hb4h_17", tg = "_container_1hb4h_23", ng = "_dark_1hb4h_29", og = "_active_1hb4h_32", ag = "_light_1hb4h_36", qe = {
  thumbnail: $h,
  caption: eg,
  container: tg,
  dark: ng,
  active: og,
  light: ag
}, qt = [
  $.AdaptiveComposition
];
function rg(e) {
  switch (e) {
    case $.AdaptiveComposition:
      return jh;
    case $.Speaker7:
      return Yh;
    case $.Speaker21:
      return Hh;
    case $.Speaker221:
      return Zh;
    case $.Speaker33:
      return Gh;
    case $.Equal22:
      return Uh;
    case $.Equal33:
      return qh;
    case $.Equal44:
      return Xh;
    case $.Equal55:
      return Kh;
    case $.Highlight:
      return Jh;
    default:
      return _h;
  }
}
const qa = ({ className: e, layout: t, colorScheme: a, selectLayout: o, children: r, active: i }) => {
  const { t: s } = y(), c = L(
    () => o(t),
    [t, o]
  );
  return /* @__PURE__ */ n.createElement(sn, null, ({ colorScheme: l }) => /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    rn,
    {
      onClick: c,
      className: b(
        qe.container,
        "mb-2",
        "mt-2",
        e
      ),
      "data-testid": `${u.Layout}-${t}`,
      "aria-label": s(`settings.layout[${t}]`, {
        defaultValue: t,
        nsSeparator: !1
      })
    },
    r,
    t && /* @__PURE__ */ n.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start"
        }
      },
      /* @__PURE__ */ n.createElement(
        N,
        {
          className: qe.caption,
          colorScheme: a ?? l,
          htmlTag: "span",
          "data-testid": `${u.LayoutLabel}-${t}`,
          isTruncated: !0
        },
        s(`settings.layout[${t}]`, {
          defaultValue: t,
          nsSeparator: !1
        })
      ),
      qt.includes(
        t
      ) && /* @__PURE__ */ n.createElement(N, { fontVariant: S.Small }, /* @__PURE__ */ n.createElement(Z, { i18nKey: "settings.layout-only-for-everyone" }, "Only available for everyone"))
    ),
    i && /* @__PURE__ */ n.createElement(
      "div",
      {
        style: {
          flex: "1 1",
          justifyContent: "flex-end",
          display: "flex"
        },
        className: "mr-1"
      },
      /* @__PURE__ */ n.createElement(
        F,
        {
          source: k.IconCheckmark,
          color: Yr[a ?? l]["border/accent"]
        }
      )
    )
  ), /* @__PURE__ */ n.createElement(cn, null)));
}, ig = ({ active: e, className: t, colorScheme: a, layout: o, selectLayout: r, ...i }) => {
  const s = rg(o);
  return /* @__PURE__ */ n.createElement(qa, { layout: o, selectLayout: r, ...i }, /* @__PURE__ */ n.createElement(sn, null, ({ colorScheme: c }) => /* @__PURE__ */ n.createElement(
    Vn,
    {
      source: s,
      className: b(
        qe.thumbnail,
        qe[a ?? c],
        "mr-2",
        {
          [qe.active]: !!e
        },
        t
      ),
      ...i
    }
  )));
}, sg = ({ svg: e, name: t, active: a, colorScheme: o, ...r }) => /* @__PURE__ */ n.createElement(sn, null, ({ colorScheme: i }) => /* @__PURE__ */ n.createElement(
  "img",
  {
    src: a ? e.active : e.primary,
    className: b(
      qe.thumbnail,
      qe[o ?? i],
      "mr-2",
      {
        [qe.active]: !!a
      }
    ),
    ...r,
    alt: `${t} layout thumbnail`
  }
)), cg = "_layoutOption_thfk7_9", lg = {
  layoutOption: cg
}, dg = /* @__PURE__ */ new Map([
  [
    $.AdaptiveComposition,
    [
      "5:7",
      "ac_presentation_in_mix",
      "ac_presentation_in_mix_group",
      "ac_extended"
    ]
  ],
  [$.Equal22, ["4:0"]],
  [$.Equal33, ["9:0"]],
  [$.Equal44, ["16:0"]],
  [$.Equal55, ["25:0"]]
]), kn = (e, t) => t === e ? !0 : !!(t && dg.get(e)?.includes(t)), qv = ({
  currentLayout: e,
  currentPersonalLayout: t,
  setLayout: a,
  setPersonalLayout: o,
  resetToMeetingLayout: r,
  canChangeLayout: i,
  canChangePersonalLayout: s,
  setShowLayoutChangeConfirmationModal: c,
  showLayoutChangeConfirmationModal: l,
  isConfirmationOpen: d,
  openConfirmation: m,
  closeConfirmation: p,
  layouts: g,
  onBackClick: f
}) => {
  const { t: v } = y(), [E, C] = x(!1), [B, w] = x(
    t ?? e
  ), M = L(() => {
    c(!1), C(!0), B && a(
      B,
      () => C(!1),
      () => C(!1)
    ), p();
  }, [
    B,
    p,
    a,
    c
  ]), P = L(() => {
    C(!0), B && o(
      B,
      () => C(!1),
      () => C(!1)
    );
  }, [B, o]), T = (Y) => /* @__PURE__ */ n.createElement(
    ig,
    {
      active: kn(Y, B),
      className: lg.layoutOption,
      layout: Y,
      key: Y,
      selectLayout: w
    }
  ), R = () => [
    $.AdaptiveComposition,
    $.Speaker7,
    $.Speaker21,
    $.Speaker221,
    $.Speaker33,
    $.Highlight,
    $.Equal22,
    $.Equal33,
    $.Equal44,
    $.Equal55
  ].map(T), O = () => Array.from(g.entries()).flatMap(([Y, J]) => !i && qt.includes(Y) ? [] : J.primary && J.active ? [
    /* @__PURE__ */ n.createElement(
      qa,
      {
        key: Y,
        layout: Y,
        selectLayout: w,
        active: kn(Y, B)
      },
      /* @__PURE__ */ n.createElement(
        sg,
        {
          name: Y,
          svg: J,
          active: kn(Y, B)
        }
      )
    )
  ] : [T(Y)]);
  A(() => {
    w(t ?? e);
  }, [e, t]);
  const G = s && !(qt.includes(B ?? "") || qt.includes(e ?? ""));
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    Dh,
    {
      headerContent: /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, /* @__PURE__ */ n.createElement(
        Et,
        {
          title: i ? v(
            "settings.meeting-layout",
            "Meeting layout"
          ) : v("settings.layout", "Layout"),
          onBackClick: f,
          backButtonTestId: u.ButtonSettingsBack
        }
      )),
      footerContent: /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, G && /* @__PURE__ */ n.createElement(
        D,
        {
          onClick: P,
          type: "submit",
          modifier: "fullWidth",
          className: "mb-2",
          isLoading: E,
          isDisabled: E,
          "data-testid": u.ButtonSettingsSaveMyself
        },
        /* @__PURE__ */ n.createElement(Z, { t: v, i18nKey: "settings.save-for-myself" }, "Save for myself")
      ), i && /* @__PURE__ */ n.createElement(
        D,
        {
          onClick: () => {
            l ? m() : M();
          },
          variant: "secondary",
          size: "medium",
          modifier: "fullWidth",
          isLoading: E,
          isDisabled: E,
          "data-testid": u.ButtonSettingsSaveAll
        },
        /* @__PURE__ */ n.createElement(
          Z,
          {
            t: v,
            i18nKey: "settings.save-for-everyone"
          },
          "Save for everyone"
        )
      ))
    },
    /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, g.size > 0 ? O() : R(), s && t && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
      D,
      {
        onClick: r,
        className: "mt-4 mb-1",
        variant: "tertiary",
        size: "medium",
        modifier: "fullWidth",
        "data-testid": u.ButtonSettingsResetToMeetingLayout
      },
      /* @__PURE__ */ n.createElement(
        Z,
        {
          t: v,
          i18nKey: "settings.reset-to-meeting-layout"
        },
        "Reset to meeting layout"
      )
    ), /* @__PURE__ */ n.createElement(N, { fontVariant: S.Small }, /* @__PURE__ */ n.createElement(
      Z,
      {
        t: v,
        i18nKey: "settings.layout-reset-to-meeting-layout-info"
      },
      "Resets your layout to the one chosen by host for this meeting"
    ))))
  ), /* @__PURE__ */ n.createElement(
    Qe,
    {
      closeOnOutsideClick: !1,
      cancelButtonTestid: u.ConfirmationModalCancelButton,
      cancelButtonText: v("common.cancel", "Cancel"),
      confirmButtonTestid: u.ConfirmationModalConfirmButton,
      confirmButtonText: v("common.change", "Change"),
      "data-testid": u.ModalLayoutChangeConfirmation,
      description: v(
        "settings.layout-confirmation-desc",
        "You’re about to change the layout for everyone in the meeting, not just yourself."
      ),
      isOpen: d,
      onCancel: p,
      onClose: p,
      onConfirm: M,
      title: v(
        "settings.layout-confirmation-title",
        "Changing layouts will affect everyone"
      ),
      uniqueTitle: v(
        "settings.layout-confirmation-title",
        "Changing layouts will affect everyone"
      )
    }
  ));
}, Xv = ({ isOpen: e, toggle: t, ...a }) => {
  const { t: o } = y();
  return /* @__PURE__ */ n.createElement(
    D,
    {
      "aria-label": o(
        "meeting.toggle-invite-modal",
        "Toggle invite members modal"
      ),
      modifier: "square",
      onClick: t,
      size: "medium",
      isActive: e,
      variant: "translucent",
      ...a
    },
    /* @__PURE__ */ n.createElement(F, { source: k.IconAddSomeone })
  );
}, mg = "_row_lp417_4", ug = "_actionButton_lp417_13", jo = {
  row: mg,
  actionButton: ug
}, pg = ({ addMember: e, className: t, displayName: a, identity: o, ...r }) => {
  const { t: i } = y(), [s, c] = x(!1), l = L(() => {
    s || (c(!0), e(o));
  }, [e, o, s]);
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(jo.row, t),
      "data-testid": u.SearchRow,
      ...r
    },
    /* @__PURE__ */ n.createElement(
      Hr,
      {
        displayName: a,
        usernameFontVariant: S.Body,
        avatarType: Vt.Initials
      }
    ),
    /* @__PURE__ */ n.createElement(
      D,
      {
        "aria-label": i("invite.invite-person", "Invite person"),
        className: jo.actionButton,
        "data-testid": u.ButtonInviteMemberSearchRow,
        onClick: l,
        variant: "secondary",
        size: "small",
        isDisabled: s
      },
      s ? i("invite.invited", "Invited") : i("invite.invite", "Invite")
    )
  );
}, hg = ({ onValueChange: e, value: t }) => {
  const { t: a } = y();
  return /* @__PURE__ */ n.createElement(
    ca,
    {
      "data-testid": u.InvitationSearchInput,
      label: a(
        "invite.search-for-someone",
        "Search for someone to invite"
      ),
      labelModifier: "hidden",
      name: "search-someone-to-invite",
      onValueChange: e,
      placeholder: a(
        "invite.search-for-someone",
        "Search for someone to invite"
      ),
      showClearButton: !!t,
      sizeModifier: "small",
      type: "text",
      value: t
    }
  );
}, gg = "_inMeetingModal_gj99v_18", fg = "_shouldTransform_gj99v_36", Eg = "_results_gj99v_40", vg = "_emptyResults_gj99v_49", Cg = "_spinner_gj99v_58", Qt = {
  inMeetingModal: gg,
  shouldTransform: fg,
  results: Eg,
  emptyResults: vg,
  spinner: Cg
}, Kv = ({ className: e, inviteLinkBox: t }) => {
  const { t: a } = y();
  return /* @__PURE__ */ n.createElement("div", { className: b("m-4", e) }, /* @__PURE__ */ n.createElement(
    N,
    {
      fontVariant: S.Body,
      "data-testid": u.SendInviteLink
    },
    /* @__PURE__ */ n.createElement(Z, { t: a, i18nKey: "invite.send-invite-link" }, "or send an invite link")
  ), t);
}, _v = ({ invitees: e, loading: t, searched: a = !1, onInviteeAdd: o }) => {
  const { t: r } = y();
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: b(Qt.results, {
        [Qt.emptyResults]: !e.length
      })
    },
    t ? /* @__PURE__ */ n.createElement(
      $o,
      {
        className: Qt.spinner,
        colorScheme: "dark",
        sizeModifier: "medium"
      }
    ) : e.length > 0 ? e.map(({ identity: i, name: s }) => /* @__PURE__ */ n.createElement(
      pg,
      {
        key: i,
        addMember: o,
        displayName: s,
        identity: i
      }
    )) : /* @__PURE__ */ n.createElement(N, { fontVariant: S.Body }, a ? r(
      "invite.cant-find-anyone",
      "Can’t find anyone with that name"
    ) : r(
      "invite.click-search",
      "Click on the search field above to search"
    ))
  );
}, $v = ({ children: e, className: t, searchValue: a, onSearchValueChange: o, ...r }) => {
  const { t: i } = y();
  return /* @__PURE__ */ n.createElement("div", { className: b("mt-4 ml-4", t), ...r }, /* @__PURE__ */ n.createElement(Ie, { htmlTag: "h5", fontVariant: S.H5 }, /* @__PURE__ */ n.createElement(Z, { t: i, i18nKey: "invite.invite-someone" }, "Invite someone to the meeting")), /* @__PURE__ */ n.createElement("div", { className: "mt-4 mr-4" }, /* @__PURE__ */ n.createElement(
    hg,
    {
      value: a,
      onValueChange: o
    }
  )), e);
}, bg = ({
  children: e,
  className: t,
  isOpen: a,
  modalType: o = Zr.Positioned,
  onClose: r,
  ...i
}) => {
  const { t: s } = y(), { modalHandleRef: c, focusModal: l } = sa();
  return A(() => {
    a && l();
  }, [l, a]), /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, /* @__PURE__ */ n.createElement(
    at,
    {
      ref: c,
      className: t,
      "data-testid": u.ModalInvitation,
      isOpen: a,
      modalType: o,
      onClose: r,
      padding: "none",
      testIdCloseButton: u.ButtonCloseInvitationModal,
      uniqueTitle: s(
        "invite.meeting-invitation-modal",
        "Meeting Invitation Modal"
      ),
      withCloseButton: !0,
      withMask: !1,
      ...i
    },
    e
  ));
}, eC = ({ children: e, shouldTransform: t, ...a }) => /* @__PURE__ */ n.createElement(
  bg,
  {
    className: b(Qt.inMeetingModal, {
      [Qt.shouldTransform]: t
    }),
    ...a
  },
  e
), yg = "_linkCopyButton_1sn92_4", Bg = "_linkBox_1sn92_9", kg = "_linkText_1sn92_19", wn = {
  linkCopyButton: yg,
  linkBox: Bg,
  linkText: kg
}, tC = ({ className: e, expiryHours: t, link: a, isCopied: o = !1, onClick: r }) => {
  const { t: i } = y();
  return A(() => {
    o && Gr(i("invite.copied", "Copied"), "assertive");
  }, [o, i]), /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    Re,
    {
      isWithBorder: !0,
      isWithShadow: !1,
      colorScheme: "light",
      hasBackground: !0,
      bgColor: Me.DeepBlue10,
      style: o ? { borderColor: Me.SignalGreen } : {},
      className: b(e, wn.linkBox),
      "data-testid": u.MeetingLinkWrapper
    },
    /* @__PURE__ */ n.createElement(
      N,
      {
        colorScheme: "light",
        className: wn.linkText,
        "data-testid": u.MeetingLinkText
      },
      a
    ),
    /* @__PURE__ */ n.createElement(
      D,
      {
        variant: o ? "success" : "primary",
        colorScheme: "light",
        className: wn.linkCopyButton,
        noEnhancerPadding: !0,
        onClick: r,
        "aria-label": i(
          "invite.copy-to-clipboard",
          "Copy a link to clipboard"
        ),
        "data-testid": u.ButtonCopyMeetingLink
      },
      o ? i("invite.copied", "Copied") : i("invite.copy", "Copy")
    )
  ), t && /* @__PURE__ */ n.createElement("div", { className: "mt-2" }, /* @__PURE__ */ n.createElement(N, { fontVariant: S.Small }, /* @__PURE__ */ n.createElement(Z, { t: i, i18nKey: "invite.expiry" }, "Your invite link expires in ", { expiryHours: t }, " hours"))));
}, wg = "_mainWrapper_1ivn9_203", xg = "_mutedWrapper_1ivn9_221", Mg = "_mutedDisabled_1ivn9_226", Ig = "_childrenWrapper_1ivn9_230", Sg = "_tooltipButtonWrapper_1ivn9_239", It = {
  mainWrapper: wg,
  mutedWrapper: xg,
  mutedDisabled: Mg,
  childrenWrapper: Ig,
  tooltipButtonWrapper: Sg
}, nC = ({
  children: e,
  deviceStatusInfo: t,
  isDisabled: a,
  requestCameraPreview: o,
  showPreviewLabel: r,
  stopCameraPreview: i,
  updatingPreviewAudio: s,
  updatingPreviewVideo: c,
  ...l
}) => {
  const { t: d } = y(), [m, p] = x(!0), [g, f] = x(!1), v = t.error ? {
    icon: k.IconRefresh,
    text: d("common.try-again", "Try again"),
    testid: u.SettingButtonTryAgain
  } : {
    icon: k.IconVideoOn,
    text: d("settings.request-preview", "Request preview"),
    testid: u.SettingButtonRequestPreview
  }, E = c || s;
  return /* @__PURE__ */ n.createElement("div", { className: It.mainWrapper }, /* @__PURE__ */ n.createElement(
    Kn,
    {
      "aria-label": d("media.settings-selfview", "Settings selfview"),
      aspectRatioWrapperClassName: "mb-2",
      "data-testid": u.SettingsVideoSelfview,
      labelContent: /* @__PURE__ */ n.createElement(N, { fontVariant: S.XSmall }, /* @__PURE__ */ n.createElement("div", { className: "d-flex align-items-center" }, d("settings.preview-label", "Private preview"), /* @__PURE__ */ n.createElement(
        ot,
        {
          controlledIsVisible: g,
          controlledOnChange: f,
          position: "bottomEnd",
          text: d(
            "setting.preview-label-info",
            "Only you can see this. Your camera remains off for everyone in the meeting."
          ),
          ctaText: /* @__PURE__ */ n.createElement(
            D,
            {
              modifier: "fluid",
              variant: "text",
              size: "compact",
              onClick: () => {
                f(!1), i?.();
              }
            },
            d(
              "setting.preview-label-action",
              "Stop preview"
            )
          )
        },
        /* @__PURE__ */ n.createElement(
          D,
          {
            modifier: "disc",
            variant: "transparent",
            size: "compact",
            onClick: () => f((C) => !C)
          },
          /* @__PURE__ */ n.createElement(
            F,
            {
              source: k.IconInfoRound,
              size: "compact"
            }
          )
        )
      ))),
      labelTestId: u.SettingsVideoSelfviewPreviewLabel,
      showLabel: r,
      "wrapper-data-testid": u.SettingsVideoSelfviewWrapper,
      shouldShowUserAvatar: !1,
      username: "",
      ...l
    },
    l.isVideoInputMuted && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
      Ln,
      {
        className: b(It.mutedWrapper, {
          [It.mutedDisabled]: a
        })
      },
      /* @__PURE__ */ n.createElement(
        Jr,
        {
          colorScheme: "dark",
          isLoading: E,
          sizeModifier: "medium"
        },
        /* @__PURE__ */ n.createElement(
          F,
          {
            size: "medium",
            colorScheme: "dark",
            "data-testid": t.error ? u.SettingIconWarning : u.SettingIconCameraOff,
            source: t.error ? k.IconAlert : k.IconVideoOff
          }
        ),
        /* @__PURE__ */ n.createElement(
          N,
          {
            colorScheme: "dark",
            fontVariant: S.BodyBold
          },
          t.error ? t.title : d(
            "settings.your-camera-is-off",
            "Your camera is off."
          )
        )
      )
    ), !a && !E && /* @__PURE__ */ n.createElement(
      "div",
      {
        className: b(
          "d-flex flex-direction-column align-items-center",
          It.tooltipButtonWrapper
        )
      },
      /* @__PURE__ */ n.createElement(
        ot,
        {
          usePortal: !0,
          controlledIsVisible: m,
          controlledOnChange: p,
          position: "topCenter",
          header: t.title,
          text: t.message
        },
        /* @__PURE__ */ n.createElement(
          D,
          {
            colorScheme: "dark",
            onClick: o,
            variant: "tertiary",
            "data-testid": v.testid,
            isDisabled: t.error && !t.retriable,
            isLoading: E,
            enhancerStart: /* @__PURE__ */ n.createElement(F, { source: v.icon })
          },
          v.text
        )
      )
    ))
  ), /* @__PURE__ */ n.createElement("div", { className: It.childrenWrapper }, e));
}, Pg = "_wrapper_11ow6_4", Ng = {
  wrapper: Pg
}, oC = ({ addParticipant: e }) => {
  const { t } = y();
  return /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, /* @__PURE__ */ n.createElement("div", { className: Ng.wrapper }, /* @__PURE__ */ n.createElement(cn, null), /* @__PURE__ */ n.createElement(
    D,
    {
      className: b("p-3", "text-center"),
      size: "large",
      modifier: "fullWidth",
      title: t("add-participant.submit", "Add participant"),
      variant: "text",
      onClick: e,
      "data-testid": u.UserMenuAddParticipant
    },
    t("add-participant.submit", "Add participant")
  )));
}, aC = ({ voiceDetected: e, audioMuted: t, setVoiceDetected: a }) => {
  const { t: o } = y(), [r, i] = x(!1);
  A(() => (t || (i(!1), a(!1)), () => {
    a(!1);
  }), [t, a]);
  const s = e && t && !r, c = L(
    (l) => {
      l && i(!0), a(!1);
    },
    [a]
  );
  return /* @__PURE__ */ n.createElement(
    Ur,
    {
      message: o(
        "media.trying-to-speak",
        "Trying to speak? Your microphone is muted"
      ),
      isDisplayed: s,
      isVisible: s,
      onDismiss: () => c(t),
      position: "bottomCenter",
      colorScheme: "light",
      timeout: 0
    }
  );
}, Tg = {
  [ue.Reconnecting]: {
    iconSrc: k.IconAlert,
    testId: u.NetworkReconnectingState
  },
  [ue.Reconnected]: {
    iconSrc: k.IconCheckmark,
    testId: u.NetworkReconnectedState
  },
  // we want this to be the last state's UI so its preserved whilst fading out
  [ue.Connected]: {
    iconSrc: k.IconCheckmark,
    testId: u.NetworkConnectedState
  }
}, Rg = "_main_536y4_38", zg = "_shown_536y4_49", Wg = "_hidden_536y4_56", Lg = "_check_536y4_60", Fg = "_alert_536y4_64", St = {
  main: Rg,
  shown: zg,
  hidden: Wg,
  check: Lg,
  alert: Fg
}, rC = ({ networkState: e }) => {
  const { t } = y(), { iconSrc: a, testId: o } = Tg[e], r = /* @__PURE__ */ n.createElement(
    N,
    {
      className: "text-center",
      colorScheme: "light",
      fontVariant: S.BodyBold
    },
    e === ue.Reconnecting ? t(
      "meeting.network-reconnecting",
      "Lost network connection. Reconnecting..."
    ) : t("meeting.network-fixed", "Fixed!")
  );
  return /* @__PURE__ */ n.createElement(
    Xe,
    {
      className: b(St.main, {
        [St.shown]: e !== ue.Connected,
        [St.hidden]: e === ue.Connected
      }),
      "data-testid": o
    },
    /* @__PURE__ */ n.createElement(
      F,
      {
        source: a,
        size: "compact",
        className: b("mr-2", "flex-shrink-0", {
          [St.alert]: e === ue.Reconnecting,
          [St.check]: e !== ue.Reconnecting
        })
      }
    ),
    r
  );
}, iC = ({ isOpen: e, userName: t, description: a, onCancel: o, onConfirm: r, ...i }) => {
  const { t: s } = y();
  return /* @__PURE__ */ n.createElement(
    Qe,
    {
      ...i,
      cancelButtonTestid: u.ButtonRemoveUserCancel,
      cancelButtonText: s("common.cancel", "Cancel"),
      confirmButtonTestid: u.ButtonRemoveUserConfirm,
      confirmButtonText: s("common.remove", "Remove"),
      confirmButtonVariant: "danger",
      "data-testid": u.ModalRemoveUser,
      description: a,
      isOpen: e,
      onCancel: o,
      onConfirm: r,
      title: s("meeting.remove-user-confirmation", {
        defaultValue: "Are you sure you want to remove {{userName}} from this meeting?",
        userName: t
      }),
      uniqueTitle: s("meeting.remove-user-confirmation", {
        defaultValue: "Are you sure you want to remove {{userName}} from this meeting?",
        userName: t
      })
    }
  );
}, Qg = "data:image/png;base64,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";
var Wt = /* @__PURE__ */ ((e) => (e.Narrow = "280px", e.NarrowTouch = "296px", e.Wide = "664px", e.HundredPercent = "100%", e))(Wt || {}), Xa = /* @__PURE__ */ ((e) => (e.Meeting = "meeting", e.Lobby = "lobby", e))(Xa || {});
const Ag = () => {
  const e = la(), t = da(), a = On();
  if (e || a)
    return "vertical";
  if (t)
    return "horizontal";
}, Vg = () => {
  const e = la(), t = da(), a = On(), o = nn();
  if (e)
    return o ? Wt.NarrowTouch : Wt.Narrow;
  if (t)
    return Wt.Wide;
  if (a)
    return Wt.HundredPercent;
};
var Lt = /* @__PURE__ */ ((e) => (e.NoAnimation = "", e.VerticalOpen = "verticalOpen", e.VerticalClose = "verticalClose", e.HorizontalOpen = "horizontalOpen", e.HorizontalClose = "horizontalClose", e))(Lt || {});
const Og = 1e3, Dg = ({
  isVertical: e,
  shouldAnimate: t,
  updateStates: a,
  onAnimateComplete: o
}) => {
  const r = ee(!1), i = ee(st), [s, c] = x(
    ""
    /* NoAnimation */
  ), l = L(() => {
    c(
      ""
      /* NoAnimation */
    ), i.current = st, r.current = !1, o();
  }, [o]), d = qr();
  A(() => d.add(() => {
    r.current && l();
  }), [d, l]);
  const m = L(() => {
    r.current = !0, c(e ? "verticalClose" : "horizontalClose"), i.current = () => {
      i.current = () => {
        setTimeout(() => {
          l();
        }, 200);
      }, setTimeout(() => {
        a(), c(e ? "horizontalOpen" : "verticalOpen");
      }, Og);
    };
  }, [e, a, l]);
  return A(() => {
    t && !r.current && m();
  }, [t, m]), [s, i.current];
}, jg = ({
  orientation: e,
  width: t,
  imageUrl: a,
  logoUrl: o,
  imageContent: r,
  headerText: i,
  bodyContent: s
}) => {
  const [c, l] = x(e === "vertical"), [d, m] = x(t), [p, g] = x(a), [f, v] = x(o), [E, C] = x(r), [B, w] = x(i), [M, P] = x(s), T = L(() => {
    const R = e === "vertical";
    R !== c && l(R), d !== t && m(t), p !== a && g(a), f !== o && v(o), E !== r && C(r), B !== i && w(i), M !== s && P(s);
  }, [
    d,
    t,
    e,
    c,
    p,
    a,
    f,
    o,
    E,
    r,
    s,
    M,
    i,
    B
  ]);
  return [
    {
      isVertical: c,
      cardWidth: d,
      cardImageUrl: p,
      cardLogoUrl: f,
      cardImageContent: E,
      cardHeaderText: B,
      cardBodyContent: M
    },
    T
  ];
}, Yg = "_body_5hl21_4", Hg = "_isVertical_5hl21_12", Zg = "_contentContainer_5hl21_97", Gg = "_mainContent_5hl21_106", Jg = "_logo_5hl21_122", Ug = "_infoCard_5hl21_127", qg = "_transitionWidth_5hl21_137", Xg = "_infoCardImage_5hl21_141", Kg = "_transitionHeight_5hl21_158", _g = "_infoCardImageContent_5hl21_162", he = {
  body: Yg,
  isVertical: Hg,
  contentContainer: Zg,
  mainContent: Gg,
  logo: Jg,
  infoCard: Ug,
  transitionWidth: qg,
  infoCardImage: Xg,
  transitionHeight: Kg,
  infoCardImageContent: _g
}, $g = n.memo(
  ({
    imageUrl: e,
    logoUrl: t,
    headerText: a,
    bodyContent: o,
    imageContent: r,
    orientation: i,
    width: s,
    animate: { shouldAnimate: c = !1, onAnimateComplete: l = st } = {},
    type: d,
    brandName: m
  }) => {
    const { t: p } = y(), g = p("common.label-logo", "logo"), f = p("common.brand-name", "your video service"), v = d === Xa.Meeting ? p("infocard.meeting.header", {
      defaultValue: `Welcome to
 {{brandName}}`,
      brandName: m || f
    }) : p(
      "infocard.lobby.header",
      "Please wait, waiting for others to join"
    ), E = a || v, C = o || p("infocard.meeting.body", "Pexip Meetings"), B = e || Qg, w = Ag(), M = Vg(), P = s ?? M, T = i ?? w, [
      {
        isVertical: R,
        cardWidth: O,
        cardImageUrl: G,
        cardLogoUrl: Y,
        cardImageContent: J,
        cardHeaderText: _,
        cardBodyContent: U
      },
      H
    ] = jg({
      orientation: T,
      width: P,
      imageUrl: B,
      logoUrl: t,
      imageContent: r,
      headerText: E,
      bodyContent: C
    }), [q, te] = Dg({
      isVertical: R,
      shouldAnimate: c,
      updateStates: H,
      onAnimateComplete: l
    });
    A(() => {
      c || H();
    }, [H, c]);
    const V = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
      Ie,
      {
        htmlTag: "h2",
        fontVariant: S.H4,
        colorScheme: "light"
      },
      _
    ), R && U && (typeof U != "string" ? U : /* @__PURE__ */ n.createElement(
      N,
      {
        className: "mt-2 mb-0",
        htmlTag: "p",
        fontVariant: S.Body,
        colorScheme: "light"
      },
      /* @__PURE__ */ n.createElement(Yn, { text: U })
    )));
    return !P || !T ? null : /* @__PURE__ */ n.createElement(
      "div",
      {
        style: {
          width: q === Lt.HorizontalClose ? P : O
        },
        className: b(
          he.infoCard,
          R ? "flex-direction-column" : "flex-direction-row-reverse",
          {
            [he.isVertical]: R,
            [he.transitionWidth]: q === Lt.HorizontalClose || q === Lt.HorizontalOpen
          }
        )
      },
      /* @__PURE__ */ n.createElement(
        "div",
        {
          className: b(he.infoCardImage, {
            [he.isVertical]: R,
            [he.transitionHeight]: q === Lt.VerticalOpen
          }),
          style: { backgroundImage: `url('${G}')` }
        },
        J && /* @__PURE__ */ n.createElement("div", { className: he.infoCardImageContent }, J)
      ),
      /* @__PURE__ */ n.createElement(
        "div",
        {
          onAnimationEnd: te,
          className: b(he.body, {
            [q]: c,
            [he.isVertical]: R
          })
        },
        /* @__PURE__ */ n.createElement(
          "div",
          {
            className: b(
              he.contentContainer,
              R ? "flex-direction-column" : "flex-direction-column-reverse",
              {
                [he.isVertical]: R,
                "justify-content-space-between": !R
              }
            )
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: b(he.mainContent, {
                [he.isVertical]: R
              })
            },
            V
          ),
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: b({
                "mt-12": R
              })
            },
            Y && !Xr(Y) ? /* @__PURE__ */ n.createElement(
              Kr,
              {
                className: he.logo,
                imageSrc: Y,
                alt: m ? `${m} ${g}` : g,
                "aria-label": m ? `${m} ${g}` : g
              }
            ) : /* @__PURE__ */ n.createElement(
              An,
              {
                className: he.logo,
                "aria-label": p(
                  "common.label-pexip-logo",
                  "Pexip logo"
                ),
                size: "full",
                colorScheme: "light"
              }
            )
          )
        )
      )
    );
  }
);
$g.displayName = "InfoCard";
const sC = ({
  breakoutActionsCount: e,
  isPanelOpen: t,
  buttonAriaLabel: a,
  tooltipPosition: o = "top",
  ...r
}) => {
  const { t: i } = y();
  return /* @__PURE__ */ n.createElement(
    Ot,
    {
      "data-testid": u.BadgeCounterBreakoutRoomsPanelButton,
      number: e,
      isVisible: !t && e > 0,
      isTruncated: e > 9
    },
    /* @__PURE__ */ n.createElement(
      Ae,
      {
        "aria-label": a,
        "data-testid": u.ButtonBreakoutRooms,
        tooltipText: i("breakout-toggle-tooltip", "Breakout Rooms"),
        tooltipPosition: o,
        icon: /* @__PURE__ */ n.createElement(F, { source: k.IconBreakoutRooms, size: "small" }),
        isActive: t,
        ...r
      }
    )
  );
}, ef = "_panel_10kbo_234", tf = "_show_10kbo_262", nf = "_animateIn_10kbo_266", of = "_animateOut_10kbo_272", af = "_breakoutRoomsPanelWrapper_10kbo_375", Pt = {
  panel: ef,
  show: tf,
  animateIn: nf,
  animateOut: of,
  breakoutRoomsPanelWrapper: af
}, cC = ({ children: e, className: t, isShown: a, animateIn: o, animateOut: r }) => {
  const [i, s] = x(null);
  Dn(i, a);
  const c = $n(a), { ref: l } = jn(c);
  return /* @__PURE__ */ n.createElement("div", { ref: l }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: s,
      "data-testid": u.BreakoutRoomsPanelWrapper,
      className: b(
        Pt.panel,
        Pt.breakoutRoomsPanelWrapper,
        {
          [Pt.show]: a,
          [Pt.animateIn]: !!o,
          [Pt.animateOut]: !!r
        },
        t
      )
    },
    e
  ));
}, rf = "_wrapper_150qp_4", sf = "_input_150qp_8", cf = "_text_150qp_12", lf = "_editButton_150qp_16", Jt = {
  wrapper: rf,
  input: sf,
  text: cf,
  editButton: lf
}, df = ({ name: e, showEditButton: t, onSaveAction: a, className: o }) => {
  const [r, i] = x(!1), [s, c] = x(e), { t: l } = y(), d = L(() => {
    c(e), i(!0);
  }, [e]), m = L(() => {
    const g = s.trim();
    if (g === e) {
      i(!1);
      return;
    }
    a?.(g) && i(!1);
  }, [s, e, a]), p = L(
    (g) => {
      g.key === ht.enter && m(), g.key === ht.escape && i(!1);
    },
    [m]
  );
  return /* @__PURE__ */ n.createElement(ae, { className: b(Jt.wrapper, o), spacing: "none" }, r ? /* @__PURE__ */ n.createElement(
    ca,
    {
      autoComplete: "off",
      ref: (g) => {
        g?.focus();
      },
      className: Jt.input,
      value: s,
      label: l(
        "breakouts.breakout-room.name-label",
        "Breakout room name"
      ),
      labelModifier: "hidden",
      name: "inputValue",
      onKeyDown: p,
      onBlur: m,
      onValueChange: c,
      maxLength: 36
    }
  ) : /* @__PURE__ */ n.createElement(
    N,
    {
      isTruncated: !0,
      fontVariant: S.BodyBold,
      className: Jt.text
    },
    e
  ), t && !r && /* @__PURE__ */ n.createElement(
    D,
    {
      "data-testid": u.ButtonBreakoutRoomHeader,
      className: Jt.editButton,
      "aria-label": l(
        "breakouts.breakout-room.edit-button-label",
        "Edit breakout room name"
      ),
      onClick: d,
      size: "small",
      variant: "translucent",
      modifier: "square"
    },
    /* @__PURE__ */ n.createElement(F, { source: k.IconEdit, size: "small" })
  ));
}, mf = "_modalWrapper_f2eh5_1", uf = "_progressBarWrapper_f2eh5_5", pf = "_progressBar_f2eh5_5", xn = {
  modalWrapper: mf,
  progressBarWrapper: uf,
  progressBar: pf
}, lC = ({ className: e, roomName: t, secondsBeforeMove: a, onJoin: o, ...r }) => {
  const { t: i } = y(), [s, c] = x(a > 0), l = () => {
    o(), c(!1), p();
  }, { startCountDown: d, currentCount: m, cleanup: p } = Sr(
    {
      startCountFrom: a,
      enabled: !0
    },
    l
  );
  A(() => (d(), p), [p, d]);
  const g = `<strong>${t}</strong>`;
  return /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, /* @__PURE__ */ n.createElement(
    at,
    {
      isOpen: s,
      closeOnOutsideClick: !0,
      className: b(xn.modalWrapper, e),
      "data-testid": u.ModalMoveToRoom,
      ...r
    },
    /* @__PURE__ */ n.createElement(
      ta,
      {
        backgroundClassName: xn.progressBarWrapper,
        barClassName: xn.progressBar,
        progress: a === m ? 0 : 100,
        barColor: na.Primary,
        style: {
          transitionDuration: `${a - 1}s`
        }
      }
    ),
    /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.Body,
        htmlTag: "p",
        className: "mt-1 mb-2"
      },
      /* @__PURE__ */ n.createElement(
        Z,
        {
          t: i,
          i18nKey: "breakouts.move-to-room-modal.title",
          defaults: "You will be moved to {{roomName}} in {{currentCount}} {{secondString}}.",
          values: {
            roomName: g,
            currentCount: m,
            secondString: m >= 2 ? i("common.seconds", "seconds") : i("common.second", "second")
          }
        }
      )
    ),
    /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.Body,
        htmlTag: "p",
        className: "mb-4"
      },
      /* @__PURE__ */ n.createElement(Z, { t: i, i18nKey: "breakouts.move-to-room-modal.text" }, "You can join right now if you are ready.")
    ),
    /* @__PURE__ */ n.createElement(
      D,
      {
        "data-testid": u.ButtonMoveToBreakoutNow,
        modifier: "fullWidth",
        size: "large",
        onClick: l
      },
      /* @__PURE__ */ n.createElement(
        Z,
        {
          t: i,
          i18nKey: "breakouts.move-to-room-modal.join-now-btn",
          "aria-label": i(
            "breakouts.move-to-room-modal.aria-label-btn",
            {
              defaultValue: "Join {{roomName}} now",
              roomName: t
            }
          )
        },
        "Join now"
      )
    )
  ));
}, hf = "_wrapper_1bofa_4", gf = "_item_1bofa_9", ff = "_dragging_1bofa_13", Ef = "_draggableContent_1bofa_17", Nt = {
  wrapper: hf,
  item: gf,
  dragging: ff,
  draggableContent: Ef
}, Ka = n.forwardRef(
  ({
    participants: e,
    myIdentity: t,
    rooms: a,
    variant: o = fe.Setup,
    scrollElementRef: r,
    onParticipantDragging: i,
    onParticipantDrag: s,
    onParticipantRoomChange: c,
    className: l,
    lockStyle: d = _r.VERTICAL,
    ...m
  }, p) => {
    const [g, f] = x();
    return /* @__PURE__ */ n.createElement(Re, { ...m, ref: p, className: b(Nt.wrapper, l) }, e.map((v) => /* @__PURE__ */ n.createElement(
      ea,
      {
        scrollElementRef: r,
        pointerCapture: !0,
        className: b(Nt.item, {
          [Nt.dragging]: o !== fe.Preview && g === v.uuid
        }),
        id: v.uuid,
        key: v.uuid,
        onPointerMoveExtra: i,
        onPointerUpExtra: s,
        onPointerDown: () => f(v.uuid),
        onPointerUp: () => f(void 0),
        isDisabled: o === fe.Preview || !a || a && Object.entries(a).length === 0,
        lockStyle: d
      },
      /* @__PURE__ */ n.createElement(
        wh,
        {
          participant: v,
          isCurrentPeer: v.uuid === t,
          rooms: a,
          isDragging: g !== void 0,
          onParticipantRoomChange: c,
          className: b(Nt.draggableContent, {
            [Nt.dragging]: o !== fe.Preview && g === v.uuid
          })
        }
      )
    )));
  }
);
Ka.displayName = "BreakoutRoomParticipantList";
const vf = "_wrapper_ilyhc_11", Cf = "_dragTarget_ilyhc_17", bf = "_mainRoom_ilyhc_24", yf = "_footer_ilyhc_28", Bf = "_dragDivider_ilyhc_37", Tt = {
  wrapper: vf,
  dragTarget: Cf,
  mainRoom: bf,
  footer: yf,
  dragDivider: Bf
}, pn = n.forwardRef(
  ({
    id: e,
    name: t,
    participants: a,
    myIdentity: o,
    amIControlOnlyParticipant: r,
    rooms: i,
    variant: s = fe.Setup,
    onNameChanged: c,
    isDragTarget: l,
    scrollElementRef: d,
    canEditRoomName: m = !1,
    renderParticipants: p,
    onParticipantDragging: g,
    onParticipantDrag: f,
    onParticipantRoomChange: v,
    _onAssignParticipants: E,
    onJoinRoom: C,
    onCloseRoom: B,
    onRemoveRoom: w,
    lockStyle: M,
    ...P
  }, T) => {
    const { t: R } = y(), [O, G] = x(!1), Y = e === pe, J = a.some(
      ({ uuid: te }) => te === o
    ), _ = L(
      (te) => c?.(e, te),
      [e, c]
    ), U = L(() => {
      G(!1), B?.(e);
    }, [e, B]), H = () => {
      switch (s) {
        case fe.Setup:
          return null;
        case fe.Preview:
          return !Y && B ? /* @__PURE__ */ n.createElement(
            D,
            {
              variant: "dangerBordered",
              onClick: () => G(!0),
              "aria-label": R(
                "breakouts.breakout-room.close-room-aria-label",
                "Close breakout room"
              ),
              "data-testid": u.CloseBreakoutRoom
            },
            R("common.close", "Close")
          ) : null;
        case fe.Edit:
          return null;
      }
    }, q = () => {
      switch (s) {
        case fe.Setup:
        case fe.Edit:
          return Y ? null : /* @__PURE__ */ n.createElement(
            Oa,
            {
              variant: "tertiary",
              iconSource: k.IconTrash,
              hideChildren: !0,
              onClick: () => w?.(e),
              "aria-label": R(
                "breakouts.breakout-room.remove-room-aria-label",
                "Remove breakout room"
              ),
              "data-testid": u.RemoveBreakoutRoom
            }
          );
        case fe.Preview:
          return r ? null : /* @__PURE__ */ n.createElement(
            D,
            {
              variant: "success",
              isDisabled: J,
              "aria-label": R(
                "common.join.aria-label",
                "Join breakout room"
              ),
              onClick: () => C?.(e),
              "data-testid": u.JoinBreakoutRoom
            },
            R("common.join", "Join")
          );
      }
    };
    return /* @__PURE__ */ n.createElement(
      Re,
      {
        ...P,
        "data-testid": u.BreakoutRoom,
        id: e,
        ref: T,
        className: b(Tt.wrapper, P.className, {
          [Tt.mainRoom]: e === pe,
          [Tt.dragTarget]: l
        })
      },
      /* @__PURE__ */ n.createElement(
        df,
        {
          className: "mb-2",
          onSaveAction: _,
          name: Y ? R(
            "breakouts.breakout-room.main-name",
            "Main Room"
          ) : t,
          showEditButton: m && !Y
        }
      ),
      /* @__PURE__ */ n.createElement(
        ia,
        {
          title: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            N,
            {
              fontVariant: S.SmallBold,
              className: "me-2"
            },
            e === pe ? R(
              "breakouts.breakout-room.not-assigned",
              "Not assigned"
            ) : R(
              "breakouts.breakout-room.assigned",
              "Assigned"
            )
          ), /* @__PURE__ */ n.createElement(N, null, a.length)),
          "aria-label": e === pe ? R(
            "breakouts.breakout-room.not-assigned-aria-label",
            "Participants not assigned to a breakout room"
          ) : R(
            "breakouts.breakout-room.assigned-aria-label",
            "Participants assigned to breakout room {{name}}"
          ),
          isExpanded: !0
        },
        p ? p(a) : /* @__PURE__ */ n.createElement(
          Ka,
          {
            lockStyle: M,
            scrollElementRef: d,
            participants: a,
            myIdentity: o,
            rooms: i,
            onParticipantDragging: g,
            onParticipantDrag: f,
            onParticipantRoomChange: v,
            variant: s
          }
        ),
        l && /* @__PURE__ */ n.createElement(cn, { className: Tt.dragDivider })
      ),
      /* @__PURE__ */ n.createElement("div", { className: Tt.footer }, /* @__PURE__ */ n.createElement(H, null), /* @__PURE__ */ n.createElement(q, null)),
      /* @__PURE__ */ n.createElement(
        Qe,
        {
          cancelButtonText: R("common.cancel", "Cancel"),
          onCancel: () => G(!1),
          confirmButtonText: R("common.yes", "Yes"),
          onConfirm: U,
          title: R("breakouts.close-room-modal.title", {
            defaultValue: "Close {{name}}?",
            name: t
          }),
          uniqueTitle: R("breakouts.close-room-modal.title", {
            defaultValue: "Close {{name}}?",
            name: t
          }),
          description: R(
            "breakouts.close-room-modal.text",
            "The participants in this room will be moved to the main room."
          ),
          isOpen: O
        }
      )
    );
  }
);
pn.displayName = "BreakoutRoom";
const _a = ({
  onAddRoomButtonClick: e,
  onShuffledButtonClick: t,
  onSettingsButtonClick: a,
  isShuffling: o = !1
}) => {
  const { t: r } = y(), [i, s] = n.useState(!1), c = [
    !!e && {
      key: "addRoom",
      label: r("breakouts.add-room-button-text", "Add room"),
      icon: /* @__PURE__ */ n.createElement(F, { source: k.IconAdd, size: "compact" }),
      onItemClick: e,
      closeMenuOnItemClick: !1,
      testId: u.ButtonBreakoutRoomAddRoom
    },
    !!t && {
      key: "shuffle",
      label: o ? r("breakouts.shuffling-button-text", "Shuffling...") : r("breakouts.shuffle-button-text", "Shuffle"),
      icon: /* @__PURE__ */ n.createElement(F, { source: k.IconShuffle, size: "compact" }),
      onItemClick: t,
      testId: u.ButtonBreakoutRoomShuffle,
      closeMenuOnItemClick: !1
    },
    !!a && {
      key: "settings",
      label: r("breakouts.settings-button-text", "Settings"),
      icon: /* @__PURE__ */ n.createElement(F, { source: k.IconSettings, size: "compact" }),
      onItemClick: a,
      closeMenuOnItemClick: !1,
      testId: u.ButtonBreakoutRoomSettings
    }
  ].filter(Boolean);
  return /* @__PURE__ */ n.createElement(
    an,
    {
      onOpenChange: s,
      items: c,
      button: /* @__PURE__ */ n.createElement(
        D,
        {
          isActive: i,
          size: "compact",
          modifier: "square",
          variant: "translucent",
          "aria-label": r(
            "breakouts.more-configuration-menu-aria-label",
            "See more breakout rooms configuration options"
          ),
          "data-testid": u.ButtonBreakoutRoomsConfiguration
        },
        /* @__PURE__ */ n.createElement(F, { source: k.IconMoreVertical })
      ),
      popoverPlacement: "bottom left"
    }
  );
}, dC = ({
  currentParticipants: e,
  myIdentity: t,
  openRoomsText: a,
  isOpeningRooms: o = !1,
  numberOfRooms: r = 0,
  assignmentMode: i,
  headerText: s,
  onBack: c,
  onClosePanel: l,
  onOpenRooms: d,
  onSettingsButtonClick: m,
  shuffle: p = Un,
  children: g
}) => {
  const { t: f } = y(), v = ln(), [E, C] = x(e), [B, w] = x(!1), M = ee(null), { handleBreakoutRoomNameChange: P, duplicateRoomNameModal: T } = Sa({
    participants: E,
    setParticipants: C
  }), R = xa({
    participants: E,
    setParticipants: C
  });
  ps({
    currentParticipants: e,
    participants: E,
    setParticipants: C,
    changeParticipantRoom: R
  }), cs({
    assignmentMode: i,
    myIdentity: t,
    numberOfRooms: r,
    setParticipants: C,
    shuffle: p
  });
  const {
    targetRoomId: O,
    onParticipantDragging: G,
    onParticipantDrag: Y,
    getBreakoutRoomRefCallback: J
  } = Ma({
    participants: E,
    changeParticipantRoom: R,
    setIsDragging: w
  }), _ = Ia({ setParticipants: C }), { doShuffle: U, isShuffling: H } = Pa({
    myIdentity: t,
    setParticipants: C,
    shuffle: p
  }), q = ha({ setParticipants: C }), te = Fe(
    () => Zn(E).length < 1,
    [E]
  ), V = /* @__PURE__ */ n.createElement(
    D,
    {
      onClick: () => d(E),
      isLoading: o,
      modifier: "fullWidth",
      isDisabled: te,
      "data-testid": u.OpenBreakoutRooms
    },
    a
  );
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    Dt,
    {
      scrollElementRef: M,
      overflowHidden: B,
      isRounded: v,
      padding: "none",
      footerPadding: "small",
      headerContent: /* @__PURE__ */ n.createElement(
        Et,
        {
          title: s,
          onBackClick: c,
          onCloseClick: l,
          backButtonTestId: u.BreakoutSetupPanelBackBtn,
          closeButtonTestId: u.PanelHeaderCloseButton,
          endContent: /* @__PURE__ */ n.createElement(
            _a,
            {
              onAddRoomButtonClick: q,
              onSettingsButtonClick: m,
              onShuffledButtonClick: U,
              isShuffling: H
            }
          )
        }
      ),
      footerContent: te ? /* @__PURE__ */ n.createElement(
        me,
        {
          tooltipContainerClassName: "d-flex",
          text: f(
            "breakouts.open-rooms-btn-disabled-tooltip",
            "Minimum one breakout room is required"
          ),
          position: "top"
        },
        V
      ) : V,
      scrollElementClassname: "pt-2 pr-3 pb-3 pl-3"
    },
    Array.from(E.entries()).map(
      ([I, z]) => /* @__PURE__ */ n.createElement(
        pn,
        {
          scrollElementRef: M,
          id: I,
          key: I,
          name: I,
          rooms: Array.from(E.keys()).reduce(
            (Q, ne) => (I !== ne && (Q[ne] = ne), Q),
            {}
          ),
          myIdentity: t,
          participants: z,
          isDragTarget: O === I,
          onNameChanged: P,
          onParticipantDragging: G,
          onParticipantDrag: Y,
          onParticipantRoomChange: R,
          onRemoveRoom: _,
          ref: J(I),
          canEditRoomName: !0
        }
      )
    )
  ), T, g);
}, kf = "_wrapper_4dxr1_4", wf = {
  wrapper: kf
}, xf = "_roomRow_r8vpr_4", Mf = "_room_r8vpr_4", Yo = {
  roomRow: xf,
  room: Mf
}, If = ({ breakoutName: e, roomId: t, onJoinRoom: a, className: o }) => {
  const { t: r } = y();
  return /* @__PURE__ */ n.createElement("div", { className: b(Yo.roomRow, o) }, /* @__PURE__ */ n.createElement("div", { className: Yo.room }, /* @__PURE__ */ n.createElement(
    N,
    {
      fontVariant: S.Body,
      isTruncated: !0,
      title: e,
      translate: "no"
    },
    e
  )), /* @__PURE__ */ n.createElement(
    D,
    {
      "data-testid": u.ButtonBreakoutJoinAskingForHelp,
      size: "small",
      className: "mr-2 ml-2",
      variant: "success",
      "aria-label": r("common.join.aria-label", "Join breakout room"),
      onClick: () => a(t)
    },
    r("common.join", "Join")
  ));
}, Sf = ({ breakoutsAskingForHelp: e, onJoinRoom: t, ...a }) => {
  const { t: o } = y(), [r, i] = x(!0), s = () => /* @__PURE__ */ n.createElement(
    D,
    {
      variant: "text",
      size: "compact",
      enhancerStart: /* @__PURE__ */ n.createElement(
        F,
        {
          className: "mr-1",
          source: r ? k.IconChevronUp : k.IconChevronDown,
          size: "mini"
        }
      ),
      onClick: () => i((c) => !c),
      underlineText: !1
    },
    /* @__PURE__ */ n.createElement("div", { className: "d-flex align-items-center" }, /* @__PURE__ */ n.createElement(N, { fontVariant: S.H5 }, o("breakouts.asking-for-help", "Asking for help")), /* @__PURE__ */ n.createElement(N, { className: "ml-2" }, e.length))
  );
  return e.length === 0 ? null : /* @__PURE__ */ n.createElement(Re, { padding: "small", ...a, className: b(wf.wrapper) }, /* @__PURE__ */ n.createElement(s, null), r && /* @__PURE__ */ n.createElement("div", { className: "mt-4" }, e.map(({ breakoutName: c, roomId: l }) => /* @__PURE__ */ n.createElement(
    If,
    {
      className: "mt-2",
      key: l,
      breakoutName: c,
      roomId: l,
      onJoinRoom: t
    }
  ))));
}, Pf = "_editButton_15vug_1", Nf = {
  editButton: Pf
}, mC = ({
  breakoutsAskingForHelp: e,
  currentParticipants: t,
  showCloseRoomsButton: a,
  closeRoomsText: o,
  editRoomsText: r,
  breakoutRoomsNames: i,
  myIdentity: s,
  amIControlOnlyParticipant: c,
  headerText: l,
  onJoinRoom: d,
  onJoinRoomViaHelp: m,
  onCloseRoom: p,
  onCloseRooms: g,
  onClosePanel: f,
  onEditRooms: v
}) => {
  const E = ln(), {
    openBreakoutCloseAllRoomsConfirmationModal: C,
    breakoutCloseAllRoomsConfirmationModal: B
  } = ls({ onCloseRooms: g });
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
    Dt,
    {
      isRounded: E,
      padding: "none",
      footerPadding: "small",
      headerContent: /* @__PURE__ */ n.createElement(
        Et,
        {
          title: l,
          onCloseClick: f
        }
      ),
      footerContent: a ? /* @__PURE__ */ n.createElement(
        D,
        {
          onClick: C,
          modifier: "fullWidth",
          variant: "danger",
          "data-testid": u.CloseBreakoutRooms
        },
        o
      ) : void 0,
      scrollElementClassname: "pt-2 pr-3 pb-3 pl-3"
    },
    /* @__PURE__ */ n.createElement(
      D,
      {
        className: Nf.editButton,
        modifier: "fullWidth",
        enhancerStart: /* @__PURE__ */ n.createElement(F, { size: "compact", source: k.IconEdit }),
        onClick: v,
        variant: "tertiary",
        "data-testid": u.ButtonBreakoutRoomEdit
      },
      r
    ),
    /* @__PURE__ */ n.createElement(
      Sf,
      {
        breakoutsAskingForHelp: e,
        onJoinRoom: m
      }
    ),
    Array.from(t.entries()).map(
      ([w, M]) => /* @__PURE__ */ n.createElement(
        pn,
        {
          key: w,
          name: i.get(w) ?? w,
          id: w,
          participants: M,
          myIdentity: s,
          amIControlOnlyParticipant: c,
          variant: fe.Preview,
          onJoinRoom: d,
          onCloseRoom: p
        }
      )
    )
  ), B);
}, uC = ({ isOpen: e, onConfirm: t, onCancel: a }) => {
  const { t: o } = y();
  return /* @__PURE__ */ n.createElement(
    Qe,
    {
      isOpen: e,
      title: o(
        "breakouts.go-back-to-mode-assignment-title",
        "Discard rooms?"
      ),
      uniqueTitle: o(
        "breakouts.go-back-to-mode-assignment-title",
        "Discard rooms?"
      ),
      "data-testid": u.ModalBreakoutRoomsGoBackToModeAssignment,
      description: o(
        "breakouts.go-back-to-mode-assignment-description",
        "You will lose the rooms you created."
      ),
      confirmButtonText: o("common.ok", "Ok"),
      confirmButtonTestid: u.ButtonBreakoutRoomsConfirmGoBackToModeAssignment,
      cancelButtonText: o("common.cancel", "Cancel"),
      cancelButtonTestid: u.ButtonBreakoutRoomsCancelGoBackToModeAssignment,
      onConfirm: t,
      onCancel: a
    }
  );
}, pC = ({ isOpen: e, onConfirm: t, onCancel: a }) => {
  const { t: o } = y();
  return /* @__PURE__ */ n.createElement(
    Qe,
    {
      isOpen: e,
      title: o(
        "breakouts.go-back-to-opened-rooms-title",
        "Discard changes?"
      ),
      uniqueTitle: o(
        "breakouts.go-back-to-opened-rooms-title",
        "Discard changes?"
      ),
      "data-testid": u.ModalBreakoutRoomsGoBackToOpenedRooms,
      description: o(
        "breakouts.go-back-to-opened-rooms-description",
        "You will lose the changes you made to the rooms."
      ),
      confirmButtonText: o("common.ok", "Ok"),
      confirmButtonTestid: u.ButtonBreakoutRoomsConfirmGoBackToOpenedRooms,
      cancelButtonText: o("common.cancel", "Cancel"),
      cancelButtonTestid: u.ButtonBreakoutRoomsCancelGoBackToOpenedRooms,
      onConfirm: t,
      onCancel: a
    }
  );
}, Tf = "_amountOfRooms_10ig1_4", Rf = {
  amountOfRooms: Tf
}, hC = ({
  headerText: e,
  nextButtonText: t,
  initialAssignmentMode: a,
  assignmentModeLabel: o,
  assignmentModeAutomaticallyLabel: r,
  assignmentModeAutomaticallyDescription: i,
  assignmentModeManuallyLabel: s,
  assignmentModeManuallyDescription: c,
  amountOfRoomsLabel: l,
  increaseAmountOfRoomsLabel: d,
  decreaseAmountOfRoomsLabel: m,
  initialAmountOfRooms: p = 5,
  minAmountOfRooms: g = 1,
  maxAmountOfRooms: f = 50,
  onNextClick: v,
  onClosePanel: E
}) => {
  const C = ln(), [B, w] = x(a), [M, P] = x(p);
  return /* @__PURE__ */ n.createElement(
    Dt,
    {
      isRounded: C,
      headerPadding: "none",
      headerContent: /* @__PURE__ */ n.createElement(Et, { title: e, onCloseClick: E }),
      footerContent: /* @__PURE__ */ n.createElement(
        D,
        {
          modifier: "fullWidth",
          onClick: () => {
            v({
              amountOfRooms: M,
              assignmentMode: B
            });
          },
          "data-testid": u.GoToBreakoutSetupPanel
        },
        t
      )
    },
    /* @__PURE__ */ n.createElement("div", { className: b(Rf.amountOfRooms, "mb-7") }, /* @__PURE__ */ n.createElement(no, { className: "mb-0", text: l }), /* @__PURE__ */ n.createElement(
      Mn,
      {
        value: M,
        name: "roomsInput",
        label: l,
        ariaLabelDecrement: m,
        ariaLabelIncrement: d,
        minValue: g,
        maxValue: f,
        onChange: P,
        testIDInput: u.BreakoutNumberOfRoomsInput,
        testIDIncrement: u.ButtonBreakoutRoomsNumberOfRoomIncrement,
        testIDDecrement: u.ButtonBreakoutRoomsNumberOfRoomDecrement
      }
    )),
    /* @__PURE__ */ n.createElement(no, { className: "mb-7", text: o }),
    /* @__PURE__ */ n.createElement("div", { className: "mb-5" }, /* @__PURE__ */ n.createElement(
      oo,
      {
        groupName: "mode",
        checked: B === We.Automatically,
        label: r,
        value: We.Automatically,
        onValueChange: (T) => T && w(
          We.Automatically
        ),
        "data-testid": u.BreakoutAssignAutoBtn
      }
    ), /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.Body,
        htmlTag: "p",
        className: "pl-5 pt-1"
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
      oo,
      {
        groupName: "mode",
        checked: B === We.Manually,
        label: s,
        value: We.Manually,
        onValueChange: (T) => T && w(We.Manually),
        "data-testid": u.BreakoutAssignManuallyBtn
      }
    ), /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.Body,
        htmlTag: "p",
        className: "pl-5 pt-1"
      },
      c
    ))
  );
}, zf = "_modalWrapper_1fz0k_4", Wf = "_modalSectionWrapper_1fz0k_9", Lf = "_timerTextWrapper_1fz0k_14", Ff = "_timerText_1fz0k_14", Qf = "_line_1fz0k_24", Oe = {
  modalWrapper: zf,
  modalSectionWrapper: Wf,
  timerTextWrapper: Lf,
  timerText: Ff,
  line: Qf
}, gC = ({ className: e, isOpen: t, onSave: a, onCancel: o, timerValues: r, ...i }) => {
  const { t: s } = y(), [c, l] = x(r.defaultHours), [d, m] = x(r.defaultMinutes), [p, g] = x(!1), f = (C) => {
    C < r.maxHours && l(C);
  }, v = (C) => {
    C > r.maxMinutes && c < r.maxHours ? (f(c + 1), m(0)) : m(C);
  }, E = /* @__PURE__ */ n.createElement(be, null, /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(
    D,
    {
      onClick: o,
      variant: "secondary",
      modifier: "fullWidth",
      "data-testid": u.CancelBreakoutSettings
    },
    s("common.cancel", "Cancel")
  )), /* @__PURE__ */ n.createElement(K, { xs: 6 }, /* @__PURE__ */ n.createElement(
    D,
    {
      type: "submit",
      onClick: () => a(c, d, p),
      variant: "primary",
      modifier: "fullWidth",
      "data-testid": u.SaveBreakoutSettings
    },
    s("common.save", "Save")
  )));
  return /* @__PURE__ */ n.createElement(Pe, { colorScheme: "light" }, /* @__PURE__ */ n.createElement(
    at,
    {
      isOpen: t,
      withCloseButton: !0,
      onClose: o,
      closeButtonAriaLabel: s(
        "breakouts.room-settings-modal.close-btn",
        "Close room settings modal"
      ),
      closeOnOutsideClick: !1,
      className: b(e, Oe.modalWrapper),
      "data-testid": u.ModalRoomSettings,
      padding: "large",
      footerContent: E,
      footerPadding: "small",
      hasFooterShadow: !0,
      uniqueTitle: s(
        "breakouts.room-settings-modal.title",
        "Room settings"
      ),
      ...i
    },
    /* @__PURE__ */ n.createElement(
      Ie,
      {
        fontVariant: S.H5,
        htmlTag: "h3",
        className: "mt-2 mb-4"
      },
      s("breakouts.room-settings-modal.title", "Room settings")
    ),
    /* @__PURE__ */ n.createElement("div", { className: b(Oe.modalSectionWrapper, "mx-2") }, /* @__PURE__ */ n.createElement(Ne, { spacing: "compact", className: "mb-2" }, /* @__PURE__ */ n.createElement(F, { source: k.IconClock }), /* @__PURE__ */ n.createElement(N, { fontVariant: S.BodyBold, htmlTag: "span" }, s(
      "breakouts.room-settings-modal.set-timer",
      "Do you want to set a timer?"
    ))), /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.Body,
        htmlTag: "p",
        color: Me.Neutral70,
        className: "mb-6"
      },
      s(
        "breakouts.room-settings-modal.set-timer-description",
        "When the time is up participants will be moved to join the main room"
      )
    ), /* @__PURE__ */ n.createElement(be, { className: "mb-1" }, /* @__PURE__ */ n.createElement(K, { xs: 3, className: Oe.timerTextWrapper }, /* @__PURE__ */ n.createElement(
      N,
      {
        className: Oe.timerText,
        fontVariant: S.BodyBold,
        htmlTag: "p"
      },
      s(
        "breakouts.room-settings-modal.set-timer-hours",
        "Hours"
      )
    )), /* @__PURE__ */ n.createElement(K, { xs: 9 }, /* @__PURE__ */ n.createElement(
      Mn,
      {
        colorScheme: "light",
        label: s(
          "breakouts.room-settings-modal.hours-label",
          "Hours"
        ),
        ariaLabelDecrement: s(
          "breakouts.room-settings-modal.decrease-hours-aria-label",
          "Decrease hours"
        ),
        ariaLabelIncrement: s(
          "breakouts.room-settings-modal.increase-hours-aria-label",
          "Increase hours"
        ),
        name: "hoursInput",
        value: c,
        onChange: f,
        testIDInput: u.RoomSettingsHoursInput,
        testIDDecrement: u.ButtonRoomSettingsHoursInputDecrement,
        testIDIncrement: u.ButtonRoomSettingsHoursInputIncrement
      }
    ))), /* @__PURE__ */ n.createElement(be, null, /* @__PURE__ */ n.createElement(K, { xs: 3, className: Oe.timerTextWrapper }, /* @__PURE__ */ n.createElement(
      N,
      {
        className: Oe.timerText,
        fontVariant: S.BodyBold,
        htmlTag: "p"
      },
      s(
        "breakouts.room-settings-modal.set-timer-minutes",
        "Minutes"
      )
    )), /* @__PURE__ */ n.createElement(K, { xs: 9 }, /* @__PURE__ */ n.createElement(
      Mn,
      {
        colorScheme: "light",
        label: s(
          "breakouts.room-settings-modal.minutes-label",
          "Minutes"
        ),
        ariaLabelDecrement: s(
          "breakouts.room-settings-modal.decrease-minutes-aria-label",
          "Decrease minutes"
        ),
        ariaLabelIncrement: s(
          "breakouts.room-settings-modal.increase-minutes-aria-label",
          "Increase minutes"
        ),
        name: "minutesInput",
        value: d,
        onChange: v,
        stepValue: r.minuteStepValue,
        testIDInput: u.RoomSettingsMinutesInput,
        testIDDecrement: u.ButtonRoomSettingsMinutesInputDecrement,
        testIDIncrement: u.ButtonRoomSettingsMinutesInputIncrement
      }
    )))),
    /* @__PURE__ */ n.createElement("div", { className: b(Oe.line, "my-6") }),
    /* @__PURE__ */ n.createElement("div", { className: b(Oe.modalSectionWrapper, "mx-2") }, /* @__PURE__ */ n.createElement(Ne, { spacing: "compact", className: "mb-6" }, /* @__PURE__ */ n.createElement(F, { source: k.IconLeave }), /* @__PURE__ */ n.createElement(N, { fontVariant: S.BodyBold, htmlTag: "span" }, s(
      "breakouts.room-settings-modal.leave-room-options",
      "Options for leaving the rooms"
    ))), /* @__PURE__ */ n.createElement(
      $r,
      {
        checked: p,
        label: s(
          "breakouts.room-settings-modal.leave-room-checkbox",
          "Allow participants to leave at any time"
        ),
        name: "Participants can leave at any time checkbox",
        onChange: () => g(!p),
        className: "mb-2"
      }
    ), /* @__PURE__ */ n.createElement(
      N,
      {
        fontVariant: S.Body,
        htmlTag: "p",
        className: "mb-4"
      },
      s(
        "breakouts.room-settings-modal.leave-room-options-description",
        "By default, participants cannot leave a breakout room while it is open. When this is selected, participants can return to the main room at any time."
      )
    ))
  ));
}, Af = "_footer_hi8l7_4", Vf = {
  footer: Af
}, fC = ({
  currentParticipants: e,
  myIdentity: t,
  breakoutRoomsNames: a,
  saveButtonText: o,
  cancelButtonText: r,
  headerText: i,
  onSave: s,
  onCancel: c,
  onClosePanel: l,
  onSettingsButtonClick: d
}) => {
  const m = ln(), p = ee(null), {
    participants: g,
    breakoutRoomsNames: f,
    isDragging: v,
    isShuffling: E,
    onAddRoom: C,
    doSave: B,
    doShuffle: w,
    currentDragTarget: M,
    handleBreakoutRoomNameChange: P,
    onParticipantDragging: T,
    onParticipantDrag: R,
    changeParticipantRoom: O,
    onRemoveRoom: G,
    getBreakoutRoomRefCallback: Y
  } = us({
    currentParticipants: e,
    breakoutRoomsNames: a,
    myIdentity: t,
    onSave: s
  });
  return /* @__PURE__ */ n.createElement(
    Dt,
    {
      scrollElementRef: p,
      overflowHidden: v,
      isRounded: m,
      padding: "none",
      footerPadding: "small",
      headerContent: /* @__PURE__ */ n.createElement(
        Et,
        {
          title: i,
          onCloseClick: l,
          closeButtonTestId: u.PanelHeaderCloseButton,
          endContent: /* @__PURE__ */ n.createElement(
            _a,
            {
              onAddRoomButtonClick: C,
              onSettingsButtonClick: d,
              onShuffledButtonClick: w,
              isShuffling: E
            }
          )
        }
      ),
      footerContent: /* @__PURE__ */ n.createElement("div", { className: Vf.footer }, /* @__PURE__ */ n.createElement(
        D,
        {
          variant: "secondary",
          modifier: "fullWidth",
          onClick: c
        },
        r
      ), /* @__PURE__ */ n.createElement(
        D,
        {
          modifier: "fullWidth",
          onClick: B,
          "data-testid": u.ButtonSaveBreakoutRoomsEdit
        },
        o
      )),
      scrollElementClassname: "pt-2 pr-3 pb-3 pl-3"
    },
    Array.from(g.entries()).map(
      ([J, _]) => /* @__PURE__ */ n.createElement(
        pn,
        {
          scrollElementRef: p,
          variant: fe.Edit,
          id: J,
          key: J,
          name: f.get(J) ?? J,
          rooms: Array.from(g.keys()).reduce(
            (U, H) => (J !== H && (U[H] = f.get(H) ?? H), U),
            {}
          ),
          myIdentity: t,
          participants: _,
          isDragTarget: M === J,
          onNameChanged: P,
          onParticipantDragging: T,
          onParticipantDrag: R,
          onParticipantRoomChange: O,
          onRemoveRoom: G,
          ref: Y(J),
          canEditRoomName: !f.get(J)
        }
      )
    )
  );
}, EC = ({ isOpen: e, onConfirm: t }) => {
  const { t: a } = y();
  return /* @__PURE__ */ n.createElement(
    Qe,
    {
      "data-testid": u.ModalOpenRoomsError,
      isOpen: e,
      onConfirm: t,
      confirmButtonText: a("common.ok", "Ok"),
      title: a(
        "breakouts.error-on-open-rooms-title",
        "Could not open rooms"
      ),
      uniqueTitle: a(
        "breakouts.error-on-open-rooms-title",
        "Could not open rooms"
      ),
      description: a(
        "breakouts.error-on-open-rooms-description",
        "An error occurred while trying to open the breakout rooms. Please try again."
      )
    }
  );
}, vC = ({ setStreamQuality: e, streamQuality: t }) => {
  const { t: a } = y();
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(N, { fontVariant: S.BodyBold }, /* @__PURE__ */ n.createElement(Z, { t: a, i18nKey: "quality.quality" }, "Connection quality")), /* @__PURE__ */ n.createElement(N, { fontVariant: S.Small, htmlTag: "p" }, /* @__PURE__ */ n.createElement(Z, { t: a, i18nKey: "quality.info" }, "This setting affects the amount of bandwidth you’ll use for this meeting. Adjust to a lower value if your internet connection is slow or if your computer’s performance is badly affected.")), /* @__PURE__ */ n.createElement(
    ra,
    {
      className: "mb-5 mt-4",
      "data-testid": u.ButtonQuality,
      iconType: k.IconBandwidth,
      isFullWidth: !0,
      label: a("quality.select-quality", "Select meeting quality"),
      labelModifier: "hidden",
      options: [
        {
          id: we.Low,
          label: a("quality.low", "Low")
        },
        {
          id: we.Medium,
          label: a("quality.medium", "Medium")
        },
        {
          id: we.High,
          label: a("quality.high", "High")
        },
        {
          id: we.VeryHigh,
          label: a("quality.very-high", "Very High")
        },
        {
          id: we.Auto,
          label: a("quality.auto", "Auto")
        }
      ],
      onValueChange: (o) => {
        e(o);
      },
      sizeModifier: "small",
      value: t
    }
  ));
}, Of = "_unreadIndicator_1cdjn_1", Ho = {
  unreadIndicator: Of
}, CC = ({
  allowChatTypeActiveTabClick: e,
  selectedChatType: t,
  unreadChatMessages: a,
  unseenUnreadDirectChatMessages: o,
  onChatTypeChange: r
}) => {
  const { t: i } = y(), s = nn();
  return /* @__PURE__ */ n.createElement(
    ei,
    {
      allowActiveTabToBeClicked: e,
      sizeModifier: s ? "large" : "medium",
      selectedTabID: t,
      onTabChange: (c) => r(c),
      tabs: [
        {
          id: Pn.Everyone,
          name: i("meeting.chat-with-everyone", "Everyone"),
          textEndContent: a.length > 0 ? /* @__PURE__ */ n.createElement(
            zn,
            {
              testId: u.ChatUnreadEveryoneMessagesIndicator,
              className: Ho.unreadIndicator
            }
          ) : void 0,
          testId: u.ButtonChatEveryoneTab
        },
        {
          id: Pn.Direct,
          name: i("meeting.chat-with-individual", "Direct"),
          textEndContent: o.length > 0 ? /* @__PURE__ */ n.createElement(
            zn,
            {
              testId: u.ChatUnseenDirectMessagesIndicator,
              className: Ho.unreadIndicator
            }
          ) : void 0,
          testId: u.ButtonChatDirectTab
        }
      ]
    }
  );
}, Df = "_container_r6k04_4", jf = "_row_r6k04_11", Zo = {
  container: Df,
  row: jf
}, bC = ({ className: e, participant: t, onMessageClick: a }) => {
  const { t: o } = y();
  return /* @__PURE__ */ n.createElement("div", { className: b(Zo.container, e) }, /* @__PURE__ */ n.createElement("div", { className: Zo.row }, /* @__PURE__ */ n.createElement(
    on,
    {
      colorScheme: "dark",
      displayName: t.displayName,
      sizeModifier: "small",
      type: Vt.Initials,
      className: "mr-2"
    }
  ), /* @__PURE__ */ n.createElement(N, { fontVariant: S.BodyBold, isTruncated: !0 }, t.displayName)), /* @__PURE__ */ n.createElement(
    D,
    {
      "data-testid": u.ButtonChatNewDirectMessage,
      onClick: () => a(t),
      size: "compact",
      variant: "tertiary"
    },
    o("meeting.chat-message-participant", "Message")
  ));
}, yC = ({
  participantInDirectChatWith: e,
  latestMessage: t,
  hasUnreadMessages: a,
  handleGoToDirectChat: o
}) => /* @__PURE__ */ n.createElement(
  rn,
  {
    "data-testid": u.ButtonChatDirectMessagePreview,
    tabIndex: 0,
    htmlTag: "div",
    onClick: o,
    onKeyDown: (r) => {
      r.key === ht.enter && o();
    }
  },
  /* @__PURE__ */ n.createElement(
    Ha,
    {
      isUnread: a,
      useHoverStyle: !0,
      withAvatar: !0,
      isTruncated: !0,
      message: {
        ...t,
        displayName: e.displayName ?? ""
      }
    },
    /* @__PURE__ */ n.createElement(Yn, { text: t.message })
  )
);
export {
  Fi as AUDIO_MP4,
  ro as AUDIO_OGG_OPUS,
  Li as AUDIO_WEBM_OPUS,
  $c as AVQualityStats,
  Xv as AddParticipantButton,
  Kn as AspectRatioSelfview,
  cv as AudioMeter,
  fv as AudioMeterButton,
  Qc as AudioMeterView,
  Sv as AudioOutputTestButton,
  bt as BROWSER_NAME,
  Jl as BackgroundBlurInputControl,
  Ut as BlockedBrowserPermissionsInfoType,
  fC as BreakoutEditPanel,
  wh as BreakoutParticipantRow,
  mC as BreakoutPreviewPanel,
  pn as BreakoutRoom,
  We as BreakoutRoomAssignmentMode,
  df as BreakoutRoomHeader,
  fe as BreakoutRoomVariant,
  If as BreakoutRoomsAskingForHelpRoomRow,
  uC as BreakoutRoomsGoBackToModeAssignmentModal,
  pC as BreakoutRoomsGoBackToOpenedRoomsModal,
  hC as BreakoutRoomsModeAssignment,
  dv as BreakoutRoomsNameAndTimeLeft,
  sl as BreakoutRoomsNameAndTimeLeftView,
  sC as BreakoutRoomsPanelToggleView,
  cC as BreakoutRoomsPanelWrapper,
  mi as BreakoutRoomsScreen,
  dC as BreakoutSetupPanel,
  ui as CHARACTER_LIMIT,
  zv as CallControlsDesktopView,
  Wv as CallControlsTouchView,
  Rn as CallQualityVisualizer,
  mp as ChatActivityMessage,
  yC as ChatDirectMessagePreview,
  Ha as ChatMessageView,
  bC as ChatNewDirectMessage,
  Fv as ChatPanelContentWrapper,
  Lv as ChatPanelInput,
  Lu as ChatPanelInputButtons,
  Wu as ChatPanelInputSendButton,
  up as ChatPanelMessages,
  Vv as ChatPanelToggleView,
  Qv as ChatPanelView,
  Pn as ChatType,
  CC as ChatTypeSwitcher,
  gi as DEFAULT_CHAT_INPUT_HEIGHT,
  io as DEVICE_TYPE,
  Cv as DesktopMeetingToolbar,
  _n as DeviceDeniedTooltip,
  mt as DeviceSelect,
  Mm as DevicesList,
  Iv as DevicesSelection,
  bv as DraggableFoldableInMeetingSelfview,
  yv as DraggableInMeetingSelfview,
  za as DraggableMeetingVideo,
  $s as EASE_DURATION,
  yc as ExternalVideo,
  Ev as FeccButtonView,
  Ud as FoldedSelfview,
  vv as Footer,
  Wh as FrequencyBar,
  Lh as FrequencyBars,
  Gv as FrequencyBarsAudioMeter,
  Yi as GROUP_ACTIVITIES_TIME_WINDOW,
  Av as Header,
  ao as INITIAL_STREAM_QUALITY,
  $i as I_PAD,
  mn as InMeetingDraggable,
  Ae as InMeetingInputControl,
  ma as InMeetingUIElements,
  $g as InfoCard,
  Xa as InfoCardType,
  Wt as InfoCardWidth,
  Zv as InputControlToggleView,
  bg as InvitationModal,
  eC as InvitationModalWithTransform,
  hg as InvitationSearchInput,
  _v as InviteeResults,
  $v as InviteeSearch,
  kv as JoinCallDetails,
  Mv as JoinCallDetailsMobile,
  pm as JoinCallDetailsWrapper,
  Fa as JoinDetailsText,
  Bv as JoinDetailsTextWrapper,
  wv as JoinMeetingButton,
  xv as JoinMeetingButtonWithOptions,
  ht as KEYBOARD_EVENT_KEY,
  ru as LeaveButtonDesktop,
  iu as LeaveButtonTouch,
  tC as LinkCopy,
  fi as MESSAGES_BOTTOM_OFFSET,
  pi as MIN_VIEWPORT_HEIGHT,
  ua as MIN_VIEWPORT_WIDTH,
  pe as MainBreakoutRoomId,
  Kv as ManualInvite,
  qv as MeetingLayout,
  Yv as MeetingScrim,
  Tp as MeetingStageContainer,
  Xn as MeetingVideo,
  Tv as MeetingWrapper,
  Pv as MicrophoneMonitorModal,
  oc as MicrophoneMuteMessage,
  Ri as MimeTypes,
  Lo as MissingDeviceAlert,
  Pd as MoreMenu,
  lC as MoveToRoomModalView,
  Hn as MuteState,
  rC as NetworkAlert,
  ue as NetworkState,
  Nn as NewChatMessageAction,
  au as NewChatMessagePill,
  EC as OpenBreakoutRoomsErrorModal,
  $t as PanelAnimationTypes,
  Et as PanelHeader,
  jv as PanelHeaderWrapper,
  Dv as ParticipantRow,
  Kp as ParticipantRowActions,
  Ua as ParticipantRowWrapper,
  Ov as ParticipantSidePanelWrapper,
  oC as ParticipantsPanelFooter,
  Hv as ParticipantsPanelToggleView,
  qi as Platform,
  wc as PoppedOutEmptyPresentation,
  uv as PreflightContent,
  hv as PreflightContentMobile,
  Vl as PreflightControlsWrapper,
  Ul as PreflightInputControls,
  Ue as PreflightJoinDetailsToRender,
  pv as PreflightMediaControls,
  gv as PreflightSelfview,
  de as PresentationAction,
  ud as PresentationButton,
  De as PresentationEmphasis,
  Wc as PresentationMeetingVideo,
  Sn as PresentationSize,
  di as PresentationType,
  vC as QualityList,
  nt as QualityNames,
  ac as RESET_TIME,
  md as RaiseHandButton,
  iC as RemoveUserConfirmation,
  Rv as RequestAccess,
  Oa as ResponsiveButton,
  gC as RoomSettingsModalView,
  Us as STATE_RESET_TIMER,
  Ht as SYSTEM_NAME,
  pg as SearchRow,
  nC as SelfViewSettings,
  xl as Selfview,
  Jv as SettingsModalBody,
  Dh as SettingsPanel,
  lv as Stats,
  Jc as StatsModal,
  Uv as StealPresentationModal,
  we as StreamQuality,
  X as StreamStatus,
  u as TestId,
  Nv as TestYourMicLink,
  Va as TestYourMicStages,
  aC as ToastSpeakingWhileMuted,
  Sd as ToolbarAriaMenu,
  zn as UnreadIndicator,
  Ei as UserMediaContext,
  $ as VideoLayoutOptionValues,
  Qa as YouCanSayTitle,
  Mi as appendGroupedParticipants,
  gE as browserVersion,
  Qs as buildErrorMessages,
  Ii as buildGroupedActivityMessage,
  PE as calculateDisplayMode,
  Ti as calculateHowManyUnreadMessages,
  Si as calculateNewChatMessageAction,
  Wi as copyTextToClipboard,
  iE as copyToClipboardItem,
  es as createChangeOfMediaDevicesSubscription,
  En as createChangeOfTrackSubscription,
  VE as createInMeetingUIHook,
  mE as createInMemoryMediaSourceStore,
  RE as createMediaActiveSubscription,
  dE as createMediaRecorder,
  qE as createPreviewAudioInputHook,
  XE as createPreviewAudioOutputHook,
  KE as createPreviewControllerHook,
  JE as createPreviewHook,
  ev as createPreviewVideoInputHook,
  tv as createPushToTalkHook,
  nv as createPushToTalkMuteToastHook,
  sv as createUserMediaHooks,
  rv as createVADHook,
  fE as currentBrowserName,
  ct as desktopToolbarWidth,
  fa as detectBrowser,
  ke as execRegex,
  IE as exitPiP,
  Yt as extractVersion,
  jE as generateMediaSignalHooks,
  lE as getAudioMimeType,
  ts as getAudioOutput,
  Ea as getBrowserName,
  vE as getClampLevelFn,
  Os as getDeviceErrorMessageSetter,
  Ji as getGroupActivityMessages,
  bE as getInitialStreamQuality,
  Ni as getIsLastNewMessageVisibleFn,
  Jn as getIsMicrosoftSurface,
  _t as getPlatform,
  ns as getPreferredAudioOutput,
  wa as getUserAgentDetails,
  ss as initMeetingUIState,
  nc as initPushToTalkUI,
  ks as initialNewUnreadMessageState,
  Te as interfacesMargin,
  Zi as isActivityInTimeRange,
  ji as isBrowserSupported,
  Vi as isChromiumWebRTC,
  xE as isCompatibleMobileDevice,
  zs as isControlsOverlapTruthy,
  uE as isCurrentBrowserSupported,
  hE as isFirefox,
  Ai as isFirefoxWebRTC,
  Pi as isLastMessageByCurrentUser,
  BE as isMediaLocked,
  yE as isMediaMuted,
  kE as isMicrosoftSurface,
  gt as isMobileDevice,
  Ta as isOverlappingSidePanel,
  Ki as isPhone,
  ba as isPortrait,
  Oi as isSafariWebRTC,
  Hi as isSameActivityType,
  pE as isScreenShareSupported,
  ya as isSmallScreen,
  en as isSpaceKeyboard,
  wE as isTablet,
  Gn as isTouchScreen,
  cl as isVideoActive,
  ll as isVideoMuted,
  Qi as isWebRTCBrowser,
  xs as newChatMessageReducer,
  Ba as onDeviceSelectChange,
  ME as platform,
  Xs as presentationReducer,
  SE as qualityToMediaConstraints,
  EE as randomNumber,
  sE as readTextFromClipboard,
  ga as scrollToLastMessage,
  nE as selfviewAspectRatioValues,
  lo as setDisplayNewMessageToast,
  Ms as setIsLastMessageVisible,
  CE as setLogger,
  Gi as shouldAppendActivityMessage,
  rE as shouldEmitNewMessage,
  NE as shouldResizeWindow,
  mv as shouldShowErrorBorder,
  Un as shuffleBreakoutParticipants,
  Ze as sidePanelPlusDesktopToolbarWidth,
  hi as sidePanelWidth,
  cE as statefulCopyLinkToClipboard,
  Kt as stopMouseEventPropagation,
  Di as supportUnifiedPlan,
  TE as toTime,
  zE as togglePanel,
  mo as updateLastNewMessageVisible,
  Is as updateNewMessagesCount,
  Ci as useAnalyzer,
  bi as useAssertedContext,
  oE as useAudioDetection,
  xi as useAudioMeter,
  aE as useBatteryStatus,
  ha as useBreakoutAddRoom,
  cs as useBreakoutAssignParticipantsByMode,
  xa as useBreakoutChangeParticipantRoom,
  ls as useBreakoutCloseAllRoomsConfirmationModal,
  us as useBreakoutEdit,
  Ma as useBreakoutParticipantDrag,
  Ia as useBreakoutRemoveRoom,
  Sa as useBreakoutRoomNameChange,
  Pa as useBreakoutShuffleParticipants,
  ps as useBreakoutUpdateParticipants,
  WE as useBuildTranslatedActivityChatMessages,
  LE as useCallQuality,
  FE as useCallQualityToast,
  QE as useChat,
  Ws as useControlsRelativePosition,
  Ds as useDeviceErrorMessage,
  Ls as useDeviceErrorMessageState,
  qn as useDeviceStatusInfo,
  AE as useFallbackDeviceNotifier,
  Ag as useInfoCardOrientation,
  Vg as useInfoCardWidth,
  cc as useInputSuspendedInfo,
  Gs as useInputsState,
  OE as useMedia,
  DE as useMediaInputs,
  YE as useMeetingStageLayout,
  HE as useNetworkState,
  ws as useNewChatMessageReducer,
  ZE as usePreflightJoinDetailsToRender,
  GE as usePresentation,
  qs as usePresentationPoppedOut,
  UE as usePreviewAnalyzer,
  _E as usePreviewControllerHandler,
  $E as usePreviewErrorHandling,
  ov as useRemoveParticipant,
  av as useResetCopyMeetingLink,
  iv as useSelectDeviceChangeHandler,
  Na as useSelectedInput,
  rc as useSidePanelTransform,
  Fs as useSubscribeToInputError,
  re as useUserMediaContext,
  sc as useWindowOrientation
};
